angular.module("ainapp")
    .service('MainService', ['$q', '$window', "$http", "app.config",
        function ($q, $window, $http, config) {

            //////////////////. Company Profile .//////////////////

            this.TicketStatusList = function (data) {
                return $http.post("https://api-management.magtec.ae/StatusList", data);
            };
            this.AddTicket = function (data) {
                return $http.post("https://api-management.magtec.ae/AddTicket", data);
            };
            this.CustomerTicketList = function (data) {
                return $http.post("https://api-management.magtec.ae/CustomerTicketList", data);
            };
            this.TicketsInView = function (data) {
                return $http.post("https://api-management.magtec.ae/TicketsInView", data);
            };
            this.getTicketCategories = function () {
                return $http.get("https://api-management.magtec.ae/SupportCategoryList");
            };
            this.getTicketbyId = function (id) {
                return $http.get("https://api-management.magtec.ae/getTicketbyId/" + id);
            };

            this.SaveCompanyProfile = function (data) {
                return $http.post(config.basePath + "SaveCompanyProfile", data);
            };
            this.AddJVInvoiceExcelIN = function (data) {
                return $http.post(config.basePath + "AddJVInvoiceExcelIN", data);
            };
            this.AddJVInvoiceExcelOUT = function (data) {
                return $http.post(config.basePath + "AddJVInvoiceExcelOUT", data);
            };
            this.ClearTempData = function () {
                return $http.get(config.basePath + "ClearTempData");
            };
            this.GetHomeData = function () {
                return $http.get(config.basePath + "GetHomeData");
            };
            this.SendDocumentExpiryMail = function () {
                return $http.get(config.basePath + "SendDocumentExpiryMail");
            };
            this.SendBirthdayMail = function () {
                return $http.get(config.basePath + "SendBirthdayMail");
            };
            this.GetAllReportFiles = function () {
                return $http.get(config.basePath + "GetAllReportFiles");
            };
            this.GetAllVoucherReportFiles = function () {
                return $http.get(config.basePath + "GetAllVoucherReportFiles");
            };
            this.SendLoginOTP = function () {
                return $http.get(config.basePath + "SendLoginOTP");
            };
            this.checkLoginOTP = function (id) {
                return $http.get(config.basePath + "checkLoginOTP/" + id);
            };
            this.VoucherSettingsbyType = function (id) {
                return $http.get(config.basePath + "VoucherSettingsbyType/" + id);
            };
            this.UpdateBranchUserSession = function (data) {
                return $http.post(config.basePath + "UpdateBranchUserSession", data);
            };
            this.PrintInvoice = function (data) {
                return $http.post(config.basePath + "PrintInvoice", data);
            };
            this.UploadVoucherPrintFile = function () {
                return $http.post(config.basePath + "UploadVoucherPrintFile");
            };
            this.UploadVoucherPrintFileReport = function () {
                return $http.post(config.basePath + "UploadVoucherPrintFileReport");
            };
            this.GetCompanyProfile = function () {
                return $http.get(config.basePath + "GetCompanyProfile");
            };
            this.GetMonthlySales = function () {
                return $http.post(config.basePath + "GetMonthlySales");
            };
            this.GetCurrentMonthExpense = function () {
                return $http.post(config.basePath + "GetCurrentMonthExpense");
            };
            this.CostCenterSummary = function () {
                return $http.post(config.basePath + "CostCenterSummary");
            };
            this.PurchaseReturnChart = function () {
                return $http.post(config.basePath + "PurchaseReturnChart");
            };
            this.SalesReturnChart = function () {
                return $http.post(config.basePath + "SalesReturnChart");
            };
            this.BalanceAccountChart = function () {
                return $http.post(config.basePath + "BalanceAccountChart");
            };
            this.StockEndingProducts = function () {
                return $http.post(config.basePath + "StockEndingProducts");
            };
            this.TopSellingItems = function () {
                return $http.post(config.basePath + "TopSellingItems");
            };
            this.AuditPendingSalesVouchers = function () {
                return $http.post(config.basePath + "AuditPendingSalesVouchers");
            };
            this.AuditPendingPurchaseVouchers = function () {
                return $http.post(config.basePath + "AuditPendingPurchaseVouchers");
            };
            this.GetResaveVoucherList = function () {
                return $http.get(config.basePath + "GetResaveVoucherList");
            };
            this.ChangePassword = function (data) {
                return $http.post(config.basePath + "ChangePassword", data);
            };
            this.SendEmailSupport = function (data) {
                return $http.post(config.basePath + "SendEmailSupport", data);
            };
            this.SendEnquiry = function (data) {
                return $http.post(config.basePath + "SendEnquiry", data);
            };
            this.SaveAuditDone = function (id, type) {
                return $http.get(config.basePath + "SaveAuditDone/" + id + "/" + type);
            };
            this.getConvertedCost = function (proId, unitId) {
                return $http.get(config.basePath + "getConvertedCost/" + proId + "/" + unitId);
            };
            this.GetVoucherDetailsInGL = function (id) {
                return $http.get(config.basePath + "GetVoucherDetailsInGL/" + id);
            };

            //////////////////.Acc Types..//////////////////

            this.AddAccountType = function (data) {
                return $http.post(config.basePath + "AddAccountType", data);
            };
            this.AccountTypeSubList = function (id) {
                return $http.get(config.basePath + "AccountTypeSubList/" + id);
            };
            this.UpdateAccountType = function (data) {
                return $http.post(config.basePath + "UpdateAccountType", data);
            };
            this.AccountTypeParentList = function () {
                return $http.get(config.basePath + "AccountTypeParentList");
            };
            this.AccountTypeAllChilds = function () {
                return $http.get(config.basePath + "AccountTypeAllChilds");
            };
            this.DeleteAccountType = function (id) {
                return $http.get(config.basePath + "DeleteAccountType/" + id);
            };
            this.SimilarAccountTypes = function (id) {
                return $http.get(config.basePath + "SimilarAccountTypes/" + id);
            };

            ///////////////////.. Account Master .. ////////////////////////

            this.AccountList = function () {
                return $http.get(config.basePath + "AccountList");
            };
            this.SaveAccounts = function (data) {
                return $http.post(config.basePath + "SaveAccounts", data);
            };
            this.UpdateAccount = function (data) {
                return $http.post(config.basePath + "UpdateAccount", data);
            };
            this.accountInAutoComplete = function (data) {
                return $http.post(config.basePath + "accountInAutoComplete", data);
            };
            this.SuppliersInAutoComplete = function (data) {
                return $http.post(config.basePath + "SuppliersInAutoComplete", data);
            };
            this.accountGroupsInAutoComplete = function (data) {
                return $http.post(config.basePath + "accountGroupsInAutoComplete", data);
            };
            this.CustomerInAutoComplete = function (data) {
                return $http.post(config.basePath + "CustomerInAutoComplete", data);
            };
            this.AccountsInPDCAutoComplete = function (data) {
                return $http.post(config.basePath + "AccountsInPDCAutoComplete", data);
            };

            this.GetCashAccounts = function (data) {
                return $http.post(config.basePath + "GetCashAccounts", data);
            };
            this.GetCashPettyCRDCashAccounts = function (data) {
                return $http.post(config.basePath + "GetCashPettyCRDCashAccounts", data);
            };
            this.GetBankAccounts = function (data) {
                return $http.post(config.basePath + "GetBankAccounts", data);
            };
            this.GetPDCReceivableAccounts = function (data) {
                return $http.post(config.basePath + "GetPDCReceivableAccounts", data);
            };
            this.GetPDCPayableAccounts = function (data) {
                return $http.post(config.basePath + "GetPDCPayableAccounts", data);
            };
            this.AccountListByKeyword = function (data) {
                return $http.post(config.basePath + "AccountListByKeyword", data);
            };
            this.accountInAutoCompleteLevel3 = function (data) {
                return $http.post(config.basePath + "accountInAutoCompleteLevel3", data);
            };
            this.SaveAccountCustomer = function (data) {
                return $http.post(config.basePath + "SaveAccountCustomer", data);
            };
            this.SaveAccountVendor = function (data) {
                return $http.post(config.basePath + "SaveAccountVendor", data);
            };
            this.SaveAccountExpense = function (data) {
                return $http.post(config.basePath + "SaveAccountExpense", data);
            };
            this.AccountsInCustomerView = function (data) {
                return $http.post(config.basePath + "AccountsInCustomerView", data);
            };
            this.LoadAccountsInAutoComplete = function (data) {
                return $http.post(config.basePath + "LoadAccountsInAutoComplete", data);
            };
            this.LoadCustomerAccountsSPInAutoComplete = function (data) {
                return $http.post(config.basePath + "LoadCustomerAccountsSPInAutoComplete", data);
            };
            this.LoadOtherAccountsInSPAutoComplete = function (data) {
                return $http.post(config.basePath + "LoadOtherAccountsInSPAutoComplete", data);
            };
            this.AccountsInVendorView = function (data) {
                return $http.post(config.basePath + "AccountsInVendorView", data);
            };
            this.UpdateAccountGroup = function (data) {
                return $http.post(config.basePath + "UpdateAccountGroup", data);
            };
            this.AccountsInExpenseView = function (data) {
                return $http.post(config.basePath + "AccountsInExpenseView", data);
            };
            this.AccountSubList = function (id) {
                return $http.get(config.basePath + "AccountSubList/" + id);
            };
            this.GetAccountById = function (id) {
                return $http.get(config.basePath + "GetAccountById/" + id);
            };
            this.DeleteAccountMaster = function (id) {
                return $http.get(config.basePath + "DeleteAccountMaster/" + id);
            };
            this.DeleteBulkAccountMasters = function (data) {
                return $http.post(config.basePath + "DeleteBulkAccountMasters", data);
            };
            this.GetParentsByAccountType = function (id) {
                return $http.get(config.basePath + "GetParentsByAccountType/" + id);
            };
            this.getAccountByName = function (data) {
                return $http.post(config.basePath + "getAccountByName", data);
            };
            this.AccountTypesInDropdown = function () {
                return $http.get(config.basePath + "AccountTypesInDropdown");
            };
            this.AccountsInKendoTree = function () {
                return $http.get(config.basePath + "AccountsInKendoTree");
            };
            this.AccountsInDynKendoTree = function (data) {
                return $http.post(config.basePath + "AccountsInDynKendoTree", data);
            };
            this.GetDefaultCustomer = function () {
                return $http.get(config.basePath + "GetDefaultCustomer");
            };
            this.LessorInAutoComplete = function (data) {
                return $http.post(config.basePath + "LessorInAutoComplete", data);
            };
            this.TenantInAutoComplete = function (data) {
                return $http.post(config.basePath + "TenantInAutoComplete", data);
            };
            this.FieldAutoComplete = function (data) {
                return $http.post(config.basePath + "FieldAutoComplete", data);
            };
            this.AccGroupsInDropdown = function () {
                return $http.get(config.basePath + "AccGroupsInDropdown");
            };

            //////////////////.Country..//////////////////

            this.AddCountry = function (data) {
                return $http.post(config.basePath + "AddCountry", data);
            };
            this.CountryInView = function (data) {
                return $http.post(config.basePath + "CountryInView", data);
            };
            this.CountriesInDropdown = function () {
                return $http.get(config.basePath + "CountriesInDropdown");
            };

            this.DeleteCountry = function (id) {
                return $http.get(config.basePath + "DeleteCountry/" + id);
            };

            //////////////////.Print Settings..//////////////////

            this.AddPrintSetting = function (data) {
                return $http.post(config.basePath + "AddPrintSetting", data);
            };

            this.PrintSettingsbyType = function (id) {
                return $http.get(config.basePath + "PrintSettingsbyType/" + id);
            };

            this.PrintSettingsbyTypeAll = function (id) {
                return $http.get(config.basePath + "PrintSettingsbyTypeAll/" + id);
            };

            this.DeletePrintSetting = function (id) {
                return $http.get(config.basePath + "DeletePrintSetting/" + id);
            };

            //////////////////.Whatsapp Settings..//////////////////

            this.AddWhatsappSetting = function (data) {
                return $http.post(config.basePath + "AddWhatsappSetting", data);
            };

            this.WhatsappSettingsbyType = function (id) {
                return $http.get(config.basePath + "WhatsappSettingsbyType/" + id);
            };

            this.DeleteWhatsappSetting = function (id) {
                return $http.get(config.basePath + "DeleteWhatsappSetting/" + id);
            };

            //////////////////.SMS Settings..//////////////////

            this.AddSMSSetting = function (data) {
                return $http.post(config.basePath + "AddSMSSetting", data);
            };

            this.SMSSettingsbyType = function (id) {
                return $http.get(config.basePath + "SMSSettingsbyType/" + id);
            };

            this.DeleteSMSSetting = function (id) {
                return $http.get(config.basePath + "DeleteSMSSetting/" + id);
            };


            //////////////////.Cusian..//////////////////

            this.AddCusian = function (data) {
                return $http.post(config.basePath + "AddCusian", data);
            };
            this.CusianInView = function (data) {
                return $http.post(config.basePath + "CusianInView", data);
            };
            this.DeleteCusian = function (id) {
                return $http.get(config.basePath + "DeleteCusian/" + id);
            };
            this.CusiansInDropdown = function () {
                return $http.get(config.basePath + "CusiansInDropdown");
            };
            this.CusiansInSales = function () {
                return $http.get(config.basePath + "CusiansInSales");
            };




            //////////////////.ProductTypes..//////////////////

            this.AddProductType = function (data) {
                return $http.post(config.basePath + "AddProductType", data);
            };
            this.ProductTypeInView = function (data) {
                return $http.post(config.basePath + "ProductTypeInView", data);
            };
            this.DeleteProductType = function (id) {
                return $http.get(config.basePath + "DeleteProductType/" + id);
            };
            this.ProductTypesInDropdown = function () {
                return $http.get(config.basePath + "ProductTypesInDropdown");
            };

            //////////////////.Product Size..//////////////////

            this.AddProductSize = function (data) {
                return $http.post(config.basePath + "AddProductSize", data);
            };
            this.ProductSizeInView = function (data) {
                return $http.post(config.basePath + "ProductSizeInView", data);
            };
            this.DeleteProductSize = function (id) {
                return $http.get(config.basePath + "DeleteProductSize/" + id);
            };
            this.ProductSizesInDropdown = function () {
                return $http.get(config.basePath + "ProductSizesInDropdown");
            };

            //////////////////.Product Category..//////////////////

            this.AddProductParentCategory = function (data) {
                return $http.post(config.basePath + "AddProductParentCategory", data);
            };
            this.ProductParentCategoriesInView = function (data) {
                return $http.post(config.basePath + "ProductParentCategoriesInView", data);
            };
            this.DeleteProductParentCategory = function (id) {
                return $http.get(config.basePath + "DeleteProductParentCategory/" + id);
            };
            this.ProductParentCategoriesByType = function (id) {
                return $http.get(config.basePath + "ProductParentCategoriesByType/" + id);
            };
            this.ProductParentCategoriesInDropdown = function () {
                return $http.get(config.basePath + "ProductParentCategoriesInDropdown");
            };


            //////////////////.Product Color..//////////////////

            this.AddProductColor = function (data) {
                return $http.post(config.basePath + "AddProductColor", data);
            };
            this.ProductColorInView = function (data) {
                return $http.post(config.basePath + "ProductColorInView", data);
            };
            this.DeleteProductColor = function (id) {
                return $http.get(config.basePath + "DeleteProductColor/" + id);
            };
            this.ProductColorsInDropdown = function () {
                return $http.get(config.basePath + "ProductColorsInDropdown");
            };

            //////////////////.Designation..//////////////////

            this.AddDesignation = function (data) {
                return $http.post(config.basePath + "AddDesignation", data);
            };
            this.DesignationInView = function (data) {
                return $http.post(config.basePath + "DesignationInView", data);
            };
            this.DesignationsInDropdown = function () {
                return $http.get(config.basePath + "DesignationsInDropdown");
            };

            this.DeleteDesignation = function (id) {
                return $http.get(config.basePath + "DeleteDesignation/" + id);
            };


            //////////////////.Department..//////////////////

            this.AddDepartment = function (data) {
                return $http.post(config.basePath + "AddDepartment", data);
            };
            this.DepartmentInView = function (data) {
                return $http.post(config.basePath + "DepartmentInView", data);
            };
            this.DepartmentsInDropdown = function () {
                return $http.get(config.basePath + "DepartmentsInDropdown");
            };

            this.DeleteDepartment = function (id) {
                return $http.get(config.basePath + "DeleteDepartment/" + id);
            };




            //////////////////.CourtCategory..//////////////////

            this.AddCourtCategory = function (data) {
                return $http.post(config.basePath + "AddCourtCategory", data);
            };
            this.CourtCategoriesInView = function (data) {
                return $http.post(config.basePath + "CourtCategoriesInView", data);
            };
            this.CourtCategoriesInDropdown = function () {
                return $http.get(config.basePath + "CourtCategoriesInDropdown");
            };

            this.DeleteCourtCategory = function (id) {
                return $http.get(config.basePath + "DeleteCourtCategory/" + id);
            };


            //////////////////.Court..//////////////////

            this.AddCourt = function (data) {
                return $http.post(config.basePath + "AddCourt", data);
            };
            this.CourtsInView = function (data) {
                return $http.post(config.basePath + "CourtsInView", data);
            };
            this.CourtsInDropdown = function () {
                return $http.get(config.basePath + "CourtsInDropdown");
            };

            this.DeleteCourt = function (id) {
                return $http.get(config.basePath + "DeleteCourt/" + id);
            };

            //////////////////.CaseCategory..//////////////////

            this.AddCaseCategory = function (data) {
                return $http.post(config.basePath + "AddCaseCategory", data);
            };
            this.CaseCategoriesInView = function (data) {
                return $http.post(config.basePath + "CaseCategoriesInView", data);
            };
            this.CaseCategoriesInDropdown = function () {
                return $http.get(config.basePath + "CaseCategoriesInDropdown");
            };

            this.DeleteCaseCategory = function (id) {
                return $http.get(config.basePath + "DeleteCaseCategory/" + id);
            };

            //////////////////.CaseStage..//////////////////

            this.AddCaseStage = function (data) {
                return $http.post(config.basePath + "AddCaseStage", data);
            };
            this.CaseStagesInView = function (data) {
                return $http.post(config.basePath + "CaseStagesInView", data);
            };
            this.CaseStagesInDropdown = function () {
                return $http.get(config.basePath + "CaseStagesInDropdown");
            };

            this.DeleteCaseStage = function (id) {
                return $http.get(config.basePath + "DeleteCaseStage/" + id);
            };


            //////////////////.Case Visit..//////////////////

            this.AddCaseVisit = function (data) {
                return $http.post(config.basePath + "AddCaseVisit", data);
            };
            this.CaseVisitsInView = function (data) {
                return $http.post(config.basePath + "CaseVisitsInView", data);
            };
            this.CaseVisitsInDropdown = function () {
                return $http.get(config.basePath + "CaseVisitsInDropdown");
            };

            this.DeleteCaseVisit = function (id) {
                return $http.get(config.basePath + "DeleteCaseVisit/" + id);
            };



            //////////////////.Case Visit Type..//////////////////

            this.AddCaseVisitType = function (data) {
                return $http.post(config.basePath + "AddCaseVisitType", data);
            };
            this.CaseVisitTypesInView = function (data) {
                return $http.post(config.basePath + "CaseVisitTypesInView", data);
            };
            this.CaseVisitTypesInDropdown = function () {
                return $http.get(config.basePath + "CaseVisitTypesInDropdown");
            };

            this.DeleteCaseVisitType = function (id) {
                return $http.get(config.basePath + "DeleteCaseVisitType/" + id);
            };



            //////////////////.Case Hearing..//////////////////

            this.AddCaseHearing = function (data) {
                return $http.post(config.basePath + "AddCaseHearing", data);
            };
            this.CaseHearingsInView = function (data) {
                return $http.post(config.basePath + "CaseHearingsInView", data);
            };
            this.CaseHearingsInDropdown = function () {
                return $http.get(config.basePath + "CaseHearingsInDropdown");
            };

            this.DeleteCaseHearing = function (id) {
                return $http.get(config.basePath + "DeleteCaseHearing/" + id);
            };






            //////////////////.AppointmentType..//////////////////

            this.AddAppointmentType = function (data) {
                return $http.post(config.basePath + "AddAppointmentType", data);
            };
            this.AppointmentTypesInView = function (data) {
                return $http.post(config.basePath + "AppointmentTypesInView", data);
            };
            this.AppointmentTypesInDropdown = function () {
                return $http.get(config.basePath + "AppointmentTypesInDropdown");
            };

            this.DeleteAppointmentType = function (id) {
                return $http.get(config.basePath + "DeleteAppointmentType/" + id);
            };


            //////////////////.CaseTransaction..//////////////////

            this.AddCaseTransaction = function (data) {
                return $http.post(config.basePath + "AddCaseTransaction", data);
            };
            this.CaseTransactionsInView = function (data) {
                return $http.post(config.basePath + "CaseTransactionsInView", data);
            };
            this.CaseTransactionsInDropdown = function () {
                return $http.get(config.basePath + "CaseTransactionsInDropdown");
            };

            this.DeleteCaseTransaction = function (id) {
                return $http.get(config.basePath + "DeleteCaseTransaction/" + id);
            };

            //////////////////.AuthorizedPerson..//////////////////

            this.AddAuthorizedPerson = function (data) {
                return $http.post(config.basePath + "AddAuthorizedPerson", data);
            };
            this.AuthorizedPersonsInView = function (data) {
                return $http.post(config.basePath + "AuthorizedPersonsInView", data);
            };
            this.AuthorizedPersonsInDropdown = function () {
                return $http.get(config.basePath + "AuthorizedPersonsInDropdown");
            };

            this.DeleteAuthorizedPerson = function (id) {
                return $http.get(config.basePath + "DeleteAuthorizedPerson/" + id);
            };


            //////////////////.Case..//////////////////

            this.AddCase = function (data) {
                return $http.post(config.basePath + "AddCase", data);
            };
            this.CasesInView = function (data) {
                return $http.post(config.basePath + "CasesInView", data);
            };
            this.CaseInAutoComplete = function (data) {
                return $http.post(config.basePath + "CaseInAutoComplete", data);
            };
            this.CasesById = function (id) {
                return $http.get(config.basePath + "CasesById/" + id);
            };
            this.DeleteCase = function (id) {
                return $http.get(config.basePath + "DeleteCase/" + id);
            };

            //////////////////.Act..//////////////////

            this.AddAct = function (data) {
                return $http.post(config.basePath + "AddAct", data);
            };
            this.ActsInView = function (data) {
                return $http.post(config.basePath + "ActsInView", data);
            };
            this.ActsInDropdown = function () {
                return $http.get(config.basePath + "ActsInDropdown");
            };

            this.DeleteAct = function (id) {
                return $http.get(config.basePath + "DeleteAct/" + id);
            };


            //////////////////.Appointment..//////////////////

            this.AddAppointment = function (data) {
                return $http.post(config.basePath + "AddAppointment", data);
            };
            this.AppointmentsInView = function (data) {
                return $http.post(config.basePath + "AppointmentsInView", data);
            };
            this.AppointmentsInDropdown = function () {
                return $http.get(config.basePath + "AppointmentsInDropdown");
            };

            this.DeletAppointment = function (id) {
                return $http.get(config.basePath + "DeletAppointment/" + id);
            };



            //////////////////.AttachmentType..//////////////////

            this.AddAttachmentType = function (data) {
                return $http.post(config.basePath + "AddAttachmentType", data);
            };
            this.AttachmentTypeInView = function (data) {
                return $http.post(config.basePath + "AttachmentTypeInView", data);
            };

            this.DeleteAttachmentType = function (id) {
                return $http.get(config.basePath + "DeleteAttachmentType/" + id);
            };




            //////////////////.Employee Attachment.//////////////////

            this.AddEmployeeAttachment = function (data) {
                return $http.post(config.basePath + "AddEmployeeAttachment", data);
            };
            this.EmployeeAttachmentInView = function (data) {
                return $http.post(config.basePath + "EmployeeAttachmentInView", data);
            };

            this.DeleteEmployeeAttachment = function (id) {
                return $http.get(config.basePath + "DeleteEmployeeAttachment/" + id);
            };

            this.AttachmentTypesInDropdown = function () {
                return $http.get(config.basePath + "AttachmentTypesInDropdown");
            };

            //////////////////.Wps Detail//////////////////

            this.AddWpsDetail = function (data) {
                return $http.post(config.basePath + "AddWpsDetail", data);
            };
            this.WpsDetailInView = function (data) {
                return $http.post(config.basePath + "WpsDetailInView", data);
            };

            this.DeleteWpsDetail = function (id) {
                return $http.get(config.basePath + "DeleteWpsDetail/" + id);
            };

            //            this.AttachmentTypesInDropdown = function () {
            //                return $http.get(config.basePath + "AttachmentTypesInDropdown");
            //            };



            //////////////////.Employee Advance//////////////////

            this.SaveEmployeeAdvance = function (data) {
                return $http.post(config.basePath + "SaveEmployeeAdvance", data);
            };
            this.EmployeeAdvanceInGrid = function (data) {
                return $http.post(config.basePath + "EmployeeAdvanceInGrid", data);
            };

            this.DeleteEmployeeAdvance = function (id) {
                return $http.get(config.basePath + "DeleteEmployeeAdvance/" + id);
            };


            //////////////////.Vacation History//////////////////

            this.SaveVacationHistory = function (data) {
                return $http.post(config.basePath + "SaveVacationHistory", data);
            };
            this.VacationHistoryInGrid = function (data) {
                return $http.post(config.basePath + "VacationHistoryInGrid", data);
            };

            this.DeleteVacationHistory = function (id) {
                return $http.get(config.basePath + "DeleteVacationHistory/" + id);
            };


            //////////////////.Employee Appraisal //////////////////

            this.AddEmployeeAppraisal = function (data) {
                return $http.post(config.basePath + "AddEmployeeAppraisal", data);
            };
            this.EmployeeAppraisalsInView = function (data) {
                return $http.post(config.basePath + "EmployeeAppraisalsInView", data);
            };

            this.DeleteEmployeeAppraisal = function (id) {
                return $http.get(config.basePath + "DeleteEmployeeAppraisal/" + id);
            };

            //////////////////.Employee Fine//////////////////

            this.SaveEmployeeFine = function (data) {
                return $http.post(config.basePath + "SaveEmployeeFine", data);
            };
            this.EmployeeFineInGrid = function (data) {
                return $http.post(config.basePath + "EmployeeFineInGrid", data);
            };

            this.DeleteEmployeeFine = function (id) {
                return $http.get(config.basePath + "DeleteEmployeeFine/" + id);
            };



            //////////////////Salary Detail//////////////////

            this.AddSalaryDetail = function (data) {
                return $http.post(config.basePath + "AddSalaryDetail", data);
            };
            this.SalaryDetailInView = function (data) {
                return $http.post(config.basePath + "SalaryDetailInView", data);
            };

            this.DeleteSalaryDetail = function (id) {
                return $http.get(config.basePath + "DeleteSalaryDetail/" + id);
            };

            //            this.AttachmentTypesInDropdown = function () {
            //                return $http.get(config.basePath + "AttachmentTypesInDropdown");
            //            };

            //////////////////.Leave Types..//////////////////

            this.AddLeaveType = function (data) {
                return $http.post(config.basePath + "AddLeaveType", data);
            };
            this.LeaveTypesInGrid = function (data) {
                return $http.post(config.basePath + "LeaveTypesInGrid", data);
            };
            this.LeaveTypesInDropDown = function () {
                return $http.get(config.basePath + "LeaveTypesInDropDown");
            };

            this.DeleteLeaveType = function (id) {
                return $http.get(config.basePath + "DeleteLeaveType/" + id);
            };

            //////////////////.Vacation Request..//////////////////

            this.SaveVacationRequest = function (data) {
                return $http.post(config.basePath + "SaveVacationRequest", data);
            };
            this.UpdateVacationRequest = function (data) {
                return $http.post(config.basePath + "UpdateVacationRequest", data);
            };
            this.VacationRequestsInGrid = function (data) {
                return $http.post(config.basePath + "VacationRequestsInGrid", data);
            };
            this.VacationRequestsInDropDown = function () {
                return $http.get(config.basePath + "VacationRequestsInDropDown");
            };

            this.DeleteVacationRequest = function (id) {
                return $http.get(config.basePath + "DeleteVacationRequest/" + id);
            };

            //////////////////.ResignationForm..//////////////////

            this.SaveResignationForm = function (data) {
                return $http.post(config.basePath + "SaveResignationForm", data);
            };
            this.UpdateResignationForm = function (data) {
                return $http.post(config.basePath + "UpdateResignationForm", data);
            };
            this.ResignationFormsInGrid = function (data) {
                return $http.post(config.basePath + "ResignationFormsInGrid", data);
            };
            this.ResignationFormsInDropDown = function () {
                return $http.get(config.basePath + "ResignationFormsInDropDown");
            };

            this.DeleteResignationForm = function (id) {
                return $http.get(config.basePath + "DeleteResignationForm/" + id);
            };


            /////////////////.WarningLetter..//////////////////

            this.SaveWarningLetter = function (data) {
                return $http.post(config.basePath + "SaveWarningLetter", data);
            };
            this.UpdateWarningLetter = function (data) {
                return $http.post(config.basePath + "UpdateWarningLetter", data);
            };
            this.WarningLettersInGrid = function (data) {
                return $http.post(config.basePath + "WarningLettersInGrid", data);
            };
            this.WarningLettersInDropDown = function () {
                return $http.get(config.basePath + "WarningLettersInDropDown");
            };

            this.DeleteWarningLetter = function (id) {
                return $http.get(config.basePath + "DeleteWarningLetter/" + id);
            };


            //////////////////.Unit..//////////////////

            this.UnitsInView = function (data) {
                return $http.post(config.basePath + "UnitsInView", data);
            };
            this.UnitConvertionInView = function (data) {
                return $http.post(config.basePath + "UnitConvertionInView", data);
            };
            this.AddUnit = function (data) {
                return $http.post(config.basePath + "AddUnit", data);
            };
            this.AddUnitConvertion = function (data) {
                return $http.post(config.basePath + "AddUnitConvertion", data);
            };
            this.UnitsInDropdown = function () {
                return $http.get(config.basePath + "UnitsInDropdown");
            };

            this.DeleteUnit = function (id) {
                return $http.get(config.basePath + "DeleteUnit/" + id);
            };
            this.DeleteUnitConvertion = function (id) {
                return $http.get(config.basePath + "DeleteUnitConvertion/" + id);
            };


            //////////////////.Employee..//////////////////

            this.GetNextEmployeeNo = function () {
                return $http.get(config.basePath + "GetNextEmployeeNo");
            };
            this.GetNextCostCenterNo = function () {
                return $http.get(config.basePath + "GetNextCostCenterNo");
            };
            this.GetNextCoseCenterNo = function (id) {
                return $http.get(config.basePath + "GetNextCoseCenterNo/" + id);
            };
            this.EmployeesInView = function (data) {
                return $http.post(config.basePath + "EmployeesInView", data);
            };
            this.AddEmployee = function (data) {
                return $http.post(config.basePath + "AddEmployee", data);
            };
            this.AddBulkEmployee = function (data) {
                return $http.post(config.basePath + "AddBulkEmployee", data);
            };
            this.EmployeesInDropdown = function () {
                return $http.get(config.basePath + "EmployeesInDropdown");
            };
            this.EmployeesByGradeId = function (id) {
                return $http.get(config.basePath + "EmployeesByGradeId/" + id);
            };
            this.GetRecentBirthdays = function () {
                return $http.get(config.basePath + "GetRecentBirthdays");
            };
            this.DeleteEmployee = function (id) {
                return $http.get(config.basePath + "DeleteEmployee/" + id);
            };

            this.DesignationsInDropdown = function () {
                return $http.get(config.basePath + "DesignationsInDropdown");
            };
            this.DepartmentsInDropdown = function () {
                return $http.get(config.basePath + "DepartmentsInDropdown");
            };

            this.EmployeeById = function (id) {
                return $http.get(config.basePath + "EmployeeById/" + id);
            };



            //////////////////.Branch..//////////////////

            this.BranchesInView = function (data) {
                return $http.post(config.basePath + "BranchesInView", data);
            };
            this.AddBranch = function (data) {
                return $http.post(config.basePath + "AddBranch", data);
            };
            this.BranchesInDropdown = function () {
                return $http.get(config.basePath + "BranchesInDropdown");
            };
            this.DeleteBranch = function (id) {
                return $http.get(config.basePath + "DeleteBranch/" + id);
            };
            this.getBranchByEmployeeId = function (id) {
                return $http.get(config.basePath + "getBranchByEmployeeId/" + id);
            };

            //////////////////.VAT..//////////////////

            this.VATsInView = function (data) {
                return $http.post(config.basePath + "VATsInView", data);
            };
            this.AddVAT = function (data) {
                return $http.post(config.basePath + "AddVAT", data);
            };
            this.VATsInDropdown = function () {
                return $http.get(config.basePath + "VATsInDropdown");
            };

            this.DeleteVAT = function (id) {
                return $http.get(config.basePath + "DeleteVAT/" + id);
            };

            //////////////////.Cities..//////////////////

            this.CitiesInView = function (data) {
                return $http.post(config.basePath + "CitiesInView", data);
            };
            this.AddCity = function (data) {
                return $http.post(config.basePath + "AddCity", data);
            };
            this.CitiesInDropdown = function () {
                return $http.get(config.basePath + "CitiesInDropdown");
            };

            this.DeleteCity = function (id) {
                return $http.get(config.basePath + "DeleteCity/" + id);
            };


            //////////////////.Bank..//////////////////

            this.BanksInView = function (data) {
                return $http.post(config.basePath + "BanksInView", data);
            };
            this.AddBank = function (data) {
                return $http.post(config.basePath + "AddBank", data);
            };
            this.BanksInDropdown = function () {
                return $http.get(config.basePath + "BanksInDropdown");
            };

            this.DeleteBank = function (id) {
                return $http.get(config.basePath + "DeleteBank/" + id);
            };

            //////////////////.Grade..//////////////////

            this.GradesInView = function (data) {
                return $http.post(config.basePath + "GradesInView", data);
            };
            this.AddGrade = function (data) {
                return $http.post(config.basePath + "AddGrade", data);
            };
            this.GradesInDropdown = function () {
                return $http.get(config.basePath + "GradesInDropdown");
            };

            this.DeleteGrade = function (id) {
                return $http.get(config.basePath + "DeleteGrade/" + id);
            };

            //////////////////.Leace Allcoation..//////////////////

            this.AddLeaveAllocation = function (data) {
                return $http.post(config.basePath + "AddLeaveAllocation", data);
            };
            this.LeaveAllocationInView = function (data) {
                return $http.post(config.basePath + "LeaveAllocationInView", data);
            };
            this.EmployeeLeaveLedgerInView = function (data) {
                return $http.post(config.basePath + "EmployeeLeaveLedgerInView", data);
            };
            this.LeaveAllocationList = function () {
                return $http.get(config.basePath + "LeaveAllocationList");
            };
            this.LeavePayrollComponentsList = function () {
                return $http.get(config.basePath + "LeavePayrollComponentsList");
            };

            //////////////////.Leace Application..//////////////////

            this.AddLeaveApplication = function (data) {
                return $http.post(config.basePath + "AddLeaveApplication", data);
            };
            this.LeaveApplicationsInView = function (data) {
                return $http.post(config.basePath + "LeaveApplicationsInView", data);
            };
            this.RejectLeaveApplcation = function (data) {
                return $http.post(config.basePath + "RejectLeaveApplcation", data);
            };
            this.DeleteLeaveApplcation = function (id) {
                return $http.get(config.basePath + "DeleteLeaveApplcation/" + id);
            };
            this.ApproveLeaveApplcation = function (id) {
                return $http.get(config.basePath + "ApproveLeaveApplcation/" + id);
            };

            this.GetNextLeaveApplyNo = function () {
                return $http.get(config.basePath + "GetNextLeaveApplyNo");
            };
            this.CheckEmployeeBalanceLeave = function (empId, compId) {
                return $http.get(config.basePath + "CheckEmployeeBalanceLeave/" + empId + "/" + compId);
            };


            //////////////////.Shift..//////////////////

            this.WorkTypeInView = function (data) {
                return $http.post(config.basePath + "WorkTypeInView", data);
            };
            this.AddWorkType = function (data) {
                return $http.post(config.basePath + "AddWorkType", data);
            };
            this.WorkTypesInDropdown = function () {
                return $http.get(config.basePath + "WorkTypesInDropdown");
            };
            this.DeleteWorkType = function (id) {
                return $http.get(config.basePath + "DeleteWorkType/" + id);
            };
            //////////////////.Work Type..//////////////////

            this.ShiftsInView = function (data) {
                return $http.post(config.basePath + "ShiftsInView", data);
            };
            this.AddShift = function (data) {
                return $http.post(config.basePath + "AddShift", data);
            };
            this.ShiftsInDropdown = function () {
                return $http.get(config.basePath + "ShiftsInDropdown");
            };

            this.DeleteShift = function (id) {
                return $http.get(config.basePath + "DeleteShift/" + id);
            };
            this.GetYearlyMonthWiseAttendance = function (id) {
                return $http.get(config.basePath + "GetYearlyMonthWiseAttendance/" + id);
            };

            //////////////////.PayrollComponent..//////////////////

            this.PayrollComponentsInView = function (data) {
                return $http.post(config.basePath + "PayrollComponentsInView", data);
            };
            this.AddPayrollComponent = function (data) {
                return $http.post(config.basePath + "AddPayrollComponent", data);
            };
            this.PayrollComponentsInDropdown = function () {
                return $http.get(config.basePath + "PayrollComponentsInDropdown");
            };
            this.PayrollComponentsInSalary = function () {
                return $http.get(config.basePath + "PayrollComponentsInSalary");
            };
            this.DeletePayrollComponent = function (id) {
                return $http.get(config.basePath + "DeletePayrollComponent/" + id);
            };
            this.PayrollComponentsInEmployee = function () {
                return $http.get(config.basePath + "PayrollComponentsInEmployee");
            };


            //////////////////. Earning Deduction..//////////////////
            this.PayrollComponentsForED = function () {
                return $http.get(config.basePath + "PayrollComponentsForED");
            };
            this.GetNextEarningDeductionNo = function () {
                return $http.get(config.basePath + "GetNextEarningDeductionNo");
            };

            this.AddEarningDeduction = function (data) {
                return $http.post(config.basePath + "AddEarningDeduction", data);
            };
            this.EarningDeductionInView = function (data) {
                return $http.post(config.basePath + "EarningDeductionInView", data);
            };
            this.EarningDeductionsByYear = function (empId, year, month) {
                return $http.get(config.basePath + "EarningDeductionsByYear/" + empId + "/" + year + "/" + month);
            };
            this.DeleteEarningDeduction = function (id) {
                return $http.get(config.basePath + "DeleteEarningDeduction/" + id);
            };
            this.GetEmployeeSalaryValues = function (empId, year, month, monthstr) {
                return $http.get(config.basePath + "GetEmployeeSalaryValues/" + empId + "/" + year + "/" + month + "/" + monthstr);
            };
            this.EarningDeductionsById = function (id) {
                return $http.get(config.basePath + "EarningDeductionsById/" + id);
            };
            this.DeleteEarningDeduction = function (id) {
                return $http.get(config.basePath + "DeleteEarningDeduction/" + id);
            };

            //////////////////.Counter sales..//////////////////

            this.AddCounterSales = function (data) {
                return $http.post(config.basePath + "AddCounterSales", data);
            };
            this.CounterSalesInView = function (data) {
                return $http.post(config.basePath + "CounterSalesInView", data);
            };

            this.CounterSalesInReport = function (data) {
                return $http.post(config.basePath + "CounterSalesInReport", data);
            };
            this.CounterSalesDetailsInReport = function (data) {
                return $http.post(config.basePath + "CounterSalesDetailsInReport", data);
            };
            this.EmployeeCounterSalesInReport = function (data) {
                return $http.post(config.basePath + "EmployeeCounterSalesInReport", data);
            };
            this.WarehouseCounterSalesInReport = function (data) {
                return $http.post(config.basePath + "WarehouseCounterSalesInReport", data);
            };
            this.CounterSalesById = function (id) {
                return $http.get(config.basePath + "CounterSalesById/" + id);
            };
            this.getCounterSalesIForClose = function (id) {
                return $http.get(config.basePath + "getCounterSalesIForClose/" + id);
            };
            this.TrackBillNo = function (id) {
                return $http.get(config.basePath + "TrackBillNo/" + id);
            };
            this.DeleteCounterSales = function (id) {
                return $http.get(config.basePath + "DeleteCounterSales/" + id);
            };
            this.PrintCounterClosingReport = function (id) {
                return $http.get(config.basePath + "PrintCounterClosingReport/" + id);
            };
            this.getLastBill = function () {
                return $http.get(config.basePath + "getLastBill");
            };

            //////////////////.Counters..//////////////////

            this.StartCounter = function (data) {
                return $http.post(config.basePath + "StartCounter", data);
            };
            this.CloseCounter = function (data) {
                return $http.post(config.basePath + "CloseCounter", data);
            };
            this.CountersByUserId = function (data) {
                return $http.post(config.basePath + "CountersByUserId", data);
            };
            this.LastCounter = function (id) {
                return $http.get(config.basePath + "LastCounter/" + id);
            };
            this.DeleteCounter = function (id) {
                return $http.get(config.basePath + "DeleteCounter/" + id);
            };
            this.GetCounterTotals = function (id) {
                return $http.get(config.basePath + "GetCounterTotals/" + id);
            };
            this.LastCounterActive = function () {
                return $http.get(config.basePath + "LastCounterActive");
            };


            //////////////////.Currency..//////////////////

            this.CurrencyInView = function (data) {
                return $http.post(config.basePath + "CurrencyInView", data);
            };
            this.AddCurrency = function (data) {
                return $http.post(config.basePath + "AddCurrency", data);
            };

            this.DeleteCurrency = function (id) {
                return $http.get(config.basePath + "DeleteCurrency/" + id);
            };

            //////////////////.ConvertionCurrency..//////////////////

            this.CurrencyConvertionInView = function (data) {
                return $http.post(config.basePath + "CurrencyConvertionInView", data);
            };
            this.AddCurrencyConvertion = function (data) {
                return $http.post(config.basePath + "AddCurrencyConvertion", data);
            };

            this.DeleteCurrencyConvertion = function (id) {
                return $http.get(config.basePath + "DeleteCurrencyConvertion/" + id);
            };
            this.CurrencyInDropdown = function () {
                return $http.get(config.basePath + "CurrencyInDropdown");
            };
            this.CurrencyConvertionInDropdown = function () {
                return $http.get(config.basePath + "CurrencyConvertionInDropdown");
            };


            //////////////////.CostCenter..//////////////////

            this.AddAccountCostCenter = function (data) {
                return $http.post(config.basePath + "AddAccountCostCenter", data);
            };
            this.GetCostCentersInKendo = function (data) {
                return $http.post(config.basePath + "GetCostCentersInKendo", data);
            };
            this.AccountCostCentersInKendoTree = function (id) {
                return $http.get(config.basePath + "AccountCostCentersInKendoTree/" + id);
            };
            this.AccountCostCentersList = function (id) {
                return $http.get(config.basePath + "AccountCostCentersList/" + id);
            };
            this.CostCenterById = function (id) {
                return $http.get(config.basePath + "CostCenterById/" + id);
            };
            this.GetAllCostcentersInJobReprot = function () {
                return $http.get(config.basePath + "GetAllCostcentersInJobReprot");
            };
            this.DeleteAccountCostCenter = function (id, temp) {
                return $http.get(config.basePath + "DeleteAccountCostCenter/" + id + "/" + temp);
            };
            //////////////////.CostCenter..//////////////////

            this.AddCostCenter = function (data) {
                return $http.post(config.basePath + "AddCostCenter", data);
            };
            this.AddBulkCostCenter = function (data) {
                return $http.post(config.basePath + "AddBulkCostCenter", data);
            };
            this.CostCenterList = function () {
                return $http.get(config.basePath + "CostCenterList");
            };
            this.GetAllCostCenters = function () {
                return $http.get(config.basePath + "GetAllCostCenters");
            };
            this.GetAllCostSubCenters = function () {
                return $http.get(config.basePath + "GetAllCostSubCenters");
            };
            this.CostCentersInTreeList = function () {
                return $http.get(config.basePath + "CostCentersInTreeList");
            };
            this.GetParentCostCenters = function () {
                return $http.get(config.basePath + "GetParentCostCenters");
            };
            this.CostCentersInKendoTree = function () {
                return $http.get(config.basePath + "CostCentersInKendoTree");
            };

            this.CostCenterSubList = function (id) {
                return $http.get(config.basePath + "CostCenterSubList/" + id);
            };
            this.DeleteCostCenter = function (id) {
                return $http.get(config.basePath + "DeleteCostCenter/" + id);
            };
            this.DeleteCostCenter = function (id, temp) {
                return $http.get(config.basePath + "DeleteCostCenter/" + id + "/" + temp);
            };

            //////////////////.products..//////////////////

            this.AddProduct = function (data) {
                return $http.post(config.basePath + "AddProduct", data);
            };
            this.AddProductCategory = function (data) {
                return $http.post(config.basePath + "AddProductCategory", data);
            };
            this.ProductCategoriesInView = function (data) {
                return $http.post(config.basePath + "ProductCategoriesInView", data);
            };
            this.ProductSubCategoriesInView = function (data) {
                return $http.post(config.basePath + "ProductSubCategoriesInView", data);
            };
            this.ProductList = function (data) {
                return $http.post(config.basePath + "ProductList", data);
            };
            this.ProductDetailedList = function (data) {
                return $http.post(config.basePath + "ProductDetailedList", data);
            };

            this.UpdateProduct = function (data) {
                return $http.post(config.basePath + "UpdateProduct", data);
            };

            this.UpdateProductList = function (data) {
                return $http.post(config.basePath + "UpdateProductList", data);
            };

            this.productForMultiSelect = function (data) {
                return $http.post(config.basePath + "productForMultiSelect", data);
            };
            this.productInAutoComplete = function (data) {
                return $http.post(config.basePath + "productInAutoComplete", data);
            };
            this.UploadProductList = function (data) {
                return $http.post(config.basePath + "UploadProductList", data);
            };

            this.ProductsParentList = function (type) {
                return $http.get(config.basePath + "ProductsParentList/" + type);
            };

            this.getProductByName = function (data) {
                return $http.post(config.basePath + "getProductByName", data);
            };

            this.ProductById = function (type) {
                return $http.get(config.basePath + "ProductById/" + type);
            };

            this.SecondLevelProductsbyType = function (type) {
                return $http.get(config.basePath + "SecondLevelProductsbyType/" + type);
            };

            this.ProductSubList = function (id, type) {
                return $http.get(config.basePath + "ProductSubList/" + id + "/" + type);
            };

            this.getProductAccount = function (id, type) {
                return $http.get(config.basePath + "getProductAccount/" + id + "/" + type);
            };

            this.GetBarcodeDetails = function (id) {
                return $http.get(config.basePath + "GetBarcodeDetails/" + id);
            };
            this.DeleteProduct = function (id) {
                return $http.get(config.basePath + "DeleteProduct/" + id);
            };
            this.DeleteProductCategory = function (id) {
                return $http.get(config.basePath + "DeleteProductCategory/" + id);
            };
            this.GetProductForSaleCatById = function (id) {
                return $http.get(config.basePath + "GetProductForSaleCatById/" + id);
            };
            this.GetServiceForSaleCatById = function (id) {
                return $http.get(config.basePath + "GetServiceForSaleCatById/" + id);
            };
            this.GetServiceCatForSale = function () {
                return $http.get(config.basePath + "GetServiceCatForSale");
            };
            this.GetProductCatForSale = function () {
                return $http.get(config.basePath + "GetProductCatForSale");
            };
            this.GetProductCatForSale = function () {
                return $http.get(config.basePath + "GetProductCatForSale");
            };
            this.Level1Products = function () {
                return $http.get(config.basePath + "Level1Products");
            };
            this.SecondLevelProducts = function () {
                return $http.get(config.basePath + "SecondLevelProducts");
            };
            this.Level2Products = function (id) {
                return $http.get(config.basePath + "Level2Products/" + id);
            };
            this.Level3Products = function (id) {
                return $http.get(config.basePath + "Level3Products/" + id);
            };
            this.Level4ProductsByType = function (typeId, id) {
                return $http.get(config.basePath + "Level4ProductsByType/" + id + "/" + typeId);
            };

            //////////////////.Sales Enquiry..//////////////////

            this.GetNextSalesEnquiryNo = function () {
                return $http.get(config.basePath + "GetNextSalesEnquiryNo");
            };
            this.GetNextSalesEnquiry2No = function () {
                return $http.get(config.basePath + "GetNextSalesEnquiry2No");
            };
            this.GetNextSalesEnquiry3No = function () {
                return $http.get(config.basePath + "GetNextSalesEnquiry3No");
            };
            this.GetNextSalesEnquiry4No = function () {
                return $http.get(config.basePath + "GetNextSalesEnquiry4No");
            };
            this.GetBackSalesEnquiry = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesEnquiry/" + id + "/" + type);
            };

            this.AddSalesEnquiry = function (data) {
                return $http.post(config.basePath + "AddSalesEnquiry", data);
            };

            this.SalesEnquiryInView = function (data) {
                return $http.post(config.basePath + "SalesEnquiryInView", data);
            };

            this.getSalesEnquirybyId = function (id) {
                return $http.get(config.basePath + "getSalesEnquirybyId/" + id);
            };

            this.GetSalesEnquiriesForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesEnquiriesForLinking/" + id);
            };

            this.DeleteSalesEnquiry = function (id) {
                return $http.get(config.basePath + "DeleteSalesEnquiry/" + id);
            };


            //////////////////////////////////

            this.GetBackSalesEnquiry2 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesEnquiry2/" + id + "/" + type);
            };

            this.AddSalesEnquiry2 = function (data) {
                return $http.post(config.basePath + "AddSalesEnquiry2", data);
            };

            this.SalesEnquiry2InView = function (data) {
                return $http.post(config.basePath + "SalesEnquiry2InView", data);
            };

            this.getSalesEnquiry2byId = function (id) {
                return $http.get(config.basePath + "getSalesEnquiry2byId/" + id);
            };

            this.GetSalesEnquiry2sForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesEnquiry2sForLinking/" + id);
            };

            this.DeleteSalesEnquiry2 = function (id) {
                return $http.get(config.basePath + "DeleteSalesEnquiry2/" + id);
            };

            //////////////////////////////////

            this.GetBackSalesEnquiry3 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesEnquiry3/" + id + "/" + type);
            };

            this.AddSalesEnquiry3 = function (data) {
                return $http.post(config.basePath + "AddSalesEnquiry3", data);
            };

            this.SalesEnquiry3InView = function (data) {
                return $http.post(config.basePath + "SalesEnquiry3InView", data);
            };

            this.getSalesEnquiry3byId = function (id) {
                return $http.get(config.basePath + "getSalesEnquiry3byId/" + id);
            };

            this.GetSalesEnquiry3sForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesEnquiry3sForLinking/" + id);
            };

            this.DeleteSalesEnquiry3 = function (id) {
                return $http.get(config.basePath + "DeleteSalesEnquiry3/" + id);
            };


            //////////////////////////////////

            this.GetBackSalesEnquiry4 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesEnquiry4/" + id + "/" + type);
            };

            this.AddSalesEnquiry4 = function (data) {
                return $http.post(config.basePath + "AddSalesEnquiry4", data);
            };

            this.SalesEnquiry4InView = function (data) {
                return $http.post(config.basePath + "SalesEnquiry4InView", data);
            };

            this.getSalesEnquiry4byId = function (id) {
                return $http.get(config.basePath + "getSalesEnquiry4byId/" + id);
            };

            this.GetSalesEnquiry4sForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesEnquiry4sForLinking/" + id);
            };

            this.DeleteSalesEnquiry4 = function (id) {
                return $http.get(config.basePath + "DeleteSalesEnquiry4/" + id);
            };

            //////////////////.Sales Quotation..//////////////////

            this.GetNextSalesQuotationNo = function () {
                return $http.get(config.basePath + "GetNextSalesQuotationNo");
            };
            this.GetNextSalesQuotation2No = function () {
                return $http.get(config.basePath + "GetNextSalesQuotation2No");
            };
            this.GetNextSalesQuotation3No = function () {
                return $http.get(config.basePath + "GetNextSalesQuotation3No");
            };
            this.GetNextSalesQuotation4No = function () {
                return $http.get(config.basePath + "GetNextSalesQuotation4No");
            };
            this.GetBackSalesQuotation = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesQuotation/" + id + "/" + type);
            };

            this.AddSalesQuotation = function (data) {
                return $http.post(config.basePath + "AddSalesQuotation", data);
            };

            this.SalesQuotationInView = function (data) {
                return $http.post(config.basePath + "SalesQuotationInView", data);
            };

            this.getSalesQuotationbyId = function (id) {
                return $http.get(config.basePath + "getSalesQuotationbyId/" + id);
            };
            this.GetSalesQuotationsForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesQuotationsForLinking/" + id);
            };

            this.DeleteSalesQuotation = function (id) {
                return $http.get(config.basePath + "DeleteSalesQuotation/" + id);
            };

            ////////////////////////////////////////////

            this.GetBackSalesQuotation2 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesQuotation2/" + id + "/" + type);
            };


            this.AddSalesQuotation2 = function (data) {
                return $http.post(config.basePath + "AddSalesQuotation2", data);
            };

            this.SalesQuotation2InView = function (data) {
                return $http.post(config.basePath + "SalesQuotation2InView", data);
            };

            this.getSalesQuotation2byId = function (id) {
                return $http.get(config.basePath + "getSalesQuotation2byId/" + id);
            };
            this.GetSalesQuotation2sForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesQuotation2sForLinking/" + id);
            };

            this.DeleteSalesQuotation2 = function (id) {
                return $http.get(config.basePath + "DeleteSalesQuotation2/" + id);
            };

            //////////////////////////////////////////

            this.GetBackSalesQuotation3 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesQuotation3/" + id + "/" + type);
            };


            this.AddSalesQuotation3 = function (data) {
                return $http.post(config.basePath + "AddSalesQuotation3", data);
            };

            this.SalesQuotation3InView = function (data) {
                return $http.post(config.basePath + "SalesQuotation3InView", data);
            };

            this.getSalesQuotation3byId = function (id) {
                return $http.get(config.basePath + "getSalesQuotation3byId/" + id);
            };
            this.GetSalesQuotation3sForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesQuotation3sForLinking/" + id);
            };

            this.DeleteSalesQuotation3 = function (id) {
                return $http.get(config.basePath + "DeleteSalesQuotation3/" + id);
            };

            ///////////////////////////////////////////

            this.GetBackSalesQuotation4 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesQuotation4/" + id + "/" + type);
            };


            this.AddSalesQuotation4 = function (data) {
                return $http.post(config.basePath + "AddSalesQuotation4", data);
            };

            this.SalesQuotation4InView = function (data) {
                return $http.post(config.basePath + "SalesQuotation4InView", data);
            };

            this.getSalesQuotation4byId = function (id) {
                return $http.get(config.basePath + "getSalesQuotation4byId/" + id);
            };
            this.GetSalesQuotation4sForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesQuotation4sForLinking/" + id);
            };

            this.DeleteSalesQuotation4 = function (id) {
                return $http.get(config.basePath + "DeleteSalesQuotation4/" + id);
            };




            //////////////////.Sales Order..//////////////////

            this.GetNextSalesOrderNo = function () {
                return $http.get(config.basePath + "GetNextSalesOrderNo");
            };
            this.GetNextSalesOrder2No = function () {
                return $http.get(config.basePath + "GetNextSalesOrder2No");
            };
            this.GetNextSalesOrder3No = function () {
                return $http.get(config.basePath + "GetNextSalesOrder3No");
            };
            this.GetNextSalesOrder4No = function () {
                return $http.get(config.basePath + "GetNextSalesOrder4No");
            };

            this.GetBackSalesOrder = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesOrder/" + id + "/" + type);
            };

            this.AddSalesOrder = function (data) {
                return $http.post(config.basePath + "AddSalesOrder", data);
            };

            this.SalesOrderInView = function (data) {
                return $http.post(config.basePath + "SalesOrderInView", data);
            };

            this.getSalesOrderbyId = function (id) {
                return $http.get(config.basePath + "getSalesOrderbyId/" + id);
            };
            this.GetSalesOrdersForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesOrdersForLinking/" + id);
            };

            this.DeleteSalesOrder = function (id) {
                return $http.get(config.basePath + "DeleteSalesOrder/" + id);
            };

            //////////////////////////////////////

            this.GetBackSalesOrder2 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesOrder2/" + id + "/" + type);
            };

            this.AddSalesOrder2 = function (data) {
                return $http.post(config.basePath + "AddSalesOrder2", data);
            };

            this.SalesOrder2InView = function (data) {
                return $http.post(config.basePath + "SalesOrder2InView", data);
            };

            this.getSalesOrder2byId = function (id) {
                return $http.get(config.basePath + "getSalesOrder2byId/" + id);
            };
            this.GetSalesOrder2sForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesOrder2sForLinking/" + id);
            };

            this.DeleteSalesOrder2 = function (id) {
                return $http.get(config.basePath + "DeleteSalesOrder2/" + id);
            };

            //////////////////////////////////////

            this.GetBackSalesOrder3 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesOrder3/" + id + "/" + type);
            };

            this.AddSalesOrder3 = function (data) {
                return $http.post(config.basePath + "AddSalesOrder3", data);
            };

            this.SaveAutoSalesOrder3 = function (data) {
                return $http.post(config.basePath + "SaveAutoSalesOrder3", data);
            };

            this.SalesOrder3InView = function (data) {
                return $http.post(config.basePath + "SalesOrder3InView", data);
            };

            this.getSalesOrder3byId = function (id) {
                return $http.get(config.basePath + "getSalesOrder3byId/" + id);
            };
            this.GetSalesOrder3sForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesOrder3sForLinking/" + id);
            };

            this.DeleteSalesOrder3 = function (id) {
                return $http.get(config.basePath + "DeleteSalesOrder3/" + id);
            };

            //////////////////////////////////////

            this.GetBackSalesOrder4 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesOrder4/" + id + "/" + type);
            };

            this.AddSalesOrder4 = function (data) {
                return $http.post(config.basePath + "AddSalesOrder4", data);
            };

            this.SalesOrder4InView = function (data) {
                return $http.post(config.basePath + "SalesOrder4InView", data);
            };

            this.getSalesOrder4byId = function (id) {
                return $http.get(config.basePath + "getSalesOrder4byId/" + id);
            };
            this.GetSalesOrder4sForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesOrder4sForLinking/" + id);
            };

            this.DeleteSalesOrder4 = function (id) {
                return $http.get(config.basePath + "DeleteSalesOrder4/" + id);
            };

            //////////////////.Packing List..//////////////////

            this.GetNextPackingListNo = function () {
                return $http.get(config.basePath + "GetNextPackingListNo");
            };

            this.GetBackPackingList = function (id, type) {
                return $http.get(config.basePath + "GetBackPackingList/" + id + "/" + type);
            };

            this.AddPackingList = function (data) {
                return $http.post(config.basePath + "AddPackingList", data);
            };

            this.SaveAutoPackingList = function (data) {
                return $http.post(config.basePath + "SaveAutoPackingList", data);
            };

            this.PackingListInView = function (data) {
                return $http.post(config.basePath + "PackingListInView", data);
            };

            this.getPackingListbyId = function (id) {
                return $http.get(config.basePath + "getPackingListbyId/" + id);
            };
            this.GetPackingListsForLinking = function (id) {
                return $http.get(config.basePath + "GetPackingListsForLinking/" + id);
            };

            this.DeletePackingList = function (id) {
                return $http.get(config.basePath + "DeletePackingList/" + id);
            };

            //////////////////..Delivery Note..//////////////////

            this.GetNextDeliveryNoteNo = function () {
                return $http.get(config.basePath + "GetNextDeliveryNoteNo");
            };
            this.GetNextDeliveryNote2No = function () {
                return $http.get(config.basePath + "GetNextDeliveryNote2No");
            };

            this.GetNextDeliveryNote3No = function () {
                return $http.get(config.basePath + "GetNextDeliveryNote3No");
            };

            this.GetNextDeliveryNote4No = function () {
                return $http.get(config.basePath + "GetNextDeliveryNote4No");
            };

     this.UploadSalesOrder = function (data) {
                return $http.post(config.basePath + "UploadSalesOrder", data);
            };
                 this.UploadSalesOrder2 = function (data) {
                return $http.post(config.basePath + "UploadSalesOrder2", data);
            };

            this.AddDeliveryNote = function (data) {
                return $http.post(config.basePath + "AddDeliveryNote", data);
            };
            this.UploadDeliveryNote = function (data) {
                return $http.post(config.basePath + "UploadDeliveryNote", data);
            };
       
            this.GetBackDeliveryNote = function (id, type) {
                return $http.get(config.basePath + "GetBackDeliveryNote/" + id + "/" + type);
            };
            this.DeliveryNoteInView = function (data) {
                return $http.post(config.basePath + "DeliveryNoteInView", data);
            };
            this.getDeliveryNotebyId = function (id) {
                return $http.get(config.basePath + "getDeliveryNotebyId/" + id);
            };
            this.GetDeliveryNotesForLinking = function (id) {
                return $http.get(config.basePath + "GetDeliveryNotesForLinking/" + id);
            };
            this.DeleteDeliveryNote = function (id) {
                return $http.get(config.basePath + "DeleteDeliveryNote/" + id);
            };


            //////////////////////////////

            this.AddDeliveryNote2 = function (data) {
                return $http.post(config.basePath + "AddDeliveryNote2", data);
            };
            this.GetBackDeliveryNote2 = function (id, type) {
                return $http.get(config.basePath + "GetBackDeliveryNote2/" + id + "/" + type);
            };
            this.DeliveryNote2InView = function (data) {
                return $http.post(config.basePath + "DeliveryNote2InView", data);
            };
            this.getDeliveryNote2byId = function (id) {
                return $http.get(config.basePath + "getDeliveryNote2byId/" + id);
            };
            this.GetDeliveryNote2sForLinking = function (id) {
                return $http.get(config.basePath + "GetDeliveryNote2sForLinking/" + id);
            };
            this.DeleteDeliveryNote2 = function (id) {
                return $http.get(config.basePath + "DeleteDeliveryNote2/" + id);
            };

            //////////////////////////////

            this.AddDeliveryNote3 = function (data) {
                return $http.post(config.basePath + "AddDeliveryNote3", data);
            };
            this.GetBackDeliveryNote3 = function (id, type) {
                return $http.get(config.basePath + "GetBackDeliveryNote3/" + id + "/" + type);
            };
            this.DeliveryNote3InView = function (data) {
                return $http.post(config.basePath + "DeliveryNote3InView", data);
            };
            this.getDeliveryNote3byId = function (id) {
                return $http.get(config.basePath + "getDeliveryNote3byId/" + id);
            };
            this.GetDeliveryNote3sForLinking = function (id) {
                return $http.get(config.basePath + "GetDeliveryNote3sForLinking/" + id);
            };
            this.DeleteDeliveryNote3 = function (id) {
                return $http.get(config.basePath + "DeleteDeliveryNote3/" + id);
            };

            //////////////////////////////

            this.AddDeliveryNote4 = function (data) {
                return $http.post(config.basePath + "AddDeliveryNote4", data);
            };
            this.GetBackDeliveryNote4 = function (id, type) {
                return $http.get(config.basePath + "GetBackDeliveryNote4/" + id + "/" + type);
            };
            this.DeliveryNote4InView = function (data) {
                return $http.post(config.basePath + "DeliveryNote4InView", data);
            };
            this.getDeliveryNote4byId = function (id) {
                return $http.get(config.basePath + "getDeliveryNote4byId/" + id);
            };
            this.GetDeliveryNote4sForLinking = function (id) {
                return $http.get(config.basePath + "GetDeliveryNote4sForLinking/" + id);
            };
            this.DeleteDeliveryNote4 = function (id) {
                return $http.get(config.basePath + "DeleteDeliveryNote4/" + id);
            };


            //////////////////..Sales Invoice..//////////////////

            this.GetNextSalesInvoiceNo = function () {
                return $http.get(config.basePath + "GetNextSalesInvoiceNo");
            };
            this.GetNextSalesInvoice2No = function () {
                return $http.get(config.basePath + "GetNextSalesInvoice2No");
            };
            this.GetNextSalesInvoice3No = function () {
                return $http.get(config.basePath + "GetNextSalesInvoice3No");
            };
            this.GetNextSalesInvoice4No = function () {
                return $http.get(config.basePath + "GetNextSalesInvoice4No");
            };

            this.GetBackSalesInvoice = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesInvoice/" + id + "/" + type);
            };
            this.AddSalesInvoice = function (data) {
                return $http.post(config.basePath + "AddSalesInvoice", data);
            };
            this.AddSalesInvoiceExcel = function (data) {
                return $http.post(config.basePath + "AddSalesInvoiceExcel", data);
            };
            this.UploadSalesInvoice = function (data) {
                return $http.post(config.basePath + "UploadSalesInvoice", data);
            };
            this.UploadSalesInvoice2 = function (data) {
                return $http.post(config.basePath + "UploadSalesInvoice2", data);
            };
            this.SalesInvoiceInView = function (data) {
                return $http.post(config.basePath + "SalesInvoiceInView", data);
            };
            this.getSalesInvoicebyId = function (id) {
                return $http.get(config.basePath + "getSalesInvoicebyId/" + id);
            };
            this.GetPorSalesInvoiceForLinking = function (id) {
                return $http.get(config.basePath + "GetPorSalesInvoiceForLinking/" + id);
            };
            this.GetExpSalesInvoiceForLinking = function (id) {
                return $http.get(config.basePath + "GetExpSalesInvoiceForLinking/" + id);
            };
            this.GetDirSalesInvoiceForLinking = function (id) {
                return $http.get(config.basePath + "GetDirSalesInvoiceForLinking/" + id);
            };
            this.GetSalesInvoiceForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesInvoiceForLinking/" + id);
            };
            this.DeleteSalesInvoice = function (id) {
                return $http.get(config.basePath + "DeleteSalesInvoice/" + id);
            };
            this.ReconcileVoucher = function (id) {
                return $http.get(config.basePath + "ReconcileVoucher/" + id);
            };
            this.SalesInvoiceInReconcile = function (data) {
                return $http.post(config.basePath + "SalesInvoiceInReconcile", data);
            };


            //////////////////////////////////////

            this.GetBackSalesInvoice2 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesInvoice2/" + id + "/" + type);
            };
            this.AddSalesInvoice2 = function (data) {
                return $http.post(config.basePath + "AddSalesInvoice2", data);
            };
            this.AddSalesInvoice2Excel = function (data) {
                return $http.post(config.basePath + "AddSalesInvoice2Excel", data);
            };
            this.SalesInvoice2InView = function (data) {
                return $http.post(config.basePath + "SalesInvoice2InView", data);
            };
            this.getSalesInvoice2byId = function (id) {
                return $http.get(config.basePath + "getSalesInvoice2byId/" + id);
            };
            this.GetSalesInvoice2ForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesInvoice2ForLinking/" + id);
            };
            this.DeleteSalesInvoice2 = function (id) {
                return $http.get(config.basePath + "DeleteSalesInvoice2/" + id);
            };


            //////////////////////////////////////

            this.GetBackSalesInvoice3 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesInvoice3/" + id + "/" + type);
            };
            this.AddSalesInvoice3 = function (data) {
                return $http.post(config.basePath + "AddSalesInvoice3", data);
            };
            this.AddSalesInvoice3Excel = function (data) {
                return $http.post(config.basePath + "AddSalesInvoice3Excel", data);
            };
            this.SalesInvoice3InView = function (data) {
                return $http.post(config.basePath + "SalesInvoice3InView", data);
            };
            this.getSalesInvoice3byId = function (id) {
                return $http.get(config.basePath + "getSalesInvoice3byId/" + id);
            };
            this.GetSalesInvoice3ForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesInvoice3ForLinking/" + id);
            };
            this.DeleteSalesInvoice3 = function (id) {
                return $http.get(config.basePath + "DeleteSalesInvoice3/" + id);
            };

            //////////////////////////////////////

            this.GetBackSalesInvoice4 = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesInvoice4/" + id + "/" + type);
            };
            this.AddSalesInvoice4 = function (data) {
                return $http.post(config.basePath + "AddSalesInvoice4", data);
            };
            this.AddSalesInvoice4Excel = function (data) {
                return $http.post(config.basePath + "AddSalesInvoice4Excel", data);
            };
            this.SalesInvoice4InView = function (data) {
                return $http.post(config.basePath + "SalesInvoice4InView", data);
            };
            this.getSalesInvoice4byId = function (id) {
                return $http.get(config.basePath + "getSalesInvoice4byId/" + id);
            };
            this.GetSalesInvoice4ForLinking = function (id) {
                return $http.get(config.basePath + "GetSalesInvoice4ForLinking/" + id);
            };
            this.DeleteSalesInvoice4 = function (id) {
                return $http.get(config.basePath + "DeleteSalesInvoice4/" + id);
            };


            ///////////////////////////////


            this.SalesEnquiryByCustomerSupplierId = function (id) {
                return $http.get(config.basePath + "SalesEnquiryByCustomerSupplierId/" + id);
            };

            this.AnalysePreviousDNPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousDN2Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousDN2Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousDN3Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousDN3Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousDN4Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousDN4Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousDNPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSIPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSIPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSI2Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSI2Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSI3Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSI3Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSI4Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSI4Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousDSIPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousDSIPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousESIPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousESIPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousPLPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousPLPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousPRSIPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousPRSIPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSEPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSEPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSE2Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSE2Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSE3Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSE3Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSE3Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSE4Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSQPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSQPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSQ2Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSQ2Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSQ3Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSQ3Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSQ4Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSQ4Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSOPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSO2Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSO2Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSO3Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSO3Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSO4Price/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSO4Price = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSOPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousSRPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousSRPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousISIPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousISIPrice/" + id + "/" + cusId + "/" + temp);
            };

            this.AnalysePreviousDPIPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousDPIPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousEPIPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousEPIPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousGRPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousGRPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousIPIPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousIPIPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousINPIPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousINPIPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousPEPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousPEPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousPIPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousPIPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousPOPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousPOPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousPQPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousPQPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousPRPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousPRPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousPRTNPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousPRTNPrice/" + id + "/" + cusId + "/" + temp);
            };
            this.AnalysePreviousCNSRPrice = function (id, cusId, temp) {
                if (!cusId > 0) {
                    cusId = 0
                }
                return $http.get(config.basePath + "AnalysePreviousCNSRPrice/" + id + "/" + cusId + "/" + temp);
            };

            //////////////////..Sales Return..//////////////////

            this.GetNextSalesReturnNo = function () {
                return $http.get(config.basePath + "GetNextSalesReturnNo");
            };


            this.AddSalesReturn = function (data) {
                return $http.post(config.basePath + "AddSalesReturn", data);
            };

            this.SalesReturnInView = function (data) {
                return $http.post(config.basePath + "SalesReturnInView", data);
            };

            this.getSalesReturnbyId = function (id) {
                return $http.get(config.basePath + "getSalesReturnbyId/" + id);
            };

            this.DeleteSalesReturn = function (id) {
                return $http.get(config.basePath + "DeleteSalesReturn/" + id);
            };
            this.GetBackSalesReturn = function (id, type) {
                return $http.get(config.basePath + "GetBackSalesReturn/" + id + "/" + type);
            };

            //////////////////.Purcahse Enquiry..//////////////////

            this.GetNextPurchaseEnquiryNo = function () {
                return $http.get(config.basePath + "GetNextPurchaseEnquiryNo");
            };
            this.GetBackPurchaseEnquiry = function (id, type) {
                return $http.get(config.basePath + "GetBackPurchaseEnquiry/" + id + "/" + type);
            };


            this.AddPurchaseEnquiry = function (data) {
                return $http.post(config.basePath + "AddPurchaseEnquiry", data);
            };

            this.PurchaseEnquiryInView = function (data) {
                return $http.post(config.basePath + "PurchaseEnquiryInView", data);
            };

            this.getPurchaseEnquirybyId = function (id) {
                return $http.get(config.basePath + "getPurchaseEnquirybyId/" + id);
            };

            this.DeletePurchaseEnquiry = function (id) {
                return $http.get(config.basePath + "DeletePurchaseEnquiry/" + id);
            };

            this.GetPurchaseEnquiryForLinking = function (id) {
                return $http.get(config.basePath + "GetPurchaseEnquiryForLinking/" + id);
            };

            //////////////////.Purcahse Request..//////////////////

            this.GetNextMaterialRequestNo = function () {
                return $http.get(config.basePath + "GetNextMaterialRequestNo");
            };
            this.GetBackMaterialRequest = function (id, type) {
                return $http.get(config.basePath + "GetBackMaterialRequest/" + id + "/" + type);
            };


            this.AddMaterialRequest = function (data) {
                return $http.post(config.basePath + "AddMaterialRequest", data);
            };

            this.MaterialRequestInView = function (data) {
                return $http.post(config.basePath + "MaterialRequestInView", data);
            };

            this.getMaterialRequestbyId = function (id) {
                return $http.get(config.basePath + "getMaterialRequestbyId/" + id);
            };

            this.DeleteMaterialRequest = function (id) {
                return $http.get(config.basePath + "DeleteMaterialRequest/" + id);
            };

            this.GetMaterialRequestForLinking = function (id) {
                return $http.get(config.basePath + "GetMaterialRequestForLinking/" + id);
            };


            //////////////////.Purcahse Request..//////////////////

            this.GetNextPurchaseRequestNo = function () {
                return $http.get(config.basePath + "GetNextPurchaseRequestNo");
            };
            this.GetBackPurchaseRequest = function (id, type) {
                return $http.get(config.basePath + "GetBackPurchaseRequest/" + id + "/" + type);
            };


            this.AddPurchaseRequest = function (data) {
                return $http.post(config.basePath + "AddPurchaseRequest", data);
            };

            this.PurchaseRequestInView = function (data) {
                return $http.post(config.basePath + "PurchaseRequestInView", data);
            };

            this.getPurchaseRequestbyId = function (id) {
                return $http.get(config.basePath + "getPurchaseRequestbyId/" + id);
            };

            this.DeletePurchaseRequest = function (id) {
                return $http.get(config.basePath + "DeletePurchaseRequest/" + id);
            };

            this.GetPurchaseRequestForLinking = function (id) {
                return $http.get(config.basePath + "GetPurchaseRequestForLinking/" + id);
            };


            this.GetPurchaseInvoiceForLinking = function (id) {
                return $http.get(config.basePath + "GetPurchaseInvoiceForLinking/" + id);
            };
            this.GetDirPurchaseInvoiceForLinking = function (id) {
                return $http.get(config.basePath + "GetDirPurchaseInvoiceForLinking/" + id);
            };
            this.GetImpPurchaseInvoiceForLinking = function (id) {
                return $http.get(config.basePath + "GetImpPurchaseInvoiceForLinking/" + id);
            };
            this.GetExpPurchaseInvoiceForLinking = function (id) {
                return $http.get(config.basePath + "GetExpPurchaseInvoiceForLinking/" + id);
            };

            //////////////////.Purchase Quotation..//////////////////

            this.GetNextPurchaseQuotationNo = function () {
                return $http.get(config.basePath + "GetNextPurchaseQuotationNo");
            };
            this.GetBackPurchaseQuotation = function (id, type) {
                return $http.get(config.basePath + "GetBackPurchaseQuotation/" + id + "/" + type);
            };


            this.AddPurchaseQuotation = function (data) {
                return $http.post(config.basePath + "AddPurchaseQuotation", data);
            };

            this.PurchaseQuotationInView = function (data) {
                return $http.post(config.basePath + "PurchaseQuotationInView", data);
            };

            this.getPurcahseQuotationbyId = function (id) {
                return $http.get(config.basePath + "getPurcahseQuotationbyId/" + id);
            };

            this.DeletePurchaseQuotation = function (id) {
                return $http.get(config.basePath + "DeletePurchaseQuotation/" + id);
            };

            this.GetPurchaseQuotationForLinking = function (id) {
                return $http.get(config.basePath + "GetPurchaseQuotationForLinking/" + id);
            };


            //////////////////.Purchase Order..//////////////////

            this.GetNextPurchaseOrderNo = function () {
                return $http.get(config.basePath + "GetNextPurchaseOrderNo");
            };
            this.GetBackPurchaseOrder = function (id, type) {
                return $http.get(config.basePath + "GetBackPurchaseOrder/" + id + "/" + type);
            };

            this.AddPurchaseOrder = function (data) {
                return $http.post(config.basePath + "AddPurchaseOrder", data);
            };

            this.PurchaseOrderInView = function (data) {
                return $http.post(config.basePath + "PurchaseOrderInView", data);
            };

            this.getPurchaseOrderbyId = function (id) {
                return $http.get(config.basePath + "getPurchaseOrderbyId/" + id);
            };

            this.DeletePurchaseOrder = function (id) {
                return $http.get(config.basePath + "DeletePurchaseOrder/" + id);
            };

            this.GetPurchaseOrderForLinking = function (id) {
                return $http.get(config.basePath + "GetPurchaseOrderForLinking/" + id);
            };





            //////////////////..For Approvals..//////////////////


            this.DirPurchaseInvoiceForApprovals = function (data) {
                return $http.post(config.basePath + "DirPurchaseInvoiceForApprovals", data);
            };

            this.ExpPurchaseInvoiceForApprovals = function (data) {
                return $http.post(config.basePath + "ExpPurchaseInvoiceForApprovals", data);
            };
            this.GoodsReceivedForApprovals = function (data) {
                return $http.post(config.basePath + "GoodsReceivedForApprovals", data);
            };

            this.ImpPurchaseInvoiceForApprovals = function (data) {
                return $http.post(config.basePath + "ImpPurchaseInvoiceForApprovals", data);
            };
            this.IndPurchaseInvoiceForApprovals = function (data) {
                return $http.post(config.basePath + "IndPurchaseInvoiceForApprovals", data);
            };
            this.PurchaseEnquiryForApprovals = function (data) {
                return $http.post(config.basePath + "PurchaseEnquiryForApprovals", data);
            };
            this.PurchaseOrderForApprovals = function (data) {
                return $http.post(config.basePath + "PurchaseOrderForApprovals", data);
            };
            this.PurchaseQuotationForApprovals = function (data) {
                return $http.post(config.basePath + "PurchaseQuotationForApprovals", data);
            };
            this.MaterialRequestForApprovals = function (data) {
                return $http.post(config.basePath + "MaterialRequestForApprovals", data);
            };
            this.PurchaseRequestForApprovals = function (data) {
                return $http.post(config.basePath + "PurchaseRequestForApprovals", data);
            };
            this.PurchaseReturnForApprovals = function (data) {
                return $http.post(config.basePath + "PurchaseReturnForApprovals", data);
            };
            this.CreditNoteSRForApprovals = function (data) {
                return $http.post(config.basePath + "CreditNoteSRForApprovals", data);
            };
            this.DeliveryNote2ForApprovals = function (data) {
                return $http.post(config.basePath + "DeliveryNote2ForApprovals", data);
            };
            this.DeliveryNote3ForApprovals = function (data) {
                return $http.post(config.basePath + "DeliveryNote3ForApprovals", data);
            };
            this.DeliveryNote4ForApprovals = function (data) {
                return $http.post(config.basePath + "DeliveryNote4ForApprovals", data);
            };
            this.DeliveryNoteForApprovals = function (data) {
                return $http.post(config.basePath + "DeliveryNoteForApprovals", data);
            };
            this.DirSalesInvoiceForApprovals = function (data) {
                return $http.post(config.basePath + "DirSalesInvoiceForApprovals", data);
            };
            this.ExpSalesInvoiceForApprovals = function (data) {
                return $http.post(config.basePath + "ExpSalesInvoiceForApprovals", data);
            };

            this.IndSalesInvoiceForApprovals = function (data) {
                return $http.post(config.basePath + "IndSalesInvoiceForApprovals", data);
            };

            this.PackingListForApprovals = function (data) {
                return $http.post(config.basePath + "PackingListForApprovals", data);
            };

            this.PorSalesInvoiceForApprovals = function (data) {
                return $http.post(config.basePath + "PorSalesInvoiceForApprovals", data);
            };

            this.SalesEnquiryForApprovals = function (data) {
                return $http.post(config.basePath + "SalesEnquiryForApprovals", data);
            };
            this.SalesEnquiry2ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesEnquiry2ForApprovals", data);
            };
            this.SalesEnquiry3ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesEnquiry3ForApprovals", data);
            };
            this.SalesEnquiry4ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesEnquiry4ForApprovals", data);
            };

            this.SalesInvoiceForApprovals = function (data) {
                return $http.post(config.basePath + "SalesInvoiceForApprovals", data);
            };
            this.SalesInvoice4ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesInvoice4ForApprovals", data);
            };
            this.SalesInvoice2ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesInvoice2ForApprovals", data);
            };
            this.SalesInvoice3ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesInvoice3ForApprovals", data);
            };
            this.SalesOrderForApprovals = function (data) {
                return $http.post(config.basePath + "SalesOrderForApprovals", data);
            };
            this.SalesOrder2ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesOrder2ForApprovals", data);
            };
            this.SalesOrder3ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesOrder3ForApprovals", data);
            };
            this.SalesOrder4ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesOrder4ForApprovals", data);
            };
            this.SalesQuotationForApprovals = function (data) {
                return $http.post(config.basePath + "SalesQuotationForApprovals", data);
            };
            this.SalesQuotation2ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesQuotation2ForApprovals", data);
            };

            this.SalesQuotation3ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesQuotation3ForApprovals", data);
            };
            this.SalesQuotation4ForApprovals = function (data) {
                return $http.post(config.basePath + "SalesQuotation4ForApprovals", data);
            };

            this.SalesReturnForApprovals = function (data) {
                return $http.post(config.basePath + "SalesReturnForApprovals", data);
            };



            //////////////////..Goods Received..//////////////////

            this.GetNextGoodsReceivedNo = function () {
                return $http.get(config.basePath + "GetNextGoodsReceivedNo");
            };
            this.GetBackGoodsReceived = function (id, type) {
                return $http.get(config.basePath + "GetBackGoodsReceived/" + id + "/" + type);
            };



            this.AddGoodsReceived = function (data) {
                return $http.post(config.basePath + "AddGoodsReceived", data);
            };

            this.GoodsReceivedInView = function (data) {
                return $http.post(config.basePath + "GoodsReceivedInView", data);
            };

            this.getGoodsReceivedbyId = function (id) {
                return $http.get(config.basePath + "getGoodsReceivedbyId/" + id);
            };

            this.DeleteGoodsReceived = function (id) {
                return $http.get(config.basePath + "DeleteGoodsReceived/" + id);
            };

            this.GetGoodsReceivedForLinking = function (id) {
                return $http.get(config.basePath + "GetGoodsReceivedForLinking/" + id);
            };


            //////////////////..Purchase Invoice..//////////////////

            this.GetNextPurchaseInvoiceNo = function () {
                return $http.get(config.basePath + "GetNextPurchaseInvoiceNo");
            };
            this.GetBackPurchaseInvoice = function (id, type) {
                return $http.get(config.basePath + "GetBackPurchaseInvoice/" + id + "/" + type);
            };

            this.AddPurchaseInvoiceExcel = function (data) {
                return $http.post(config.basePath + "AddPurchaseInvoiceExcel", data);
            };

            this.AddPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "AddPurchaseInvoice", data);
            };
            this.UploadPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "UploadPurchaseInvoice", data);
            };

            this.PurchaseInvoiceInView = function (data) {
                return $http.post(config.basePath + "PurchaseInvoiceInView", data);
            };

            this.PurchaseInvoiceForApprovals = function (data) {
                return $http.post(config.basePath + "PurchaseInvoiceForApprovals", data);
            };



            this.getPurchaseInvoicebyId = function (id) {
                return $http.get(config.basePath + "getPurchaseInvoicebyId/" + id);
            };

            this.DeletePurchaseInvoice = function (id) {
                return $http.get(config.basePath + "DeletePurchaseInvoice/" + id);
            };

            //////////////////..IND Purchase Invoice..//////////////////

            this.GetNextIndPurchaseInvoiceNo = function () {
                return $http.get(config.basePath + "GetNextIndPurchaseInvoiceNo");
            };
            this.GetBackIndPurchaseInvoice = function (id, type) {
                return $http.get(config.basePath + "GetBackIndPurchaseInvoice/" + id + "/" + type);
            };
            this.AddIndPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "AddIndPurchaseInvoice", data);
            };
            this.IndPurchaseInvoiceInView = function (data) {
                return $http.post(config.basePath + "IndPurchaseInvoiceInView", data);
            };
            this.IndPurchaseInvoicesInReport = function (data) {
                return $http.post(config.basePath + "IndPurchaseInvoicesInReport", data);
            };
            this.PendingIndPurchaseInvoicesInReport = function (data) {
                return $http.post(config.basePath + "PendingIndPurchaseInvoicesInReport", data);
            };
            this.getIndPurchaseInvoicebyId = function (id) {
                return $http.get(config.basePath + "getIndPurchaseInvoicebyId/" + id);
            };
            this.getIndPurchaseInvoicebyLinkingId = function (id) {
                return $http.get(config.basePath + "getIndPurchaseInvoicebyLinkingId/" + id);
            };
            this.GetIndPurchaseInvoiceForLinking = function (id) {
                return $http.get(config.basePath + "GetIndPurchaseInvoiceForLinking/" + id);
            };
            this.GetIndPurchaseInvoiceForLinkingCost = function (id) {
                return $http.get(config.basePath + "GetIndPurchaseInvoiceForLinkingCost/" + id);
            };
            this.DeleteIndPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "DeleteIndPurchaseInvoice/" + id);
            };
            this.IndPurchaseInvoiceInKeyword = function (id) {
                return $http.post(config.basePath + "IndPurchaseInvoiceInKeyword/" + id);
            };


            //////////////////..IND Sales Invoice..//////////////////

            this.GetNextIndSalesInvoiceNo = function () {
                return $http.get(config.basePath + "GetNextIndSalesInvoiceNo");
            };
            this.GetBackIndSalesInvoice = function (id, type) {
                return $http.get(config.basePath + "GetBackIndSalesInvoice/" + id + "/" + type);
            };
            this.AddIndSalesInvoice = function (data) {
                return $http.post(config.basePath + "AddIndSalesInvoice", data);
            };
            this.IndSalesInvoiceInView = function (data) {
                return $http.post(config.basePath + "IndSalesInvoiceInView", data);
            };
            this.OverDueIndSalesInvoiceInReport = function (data) {
                return $http.post(config.basePath + "OverDueIndSalesInvoiceInReport", data);
            };

            this.getIndSalesInvoicebyId = function (id) {
                return $http.get(config.basePath + "getIndSalesInvoicebyId/" + id);
            };
            this.getIndSalesInvoicebyLinkingId = function (id) {
                return $http.get(config.basePath + "getIndSalesInvoicebyLinkingId/" + id);
            };
            this.GetIndSalesInvoiceForLinking = function (id) {
                return $http.get(config.basePath + "GetIndSalesInvoiceForLinking/" + id);
            };
            this.GetIndSalesInvoiceForLinkingCost = function (id) {
                return $http.get(config.basePath + "GetIndSalesInvoiceForLinkingCost/" + id);
            };
            this.DeleteIndSalesInvoice = function (id) {
                return $http.get(config.basePath + "DeleteIndSalesInvoice/" + id);
            };
            this.IndPurchaseInvoiceInKeyword = function (id) {
                return $http.post(config.basePath + "IndPurchaseInvoiceInKeyword/" + id);
            };


            //////////////////..Purchase Return..//////////////////

            this.GetNextPurchaseReturnNo = function () {
                return $http.get(config.basePath + "GetNextPurchaseReturnNo");
            };
            this.GetBackPurchaseReturn = function (id, type) {
                return $http.get(config.basePath + "GetBackPurchaseReturn/" + id + "/" + type);
            };


            this.AddPurchaseReturn = function (data) {
                return $http.post(config.basePath + "AddPurchaseReturn", data);
            };

            this.PurchaseReturnInView = function (data) {
                return $http.post(config.basePath + "PurchaseReturnInView", data);
            };

            this.getPurchaseReturnbyId = function (id) {
                return $http.get(config.basePath + "getPurchaseReturnbyId/" + id);
            };

            this.DeletePurchaseReturn = function (id) {
                return $http.get(config.basePath + "DeletePurchaseReturn/" + id);
            };

            //////////////////..CPV..//////////////////

            this.GetNextCPVMasterNo = function () {
                return $http.get(config.basePath + "GetNextCPVMasterNo");
            };

            this.GetNextPaymentVoucherNo = function () {
                return $http.get(config.basePath + "GetNextPaymentVoucherNo");
            };

            this.GetNextReceiptVoucherNo = function () {
                return $http.get(config.basePath + "GetNextReceiptVoucherNo");
            };

            this.GetBackCPVMaster = function (id, type) {
                return $http.get(config.basePath + "GetBackCPVMaster/" + id + "/" + type);
            };


            this.PaymentReport = function (data) {
                return $http.post(config.basePath + "PaymentReport", data);
            };
            this.ReceiptReport = function (data) {
                return $http.post(config.basePath + "ReceiptReport", data);
            };
            this.PrintTempPaymentReport = function (data) {
                return $http.post(config.basePath + "PrintTempPaymentReport", data);
            };
            this.PrintTempReceiptReport = function (data) {
                return $http.post(config.basePath + "PrintTempReceiptReport", data);
            };

            this.addCpvMaster = function (data) {
                return $http.post(config.basePath + "addCpvMaster", data);
            };

            this.CPVSInView = function (data) {
                return $http.post(config.basePath + "CPVSInView", data);
            };

            this.GetCPV = function (id) {
                return $http.get(config.basePath + "GetCPV/" + id);
            };

            this.DeleteCPV = function (id) {
                return $http.get(config.basePath + "DeleteCPV/" + id);
            };

            //////////////////..CRV..//////////////////

            this.GetNextCRVMasterNo = function () {
                return $http.get(config.basePath + "GetNextCRVMasterNo");
            };

            this.addCrvMaster = function (data) {
                return $http.post(config.basePath + "addCrvMaster", data);
            };

            this.CRVSInView = function (data) {
                return $http.post(config.basePath + "CRVSInView", data);
            };

            this.GetCRV = function (id) {
                return $http.get(config.basePath + "GetCRV/" + id);
            };

            this.DeleteCRV = function (id) {
                return $http.get(config.basePath + "DeleteCRV/" + id);
            };

            //////////////////..Salary Sheet..//////////////////

            this.addSalarySheet = function (data) {
                return $http.post(config.basePath + "addSalarySheet", data);
            };

            this.SalarySheetInView = function (data) {
                return $http.post(config.basePath + "SalarySheetInView", data);
            };

            this.GetSalarySheet = function (id) {
                return $http.get(config.basePath + "GetSalarySheet/" + id);
            };

            this.DeleteSalarySheet = function (id) {
                return $http.get(config.basePath + "DeleteSalarySheet/" + id);
            };
            this.EmployeesInAutoComplete = function (data) {
                return $http.post(config.basePath + "EmployeesInAutoComplete", data);
            };
            this.EmployeesInAutoCompleteWithBS = function (data) {
                return $http.post(config.basePath + "EmployeesInAutoCompleteWithBS", data);
            };
            this.GetNextSalSheetNo = function () {
                return $http.get(config.basePath + "GetNextSalSheetNo");
            };

            //////////////////..Time Sheet..//////////////////

            this.addTimeSheet = function (data) {
                return $http.post(config.basePath + "addTimeSheet", data);
            };

            this.TimeSheetInView = function (data) {
                return $http.post(config.basePath + "TimeSheetInView", data);
            };

            this.GetTimeSheet = function (id) {
                return $http.get(config.basePath + "GetTimeSheet/" + id);
            };

            this.DeleteTimeSheet = function (id) {
                return $http.get(config.basePath + "DeleteTimeSheet/" + id);
            };

            this.GetNextTimeSheetNo = function () {
                return $http.get(config.basePath + "GetNextTimeSheetNo");
            };

            this.GetBackTimeSheet = function (id, type) {
                return $http.get(config.basePath + "GetBackTimeSheet/" + id + "/" + type);
            };

            //////////////////..FPV..//////////////////

            this.GetNextFPVMasterNo = function () {
                return $http.get(config.basePath + "GetNextFPVMasterNo");
            };

            this.addFpvMaster = function (data) {
                return $http.post(config.basePath + "addFpvMaster", data);
            };

            this.FPVSInView = function (data) {
                return $http.post(config.basePath + "FPVSInView", data);
            };

            this.GetFPV = function (id) {
                return $http.get(config.basePath + "GetFPV/" + id);
            };

            this.DeleteFPV = function (id) {
                return $http.get(config.basePath + "DeleteFPV/" + id);
            };
            this.GetBackFPVMaster = function (id, type) {
                return $http.get(config.basePath + "GetBackFPVMaster/" + id + "/" + type);
            };

            this.GetBackCRVMaster = function (id, type) {
                return $http.get(config.basePath + "GetBackCRVMaster/" + id + "/" + type);
            };


            //////////////////..FRV..//////////////////

            this.GetNextFRVMasterNo = function () {
                return $http.get(config.basePath + "GetNextFRVMasterNo");
            };

            this.addFrvMaster = function (data) {
                return $http.post(config.basePath + "addFrvMaster", data);
            };
            this.AddFRVExcel = function (data) {
                return $http.post(config.basePath + "AddFRVExcel", data);
            };

            this.FRVSInView = function (data) {
                return $http.post(config.basePath + "FRVSInView", data);
            };

            this.GetFRV = function (id) {
                return $http.get(config.basePath + "GetFRV/" + id);
            };

            this.DeleteFRV = function (id) {
                return $http.get(config.basePath + "DeleteFRV/" + id);
            };

            //////////////////..JV..//////////////////

            this.GetNextJVMasterNo = function () {
                return $http.get(config.basePath + "GetNextJVMasterNo");
            };

            this.addJvMaster = function (data) {
                return $http.post(config.basePath + "addJvMaster", data);
            };

            this.JVSInView = function (data) {
                return $http.post(config.basePath + "JVSInView", data);
            };

            this.GetJV = function (id) {
                return $http.get(config.basePath + "GetJV/" + id);
            };

            this.DeleteJV = function (id) {
                return $http.get(config.basePath + "DeleteJV/" + id);
            };


            this.GetBackJVMaster = function (id, type) {
                return $http.get(config.basePath + "GetBackJVMaster/" + id + "/" + type);
            };


            this.GetNextCreditNoteNo = function () {
                return $http.get(config.basePath + "GetNextCreditNoteNo");
            };

            this.addCreditNote = function (data) {
                return $http.post(config.basePath + "addCreditNote", data);
            };

            this.CreditNotesInView = function (data) {
                return $http.post(config.basePath + "CreditNotesInView", data);
            };


            this.GetCreditNote = function (id) {
                return $http.get(config.basePath + "GetCreditNote/" + id);
            };

            this.DeleteCreditNote = function (id) {
                return $http.get(config.basePath + "DeleteCreditNote/" + id);
            };


            this.GetBackCreditNote = function (id, type) {
                return $http.get(config.basePath + "GetBackCreditNote/" + id + "/" + type);
            };


            ////////

            this.GetNextDebitNoteNo = function () {
                return $http.get(config.basePath + "GetNextDebitNoteNo");
            };

            this.addDebitNote = function (data) {
                return $http.post(config.basePath + "addDebitNote", data);
            };

            this.DebitNotesInView = function (data) {
                return $http.post(config.basePath + "DebitNotesInView", data);
            };


            this.GetDebitNote = function (id) {
                return $http.get(config.basePath + "GetDebitNote/" + id);
            };

            this.DeleteDebitNote = function (id) {
                return $http.get(config.basePath + "DeleteDebitNote/" + id);
            };


            this.GetBackDebitNote = function (id, type) {
                return $http.get(config.basePath + "GetBackDebitNote/" + id + "/" + type);
            };


            //////////////////.Voucher Docs //////////////////

            this.AddVoucherDoc = function (data) {
                return $http.post(config.basePath + "AddVoucherDoc", data);
            };
            this.DeleteVoucherDoc = function (id) {
                return $http.get(config.basePath + "DeleteVoucherDoc/" + id);
            };
            this.VoucherDocsInView = function (data) {
                return $http.post(config.basePath + "VoucherDocsInView", data);
            };
            this.CostCentersByParentName = function (data) {
                return $http.get(config.basePath + "CostCentersByParentName/" + data);
            };
            this.VoucherDocsByJobno = function (data) {
                return $http.get(config.basePath + "VoucherDocsByJobno/" + data);
            };

            //////////////////////////////////// FinYear ////////////////////////////

            this.FinYearInDropDown = function () {
                return $http.get(config.basePath + "FinYearInDropDown");
            };

            //////////////////////////////////// Opening Balance ////////////////////////////

            this.GetNextOBMasterNo = function () {
                return $http.get(config.basePath + "GetNextOBMasterNo");
            };
            this.OBForCurrentFinancialYear = function () {
                return $http.get(config.basePath + "OBForCurrentFinancialYear");
            };

            this.OpeningBalanceReport = function (data) {
                return $http.post(config.basePath + "OpeningBalanceReport", data);
            };
            this.OBsInView = function (data) {
                return $http.post(config.basePath + "OBsInView", data);
            };

            this.JournalVoucherReport = function (data) {
                return $http.post(config.basePath + "JournalVoucherReport", data);
            };
            this.CreditNoteReport = function (data) {
                return $http.post(config.basePath + "CreditNoteReport", data);
            };
            this.DebitNoteReport = function (data) {
                return $http.post(config.basePath + "DebitNoteReport", data);
            };
            this.TimeSheetReport = function (data) {
                return $http.post(config.basePath + "TimeSheetReport", data);
            };
            this.AdsepntReport = function (data) {
                return $http.post(config.basePath + "AdsepntReport", data);
            };
            this.CompanyExpenseReport = function (data) {
                return $http.post(config.basePath + "CompanyExpenseReport", data);
            };

            this.ChequePVMasterReport = function (data) {
                return $http.post(config.basePath + "ChequePVMasterReport", data);
            };
            this.ChequeRVMasterReport = function (data) {
                return $http.post(config.basePath + "ChequeRVMasterReport", data);
            };
            this.FRVMasterReport = function (data) {
                return $http.post(config.basePath + "FRVMasterReport", data);
            };
            this.FPVMasterReport = function (data) {
                return $http.post(config.basePath + "FPVMasterReport", data);
            };
            this.CRVMasterReport = function (data) {
                return $http.post(config.basePath + "CRVMasterReport", data);
            };
            this.CPVMasterReport = function (data) {
                return $http.post(config.basePath + "CPVMasterReport", data);
            };

            this.GetBackOpeningBalance = function (id, type) {
                return $http.get(config.basePath + "GetBackOpeningBalance/" + id + "/" + type);
            };

            this.GetBackOpeningStock = function (id, type) {
                return $http.get(config.basePath + "GetBackOpeningStock/" + id + "/" + type);
            };


            this.GetCurrentFinOp = function () {
                return $http.get(config.basePath + "GetCurrentFinOp");
            };

            this.AddOpeningBalance = function (data) {
                return $http.post(config.basePath + "AddOpeningBalance", data);
            };


            this.GetOB = function (id) {
                return $http.get(config.basePath + "GetOB/" + id);
            };

            this.DeleteOpeningBalance = function (id) {
                return $http.get(config.basePath + "DeleteOpeningBalance/" + id);
            };

            //////////////////..ChequeRV..//////////////////

            this.GetNextChequeRVMasterNo = function () {
                return $http.get(config.basePath + "GetNextChequeRVMasterNo");
            };

            this.addChequervMaster = function (data) {
                return $http.post(config.basePath + "addChequervMaster", data);
            };

            this.ChequeRVSInView = function (data) {
                return $http.post(config.basePath + "ChequeRVSInView", data);
            };

            this.GetChequeRV = function (id) {
                return $http.get(config.basePath + "GetChequeRV/" + id);
            };

            this.DeleteChequeRV = function (id) {
                return $http.get(config.basePath + "DeleteChequeRV/" + id);
            };

            this.GetBackChequeRVMaster = function (id, type) {
                return $http.get(config.basePath + "GetBackChequeRVMaster/" + id + "/" + type);
            };


            //////////////////..FRV..//////////////////

            this.GetNextChequePVMasterNo = function () {
                return $http.get(config.basePath + "GetNextChequePVMasterNo");
            };
            this.GetBackChequePVMaster = function (id, type) {
                return $http.get(config.basePath + "GetBackChequePVMaster/" + id + "/" + type);
            };

            this.GetBackFRVMaster = function (id, type) {
                return $http.get(config.basePath + "GetBackFRVMaster/" + id + "/" + type);
            };


            this.addChequepvMaster = function (data) {
                return $http.post(config.basePath + "addChequepvMaster", data);
            };

            this.ChequePVSInView = function (data) {
                return $http.post(config.basePath + "ChequePVSInView", data);
            };

            this.GetChequePV = function (id) {
                return $http.get(config.basePath + "GetChequePV/" + id);
            };

            this.DeleteChequePV = function (id) {
                return $http.get(config.basePath + "DeleteChequePV/" + id);
            };

            //////////////////..Company Expense..//////////////////

            this.GetNextCompanyExpenseNo = function () {
                return $http.get(config.basePath + "GetNextCompanyExpenseNo");
            };

            this.GetBackCompanyExpense = function (id, type) {
                return $http.get(config.basePath + "GetBackCompanyExpense/" + id + "/" + type);
            };


            this.GetNextCounterSalesNo = function () {
                return $http.get(config.basePath + "GetNextCounterSalesNo");
            };

            this.addCompanyexpense = function (data) {
                return $http.post(config.basePath + "addCompanyexpense", data);
            };

            this.CompanyExpensesInView = function (data) {
                return $http.post(config.basePath + "CompanyExpensesInView", data);
            };

            this.GetCompanyExpense = function (id) {
                return $http.get(config.basePath + "GetCompanyExpense/" + id);
            };

            this.DeleteCompanyExpense = function (id) {
                return $http.get(config.basePath + "DeleteCompanyExpense/" + id);
            };


            //////////////////..General Ledger..//////////////////

            this.ViewIndividualLedgers = function (voucherId, Type) {
                return $http.get(config.basePath + "ViewIndividualLedgers/" + voucherId + "/" + Type);
            };
            this.ViewIndividualStockLedgers = function (voucherId, Type) {
                return $http.get(config.basePath + "ViewIndividualStockLedgers/" + voucherId + "/" + Type);
            };

            this.StockLedgerByProId = function (id) {
                return $http.get(config.basePath + "StockLedgerByProId/" + id);
            };

            this.getCurrentFinancialYear = function () {
                return $http.get(config.basePath + "getCurrentFinancialYear");
            };

            this.GLInView = function (data) {
                return $http.post(config.basePath + "GLInView", data);
            };

            this.GetTrialBalance = function (data) {
                return $http.post(config.basePath + "GetTrialBalance", data);
            };
            this.JobWiseProfitReport = function (data) {
                return $http.post(config.basePath + "JobWiseProfitReport", data);
            };
            this.JobWiseProfitSummary = function (data) {
                return $http.post(config.basePath + "JobWiseProfitSummary", data);
            };
            this.JobWiseProfitDetails = function (data) {
                return $http.post(config.basePath + "JobWiseProfitDetails", data);
            };

            this.GetBalanceSheet = function (data) {
                return $http.post(config.basePath + "GetBalanceSheet", data);
            };

            this.GetProfitLoss = function (data) {
                return $http.post(config.basePath + "GetProfitLoss", data);
            };
            this.GetProfitLossReport = function (data) {
                return $http.post(config.basePath + "GetProfitLossReport", data);
            };
            this.GetBalanceSheetReport = function (data) {
                return $http.post(config.basePath + "GetBalanceSheetReport", data);
            };

            //////////////////..PDC..//////////////////

            this.PDCsInView = function (data) {
                return $http.post(config.basePath + "PDCsInView", data);
            };

            this.MakeChequeClear = function (data) {
                return $http.post(config.basePath + "MakeChequeClear", data);
            };

            this.MakeChequeBounce = function (data) {
                return $http.post(config.basePath + "MakeChequeBounce", data);
            };
            this.MakeChequeCancel = function (data) {
                return $http.post(config.basePath + "MakeChequeCancel", data);
            };
            this.MakeChequeReplace = function (data) {
                return $http.post(config.basePath + "MakeChequeReplace", data);
            };
            this.MakeChequePartialReplace = function (data) {
                return $http.post(config.basePath + "MakeChequePartialReplace", data);
            };

            this.ReversePDC = function (data) {
                return $http.post(config.basePath + "ReversePDC", data);
            };

            //////////////////..Reconcile Vouchers..//////////////////

            this.ReconcileChequePaysInView = function (data) {
                return $http.post(config.basePath + "ReconcileChequePaysInView", data);
            };

            this.GetReconcileChequePay = function (id) {
                return $http.get(config.basePath + "GetReconcileChequePay/" + id);
            };

            this.ReconcileChequeRecInView = function (data) {
                return $http.post(config.basePath + "ReconcileChequeRecInView", data);
            };

            this.GetReconcileChequeRec = function (id) {
                return $http.get(config.basePath + "GetReconcileChequeRec/" + id);
            };

            this.BounceChequePaysInView = function (data) {
                return $http.post(config.basePath + "BounceChequePaysInView", data);
            };

            this.GetBounceChequePay = function (id) {
                return $http.get(config.basePath + "GetBounceChequePay/" + id);
            };

            this.BounceChequeRecInView = function (data) {
                return $http.post(config.basePath + "BounceChequeRecInView", data);
            };

            this.GetBounceChequeRec = function (id) {
                return $http.get(config.basePath + "GetBounceChequeRec/" + id);
            };


            ////////////////Stock Issue///////////////

            this.AddStockIssue = function (data) {
                return $http.post(config.basePath + "AddStockIssue", data);
            };
            this.StockIssueInView = function (data) {
                return $http.post(config.basePath + "StockIssueInView", data);
            };

            this.DeleteStockIssue = function (id) {
                return $http.get(config.basePath + "DeleteStockIssue/" + id);
            };

            this.getStockIssuebyId = function (id) {
                return $http.get(config.basePath + "getStockIssuebyId/" + id);
            };
            this.GetNextStockIssueNo = function () {
                return $http.get(config.basePath + "GetNextStockIssueNo");
            };

            this.GetBackStockIssue = function (id, type) {
                return $http.get(config.basePath + "GetBackStockIssue/" + id + "/" + type);
            };


            this.StockIssueReport = function (data) {
                return $http.post(config.basePath + "StockIssueReport", data);
            };
            ////////////////Stock JV///////////////

            this.AddStockJV = function (data) {
                return $http.post(config.basePath + "AddStockJV", data);
            };
            this.StockJVInView = function (data) {
                return $http.post(config.basePath + "StockJVInView", data);
            };

            this.DeleteStockJV = function (id) {
                return $http.get(config.basePath + "DeleteStockJV/" + id);
            };

            this.getStockJVbyId = function (id) {
                return $http.get(config.basePath + "getStockJVbyId/" + id);
            };
            this.GetNextStockJVNo = function () {
                return $http.get(config.basePath + "GetNextStockJVNo");
            };

            this.GetBackStockJV = function (id, type) {
                return $http.get(config.basePath + "GetBackStockJV/" + id + "/" + type);
            };

            this.StockJVReport = function (data) {
                return $http.post(config.basePath + "StockJVReport", data);
            };

            ////////////////Stock Recive///////////////

            this.AddStockRecive = function (data) {
                return $http.post(config.basePath + "AddStockRecive", data);
            };
            this.StockReciveInView = function (data) {
                return $http.post(config.basePath + "StockReciveInView", data);
            };

            this.DeleteStockRecive = function (id) {
                return $http.get(config.basePath + "DeleteStockRecive/" + id);
            };

            this.getStockRecivebyId = function (id) {
                return $http.get(config.basePath + "getStockRecivebyId/" + id);
            };
            this.GetNextStockReciveNo = function () {
                return $http.get(config.basePath + "GetNextStockReciveNo");
            };

            this.GetBackStockRecive = function (id, type) {
                return $http.get(config.basePath + "GetBackStockRecive/" + id + "/" + type);
            };


            this.StockReciveReport = function (data) {
                return $http.post(config.basePath + "StockReciveReport", data);
            };
            ////////////////Stock FOC///////////////

            this.AddStockFOC = function (data) {
                return $http.post(config.basePath + "AddStockFOC", data);
            };
            this.StockFOCInView = function (data) {
                return $http.post(config.basePath + "StockFOCInView", data);
            };
            this.DeleteStockFOC = function (id) {
                return $http.get(config.basePath + "DeleteStockFOC/" + id);
            };
            this.getStockFOCbyId = function (id) {
                return $http.get(config.basePath + "getStockFOCbyId/" + id);
            };
            this.GetNextStockFOCNo = function () {
                return $http.get(config.basePath + "GetNextStockFOCNo");
            };
            this.GetBackStockFOC = function (id, type) {
                return $http.get(config.basePath + "GetBackStockFOC/" + id + "/" + type);
            };


            this.StockFOCReport = function (data) {
                return $http.post(config.basePath + "StockFOCReport", data);
            };

            ////////////////Opening Stock///////////////

            this.AddOpeningStock = function (data) {
                return $http.post(config.basePath + "AddOpeningStock", data);
            };
            this.OpeningStockInView = function (data) {
                return $http.post(config.basePath + "OpeningStockInView", data);
            };


            this.DeleteOpeningStock = function (id) {
                return $http.get(config.basePath + "DeleteOpeningStock/" + id);
            };

            this.getOpeningStockbyId = function (id) {
                return $http.get(config.basePath + "getOpeningStockbyId/" + id);
            };
            this.GetNextStockOpeningStock = function () {
                return $http.get(config.basePath + "GetNextStockOpeningStock");
            };
            this.getOpeningCurrentFinYear = function () {
                return $http.get(config.basePath + "getOpeningCurrentFinYear");
            };

            this.OpeningStockReport = function (data) {
                return $http.post(config.basePath + "OpeningStockReport", data);
            };

            //////////////// dashboards ///////////////////

            this.GetHomeData = function () {
                return $http.post(config.basePath + "GetHomeData");
            };
            this.MainDashboardCounts = function () {
                return $http.post(config.basePath + "MainDashboardCounts");
            };
            this.PurchaseDashboardCounts = function () {
                return $http.post(config.basePath + "PurchaseDashboardCounts");
            };
            this.SalesDashboardCounts = function () {
                return $http.post(config.basePath + "SalesDashboardCounts");
            };
            this.BrokerSalesChart = function () {
                return $http.post(config.basePath + "BrokerSalesChart");
            };

            this.EmployeeSalesChart = function () {
                return $http.post(config.basePath + "EmployeeSalesChart");
            };
            this.FinancialDashboardCounts = function () {
                return $http.post(config.basePath + "FinancialDashboardCounts");
            };
            this.Top10Customers = function (data) {
                return $http.post(config.basePath + "Top10Customers", data);
            };
            this.Top10Suppliers = function (data) {
                return $http.post(config.basePath + "Top10Suppliers", data);
            };
            this.MostPurchaseItems = function (data) {
                return $http.post(config.basePath + "MostPurchaseItems", data);
            };
            this.MonthlyPurchaseChart = function (data) {
                return $http.post(config.basePath + "MonthlyPurchaseChart", data);
            };
            this.MonthlySalesChart = function (data) {
                return $http.post(config.basePath + "MonthlySalesChart", data);
            };
            this.BuildingUnitsChart = function (data) {
                return $http.post(config.basePath + "BuildingUnitsChart", data);
            };
            this.TopSellingProductChart = function (data) {
                return $http.post(config.basePath + "TopSellingProductChart", data);
            };
            this.SalesOrdersInHome = function () {
                return $http.get(config.basePath + "SalesOrdersInHome");
            };
            this.RealestateDashCounts = function () {
                return $http.post(config.basePath + "RealestateDashCounts");
            };
            this.SalePurchaseAnalysis = function (data) {
                return $http.post(config.basePath + "SalePurchaseAnalysis", data);
            };
            this.MostSellingItems = function (data) {
                return $http.post(config.basePath + "MostSellingItems", data);
            };
            this.MostPurchaseItemsGroup = function (data) {
                return $http.post(config.basePath + "MostPurchaseItemsGroup", data);
            };
            this.MostSellingItemsGroup = function (data) {
                return $http.post(config.basePath + "MostSellingItemsGroup", data);
            };
            this.TraceInKendo = function (data) {
                return $http.post(config.basePath + "TraceInKendo", data);
            };
            this.Updatetraces = function (data) {
                return $http.post(config.basePath + "Updatetraces", data);
            };
            this.UpdatetraceNumber = function (data) {
                return $http.post(config.basePath + "UpdatetraceNumber", data);
            };
            this.VacantUnitsChart = function (data) {
                return $http.post(config.basePath + "VacantUnitsChart", data);
            };
            this.UsingUnitsChart = function (data) {
                return $http.post(config.basePath + "UsingUnitsChart", data);
            };
            this.MostSellingUnitTypes = function (data) {
                return $http.post(config.basePath + "MostSellingUnitTypes", data);
            };

            //////////////// SMS ///////////////////

            this.GetSMSTemplates = function () {
                return $http.get(config.basePath + "GetSMSTemplates");
            };
            this.UpdateSMSTemplate = function (data) {
                return $http.post(config.basePath + "UpdateSMSTemplate", data);
            };

            //////////////// voucher Summary and Detail reports ///////////////////

            this.PrintSalesInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintSalesInvoiceReport", data);
            };
            this.PrintSalesInvoice2Report = function (data) {
                return $http.post(config.basePath + "PrintSalesInvoice2Report", data);
            };
            this.PrintSalesInvoice3Report = function (data) {
                return $http.post(config.basePath + "PrintSalesInvoice3Report", data);
            };
            this.PrintSalesInvoice4Report = function (data) {
                return $http.post(config.basePath + "PrintSalesInvoice4Report", data);
            };

            this.PrintSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesInvoiceSummaryReport", data);
            };
            this.PrintSalesInvoice2SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesInvoice2SummaryReport", data);
            };
            this.PrintSalesInvoice3SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesInvoice3SummaryReport", data);
            };
            this.PrintSalesInvoice4SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesInvoice4SummaryReport", data);
            };

            this.PrintCreditNoteSRReport = function (data) {
                return $http.post(config.basePath + "PrintCreditNoteSRReport", data);
            };
            this.PrintCreditNoteSRSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintCreditNoteSRSummaryReport", data);
            };

            this.PrintPendingPurchaseReturnSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseReturnSummaryReport", data);
            };

            this.PrintPurchaseReturnSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseReturnSummaryReport", data);
            };
            this.PrintPendingIndPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingIndPurchaseInvoiceSummaryReport", data);
            };

            this.PrintIndPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintIndPurchaseInvoiceSummaryReport", data);
            };
            this.PrintIndSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintIndSalesInvoiceSummaryReport", data);
            };
            this.PrintIndSalesInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintIndSalesInvoiceReport", data);
            };

            this.PrintExpPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintExpPurchaseInvoiceSummaryReport", data);
            };
            this.PrintPendingImpPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingImpPurchaseInvoiceSummaryReport", data);
            };

            this.PrintImpPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintImpPurchaseInvoiceSummaryReport", data);
            };

            this.PrintPendingExpPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingExpPurchaseInvoiceSummaryReport", data);
            };

            this.PrintPendingDirPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingDirPurchaseInvoiceSummaryReport", data);
            };

            this.PrintDirPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintDirPurchaseInvoiceSummaryReport", data);
            };
            this.PrintPendingPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseInvoiceSummaryReport", data);
            };
            this.PrintPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseInvoiceSummaryReport", data);
            };
            this.PrintPendingGoodsReceivedSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingGoodsReceivedSummaryReport", data);
            };
            this.PrintGoodsReceivedSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintGoodsReceivedSummaryReport", data);
            };
            this.PrintPendingPurchaseOrderSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseOrderSummaryReport", data);
            };
            this.PrintPurchaseOrderSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseOrderSummaryReport", data);
            };
            this.PrintPendingPurchaseQuotationSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseQuotationSummaryReport", data);
            };
            this.PrintPurchaseQuotationSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseQuotationSummaryReport", data);
            };
            this.PrintPendingPurchaseEnquirySummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseEnquirySummaryReport", data);
            };
            this.PrintPurchaseEnquirySummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseEnquirySummaryReport", data);
            };

            this.PrintPendingMaterialRequestSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingMaterialRequestSummaryReport", data);
            };
            this.PrintMaterialRequestSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintMaterialRequestSummaryReport", data);
            };

            this.PrintPendingPurchaseRequestSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseRequestSummaryReport", data);
            };
            this.PrintPurchaseRequestSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseRequestSummaryReport", data);
            };
            this.PrintPendingIndPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPendingIndPurchaseInvoiceReport", data);
            };
            this.PrintIndPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintIndPurchaseInvoiceReport", data);
            };
            this.PrintPendingPurchaseReturnReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseReturnReport", data);
            };
            this.PrintPurchaseReturnReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseReturnReport", data);
            };
            this.PrintPendingExpPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPendingExpPurchaseInvoiceReport", data);
            };
            this.PrintExpPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintExpPurchaseInvoiceReport", data);
            };

            this.PrintPendingImpPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPendingImpPurchaseInvoiceReport", data);
            };
            this.PrintImpPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintImpPurchaseInvoiceReport", data);
            };
            this.PrintPendingDirPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPendingDirPurchaseInvoiceReport", data);
            };
            this.PrintDirPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintDirPurchaseInvoiceReport", data);
            };
            this.PrintPendingPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseInvoiceReport", data);
            };
            this.PrintPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseInvoiceReport", data);
            };
            this.PrintPendingGoodsReceivedReport = function (data) {
                return $http.post(config.basePath + "PrintPendingGoodsReceivedReport", data);
            };
            this.PrintGoodsReceivedReport = function (data) {
                return $http.post(config.basePath + "PrintGoodsReceivedReport", data);
            };
            this.PrintPendingPurchaseOrderReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseOrderReport", data);
            };
            this.PrintPurchaseOrderReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseOrderReport", data);
            };
            this.PrintPendingPurchaseQuotationReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseQuotationReport", data);
            };
            this.PrintPurchaseQuotationReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseQuotationReport", data);
            };
            this.PrintPendingPurchaseEnquiryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseEnquiryReport", data);
            };
            this.PrintPurchaseEnquiryReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseEnquiryReport", data);
            };

            this.PrintPendingMaterialRequestReport = function (data) {
                return $http.post(config.basePath + "PrintPendingMaterialRequestReport", data);
            };
            this.PrintMaterialRequestReport = function (data) {
                return $http.post(config.basePath + "PrintMaterialRequestReport", data);
            };

            this.PrintPendingPurchaseRequestReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPurchaseRequestReport", data);
            };
            this.PrintPurchaseRequestReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseRequestReport", data);
            };
            this.PrintPendingSalesReturnSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingSalesReturnSummaryReport", data);
            };
            this.PrintPendingSalesReturnReport = function (data) {
                return $http.post(config.basePath + "PrintPendingSalesReturnReport", data);
            };
            this.PrintSalesReturnSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesReturnSummaryReport", data);
            };
            this.PrintPendingIndSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingIndSalesInvoiceSummaryReport", data);
            };
            this.PrintPendingIndSalesInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPendingIndSalesInvoiceReport", data);
            };

            this.PrintSalesReturnReport = function (data) {
                return $http.post(config.basePath + "PrintSalesReturnReport", data);
            };
            this.PrintPendingProformaInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingProformaInvoiceSummaryReport", data);
            };
            this.PrintPendingProformaInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPendingProformaInvoiceReport", data);
            };
            this.PrintProformaInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintProformaInvoiceSummaryReport", data);
            };
            this.PrintProformaInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintProformaInvoiceReport", data);
            };
            this.PrintPendingExpSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingExpSalesInvoiceSummaryReport", data);
            };
            this.PrintPendingExpSalesInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPendingExpSalesInvoiceReport", data);
            };
            this.PrintExpSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintExpSalesInvoiceSummaryReport", data);
            };
            this.PrintExpSalesInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintExpSalesInvoiceReport", data);
            };
            this.PrintPendingDirSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingDirSalesInvoiceSummaryReport", data);
            };
            this.PrintPendingDirSalesInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPendingDirSalesInvoiceReport", data);
            };
            this.PrintDirSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintDirSalesInvoiceSummaryReport", data);
            };
            this.PrintDirSalesInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintDirSalesInvoiceReport", data);
            };
            this.PrintPendingDeliveryNoteSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingDeliveryNoteSummaryReport", data);
            };
            this.PrintPendingDeliveryNoteReport = function (data) {
                return $http.post(config.basePath + "PrintPendingDeliveryNoteReport", data);
            };
            this.PrintDeliveryNoteSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintDeliveryNoteSummaryReport", data);
            };
            this.PrintDeliveryNote2SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintDeliveryNote2SummaryReport", data);
            };
            this.PrintDeliveryNote3SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintDeliveryNoteSummaryReport", data);
            };
            this.PrintDeliveryNote4SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintDeliveryNote4SummaryReport", data);
            };

            this.PrintDeliveryNoteReport = function (data) {
                return $http.post(config.basePath + "PrintDeliveryNoteReport", data);
            };
            this.PrintDeliveryNote2Report = function (data) {
                return $http.post(config.basePath + "PrintDeliveryNote2Report", data);
            };
            this.PrintDeliveryNote3Report = function (data) {
                return $http.post(config.basePath + "PrintDeliveryNote3Report", data);
            };
            this.PrintDeliveryNote4Report = function (data) {
                return $http.post(config.basePath + "PrintDeliveryNote4Report", data);
            };

            this.PrintPendingPackingListSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPackingListSummaryReport", data);
            };
            this.WorkOrderPendingSummaryReport = function (data) {
                return $http.post(config.basePath + "WorkOrderPendingSummaryReport", data);
            };
            this.PrintPendingPackingListReport = function (data) {
                return $http.post(config.basePath + "PrintPendingPackingListReport", data);
            };
            this.PrintPackingListSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPackingListSummaryReport", data);
            };
            this.PrintPackingListReport = function (data) {
                return $http.post(config.basePath + "PrintPackingListReport", data);
            };
            this.PrintPendingSalesOrderSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingSalesOrderSummaryReport", data);
            };
            this.PrintPendingSalesOrderReport = function (data) {
                return $http.post(config.basePath + "PrintPendingSalesOrderReport", data);
            };
            this.PrintSalesOrderSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesOrderSummaryReport", data);
            };
            this.PrintSalesOrder2SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesOrder2SummaryReport", data);
            };
            this.PrintSalesOrder3SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesOrder3SummaryReport", data);
            };
            this.PrintSalesOrder4SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesOrder4SummaryReport", data);
            };

            this.PrintSalesOrderReport = function (data) {
                return $http.post(config.basePath + "PrintSalesOrderReport", data);
            };
            this.PrintSalesOrder2Report = function (data) {
                return $http.post(config.basePath + "PrintSalesOrder2Report", data);
            };
            this.PrintSalesOrder3Report = function (data) {
                return $http.post(config.basePath + "PrintSalesOrder3Report", data);
            };
            this.PrintSalesOrder4Report = function (data) {
                return $http.post(config.basePath + "PrintSalesOrder4Report", data);
            };

            this.PrintPendingSalesQuotationSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingSalesQuotationSummaryReport", data);
            };
            this.PrintPendingSalesQuotationReport = function (data) {
                return $http.post(config.basePath + "PrintPendingSalesQuotationReport", data);
            };
            this.PrintSalesQuotationSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesQuotationSummaryReport", data);
            };

            this.PrintSalesQuotation2SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesQuotation2SummaryReport", data);
            };

            this.PrintSalesQuotation3SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesQuotation3SummaryReport", data);
            };

            this.PrintSalesQuotation4SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesQuotation4SummaryReport", data);
            };
            this.PrintSalesQuotationReport = function (data) {
                return $http.post(config.basePath + "PrintSalesQuotationReport", data);
            };

            this.PrintSalesQuotation2Report = function (data) {
                return $http.post(config.basePath + "PrintSalesQuotation2Report", data);
            };
            this.PrintSalesQuotation3Report = function (data) {
                return $http.post(config.basePath + "PrintSalesQuotation3Report", data);
            };
            this.PrintSalesQuotation4Report = function (data) {
                return $http.post(config.basePath + "PrintSalesQuotation4Report", data);
            };
            this.PrintPendingSalesEnquirySummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingSalesEnquirySummaryReport", data);
            };
            this.PrintPendingSalesEnquiryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingSalesEnquiryReport", data);
            };
            this.PrintSalesEnquirySummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesEnquirySummaryReport", data);
            };

            this.PrintSalesEnquiry2SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesEnquiry2SummaryReport", data);
            };

            this.PrintSalesEnquiry3SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesEnquiry3SummaryReport", data);
            };
            this.PrintSalesEnquiry4SummaryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesEnquiry4SummaryReport", data);
            };


            this.PrintSalesEnquiryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesEnquiryReport", data);
            };

            this.PrintSalesEnquiry3Report = function (data) {
                return $http.post(config.basePath + "PrintSalesEnquiry3Report", data);
            };
            this.PrintSalesEnquiry4Report = function (data) {
                return $http.post(config.basePath + "PrintSalesEnquiry4Report", data);
            };

            this.PrintSalesEnquiry2Report = function (data) {
                return $http.post(config.basePath + "PrintSalesEnquiry2Report", data);
            };
            this.PrintPendingSalesInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPendingSalesInvoiceReport", data);
            };
            this.PrintPendingSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintPendingSalesInvoiceSummaryReport", data);
            };


            this.PrintTempTrailBalncePrint = function (data) {
                return $http.post(config.basePath + "PrintTempTrailBalncePrint", data);
            };
            this.PrintTempBalanceSheetPrint = function (data) {
                return $http.post(config.basePath + "PrintTempBalanceSheetPrint", data);
            };
            this.PrintTempProfitAndLossPrint = function (data) {
                return $http.post(config.basePath + "PrintTempProfitAndLossPrint", data);
            };

            this.PrintGeneralLedgerReport = function (data) {
                return $http.post(config.basePath + "PrintGeneralLedgerReport", data);
            };

            this.PendingSalesInvoiceInReport = function (data) {
                return $http.post(config.basePath + "PendingSalesInvoiceInReport", data);
            };

            this.PendingSalesInvoiceInSummaryReport = function (data) {
                return $http.post(config.basePath + "PendingSalesInvoiceInSummaryReport", data);
            };

            this.PrintVatReport = function (data) {
                return $http.post(config.basePath + "PrintVatReport", data);
            };


            this.OverDueDirSalesInvoiceInReport = function (data) {
                return $http.post(config.basePath + "OverDueDirSalesInvoiceInReport", data);
            };
            this.OverDueExpSalesInvoiceInReport = function (data) {
                return $http.post(config.basePath + "OverDueExpSalesInvoiceInReport", data);
            };
            this.OverDueSalesInvoiceInReport = function (data) {
                return $http.post(config.basePath + "OverDueSalesInvoiceInReport", data);
            };

            this.PendingGoodsReceivedInReport = function (data) {
                return $http.post(config.basePath + "PendingGoodsReceivedInReport", data);
            };



            this.PendingExpPurchaseInvoicesInReport = function (data) {
                return $http.post(config.basePath + "PendingExpPurchaseInvoicesInReport", data);
            };

            this.PendingPurchaseReturnsInReport = function (data) {
                return $http.post(config.basePath + "PendingPurchaseReturnsInReport", data);
            };

            this.PendingImpPurchaseInvoicesInReport = function (data) {
                return $http.post(config.basePath + "PendingImpPurchaseInvoicesInReport", data);
            };

            this.PendingPurchaseInvoicesInReport = function (data) {
                return $http.post(config.basePath + "PendingPurchaseInvoicesInReport", data);
            };

            this.PendingPurchaseOrderInReport = function (data) {
                return $http.post(config.basePath + "PendingPurchaseOrderInReport", data);
            };

            this.PendingPurchaseQuotationInReport = function (data) {
                return $http.post(config.basePath + "PendingPurchaseQuotationInReport", data);
            };

            this.PendingMaterialRequestInReport = function (data) {
                return $http.post(config.basePath + "PendingMaterialRequestInReport", data);
            };


            this.PendingPurchaseRequestInReport = function (data) {
                return $http.post(config.basePath + "PendingPurchaseRequestInReport", data);
            };

            this.PendingPurchaseEnquiryInReport = function (data) {
                return $http.post(config.basePath + "PendingPurchaseEnquiryInReport", data);
            };





            this.PrintSalesEnquiryReport = function (data) {
                return $http.post(config.basePath + "PrintSalesEnquiryReport", data);
            };


            this.PrintSalesQuotationReport = function (data) {
                return $http.post(config.basePath + "PrintSalesQuotationReport", data);
            };


            this.PrintSalesOrderReport = function (data) {
                return $http.post(config.basePath + "PrintSalesOrderReport", data);
            };


            this.PrintPorfomaSalesInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPorfomaSalesInvoiceReport", data);
            };
            this.PrintDirectSalesInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintDirectSalesInvoiceReport", data);
            };
            this.PrintExportSalesInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintExportSalesInvoiceReport", data);
            };
            this.ExpPurchaseInvoicesInReport = function (data) {
                return $http.post(config.basePath + "ExpPurchaseInvoicesInReport", data);
            };

            this.PrintSalesReturnReport = function (data) {
                return $http.post(config.basePath + "PrintSalesReturnReport", data);
            };

            this.PrintPurchaseEnquiryReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseEnquiryReport", data);
            };
            this.PurchaseEnquiryInReport = function (data) {
                return $http.post(config.basePath + "PurchaseEnquiryInReport", data);
            };
            this.PurchaseRequestInReport = function (data) {
                return $http.post(config.basePath + "PurchaseRequestInReport", data);
            };
            this.MaterialRequestInReport = function (data) {
                return $http.post(config.basePath + "MaterialRequestInReport", data);
            };






            this.PendingOverDueDirSalesInvoiceInSummaryReport = function (data) {
                return $http.post(config.basePath + "PendingOverDueDirSalesInvoiceInSummaryReport", data);
            };

            this.OverDueDirSalesInvoiceInSummaryReport = function (data) {
                return $http.post(config.basePath + "OverDueDirSalesInvoiceInSummaryReport", data);
            };


            this.PendingOverDueExpSalesInvoiceInSummaryReport = function (data) {
                return $http.post(config.basePath + "PendingOverDueExpSalesInvoiceInSummaryReport", data);
            };

            this.OverDueExpSalesInvoiceInSummaryReport = function (data) {
                return $http.post(config.basePath + "OverDueExpSalesInvoiceInSummaryReport", data);
            };


            this.PendingOverDueIndSalesInvoiceInSummaryReport = function (data) {
                return $http.post(config.basePath + "PendingOverDueIndSalesInvoiceInSummaryReport", data);
            };
            this.OverDueIndSalesInvoiceInSummaryReport = function (data) {
                return $http.post(config.basePath + "OverDueIndSalesInvoiceInSummaryReport", data);
            };



            this.PendingOverDueSalesInvoiceInSummaryReport = function (data) {
                return $http.post(config.basePath + "PendingOverDueSalesInvoiceInSummaryReport", data);
            };
            this.OverDueSalesInvoiceInSummaryReport = function (data) {
                return $http.post(config.basePath + "OverDueSalesInvoiceInSummaryReport", data);
            };





            this.PrintPurchaseQuotationReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseQuotationReport", data);
            };
            this.PurchaseQuotationInReport = function (data) {
                return $http.post(config.basePath + "PurchaseQuotationInReport", data);
            };

            this.PrintPurchaseOrderReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseOrderReport", data);
            };
            this.PurchaseOrderInReport = function (data) {
                return $http.post(config.basePath + "PurchaseOrderInReport", data);
            };
            this.PrintPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseInvoiceReport", data);
            };
            this.PurchaseInvoicesInReport = function (data) {
                return $http.post(config.basePath + "PurchaseInvoicesInReport", data);
            };

            this.PrintDirPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintDirPurchaseInvoiceReport", data);
            };

            this.PrintImpPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintImpPurchaseInvoiceReport", data);
            };
            this.ImpPurchaseInvoicesInReport = function (data) {
                return $http.post(config.basePath + "ImpPurchaseInvoicesInReport", data);
            };

            this.PrintExpPurchaseInvoiceReport = function (data) {
                return $http.post(config.basePath + "PrintExpPurchaseInvoiceReport", data);
            };
            this.ExpPurchaseInvoicesInReport = function (data) {
                return $http.post(config.basePath + "ExpPurchaseInvoicesInReport", data);
            };

            this.PrintPurchaseReturnReport = function (data) {
                return $http.post(config.basePath + "PrintPurchaseReturnReport", data);
            };
            this.PurchaseReturnsInReport = function (data) {
                return $http.post(config.basePath + "PurchaseReturnsInReport", data);
            };

            this.PrintGoodsReceivedReport = function (data) {
                return $http.post(config.basePath + "PrintGoodsReceivedReport", data);
            };
            this.GoodsReceivedInReport = function (data) {
                return $http.post(config.basePath + "GoodsReceivedInReport", data);
            };
            this.PrintBillWiseOutStandingReport = function (data) {
                return $http.post(config.basePath + "PrintBillWiseOutStandingReport", data);
            };


            //////////////// stock ///////////////////

            this.StockList = function (data) {
                return $http.post(config.basePath + "StockList", data);
            };
            this.WarehouseStockList = function (data) {
                return $http.post(config.basePath + "WarehouseStockList", data);
            };
            this.StockLedger = function (data) {
                return $http.post(config.basePath + "StockLedger", data);
            };


            this.AssetList = function (data) {
                return $http.post(config.basePath + "AssetList", data);
            };

            this.ServiceList = function (data) {
                return $http.post(config.basePath + "ServiceList", data);
            };
            this.BatchLedger = function (data) {
                return $http.post(config.basePath + "BatchLedger", data);
            };

            this.GetProductBatches = function (id) {
                return $http.get(config.basePath + "GetProductBatches/" + id);
            };
            this.RecalculateProductStockBalance = function (id) {
                return $http.get(config.basePath + "RecalculateProductStockBalance/" + id);
            };

            this.GetProductBatchesSales = function (id) {
                return $http.get(config.basePath + "GetProductBatchesSales/" + id);
            };
            this.GetProductBatchesSalesEdit = function (id, id2, type, id3) {
                return $http.get(config.basePath + "GetProductBatchesSalesEdit/" + id + "/" + id2 + "/" + type + "/" + id3);
            };

            this.GetWarehouseStockBalance = function (proid, wareId) {
                return $http.get(config.basePath + "GetWarehouseStockBalance/" + proid + "/" + wareId);
            };

            //////////////// Users ///////////////////

            this.SaveUser = function (data) {
                return $http.post(config.basePath + "SaveUser", data);
            };

            this.UsersInGrid = function (data) {
                return $http.post(config.basePath + "UsersInGrid", data);
            };

            this.EmployeesInNewUserDropdown = function () {
                return $http.get(config.basePath + "EmployeesInNewUserDropdown");
            };

            this.BlockUser = function (id) {
                return $http.get(config.basePath + "BlockUser/" + id);
            };



            //////////////// User Page Role ///////////////////

            this.AddUserPageRole = function (data) {
                return $http.post(config.basePath + "AddUserPageRole", data);
            };

            this.AddUserPageRoleMapping = function (data) {
                return $http.post(config.basePath + "AddUserPageRoleMapping", data);
            };

            this.SaveUserButtonRole = function (data) {
                return $http.post(config.basePath + "SaveUserButtonRole", data);
            };


            this.CheckUserPageAccess = function (data) {
                return $http.post(config.basePath + "CheckUserPageAccess", data);
            };
            this.AddBulkCustomer = function (data) {
                return $http.post(config.basePath + "AddBulkCustomer", data);
            };

            this.GetEmployeePageRoleDetails = function (id) {
                return $http.get(config.basePath + "GetEmployeePageRoleDetails/" + id);
            };
            this.GetPageRoleMappingDetails = function (id) {
                return $http.get(config.basePath + "GetPageRoleMappingDetails/" + id);
            };
            this.EmployeeUsersInDropDown = function () {
                return $http.get(config.basePath + "EmployeeUsersInDropDown");
            };





            //////////////// Recipe ///////////////////

            this.AddRecipe = function (data) {
                return $http.post(config.basePath + "AddRecipe", data);
            };
            this.RecipesInList = function (id) {
                return $http.get(config.basePath + "RecipesInList/" + id);
            };
            this.DeleteRecipe = function (id) {
                return $http.get(config.basePath + "DeleteRecipe/" + id);
            };




            //////////////////..Sales Invoice A..//////////////////
            this.GetNextSalesInvoiceANo = function () {
                return $http.get(config.basePath + "GetNextSalesInvoiceANo");
            };


            this.AddSalesInvoiceA = function (data) {
                return $http.post(config.basePath + "AddSalesInvoiceA", data);
            };

            this.getSalesInvoiceAbyId = function (id) {
                return $http.get(config.basePath + "getSalesInvoiceAbyId/" + id);
            };
            this.SalesInvoiceAInView = function (data) {
                return $http.post(config.basePath + "SalesInvoiceAInView", data);
            };

            this.SalesInvoiceAInReport = function (data) {
                return $http.post(config.basePath + "SalesInvoiceAInReport", data);
            };

            this.DeleteSalesInvoiceA = function (id) {
                return $http.get(config.basePath + "DeleteSalesInvoiceA/" + id);
            };
            this.getOldSalesByCustomerProductA = function (id, cusId) {
                return $http.get(config.basePath + "getOldSalesByCustomerProductA/" + id + "/" + cusId);
            };

            //////////////////..Sales Invoice B..//////////////////

            this.GetNextSalesInvoiceBNo = function () {
                return $http.get(config.basePath + "GetNextSalesInvoiceBNo");
            };

            this.AddSalesInvoiceB = function (data) {
                return $http.post(config.basePath + "AddSalesInvoiceB", data);
            };

            this.getSalesInvoiceBbyId = function (id) {
                return $http.get(config.basePath + "getSalesInvoiceBbyId/" + id);
            };
            this.SalesInvoiceBInView = function (data) {
                return $http.post(config.basePath + "SalesInvoiceBInView", data);
            };

            this.SalesInvoiceBInReport = function (data) {
                return $http.post(config.basePath + "SalesInvoiceBInReport", data);
            };

            this.DeleteSalesInvoiceB = function (id) {
                return $http.get(config.basePath + "DeleteSalesInvoiceB/" + id);
            };
            this.getOldSalesByCustomerProductA = function (id, cusId) {
                return $http.get(config.basePath + "getOldSalesByCustomerProductA/" + id + "/" + cusId);
            };


            //////////////////..Sales Invoice C..//////////////////

            this.GetNextSalesInvoiceCNo = function () {
                return $http.get(config.basePath + "GetNextSalesInvoiceCNo");
            };

            this.AddSalesInvoiceC = function (data) {
                return $http.post(config.basePath + "AddSalesInvoiceC", data);
            };

            this.getSalesInvoiceCbyId = function (id) {
                return $http.get(config.basePath + "getSalesInvoiceCbyId/" + id);
            };
            this.SalesInvoiceCInView = function (data) {
                return $http.post(config.basePath + "SalesInvoiceCInView", data);
            };

            this.SalesInvoiceCInReport = function (data) {
                return $http.post(config.basePath + "SalesInvoiceCInReport", data);
            };

            this.DeleteSalesInvoiceC = function (id) {
                return $http.get(config.basePath + "DeleteSalesInvoiceC/" + id);
            };
            this.getOldSalesByCustomerProductA = function (id, cusId) {
                return $http.get(config.basePath + "getOldSalesByCustomerProductA/" + id + "/" + cusId);
            };

            //////////////////..Sales Invoice D..//////////////////


            this.GetNextSalesInvoiceDNo = function () {
                return $http.get(config.basePath + "GetNextSalesInvoiceDNo");
            };
            this.AddSalesInvoiceD = function (data) {
                return $http.post(config.basePath + "AddSalesInvoiceD", data);
            };

            this.getSalesInvoiceDbyId = function (id) {
                return $http.get(config.basePath + "getSalesInvoiceDbyId/" + id);
            };
            this.SalesInvoiceDInView = function (data) {
                return $http.post(config.basePath + "SalesInvoiceDInView", data);
            };

            this.SalesInvoiceDInReport = function (data) {
                return $http.post(config.basePath + "SalesInvoiceDInReport", data);
            };

            this.DeleteSalesInvoiceD = function (id) {
                return $http.get(config.basePath + "DeleteSalesInvoiceD/" + id);
            };
            this.getOldSalesByCustomerProductA = function (id, cusId) {
                return $http.get(config.basePath + "getOldSalesByCustomerProductA/" + id + "/" + cusId);
            };

            //////////////////..Sales Invoice E..//////////////////

            this.GetNextSalesInvoiceENo = function () {
                return $http.get(config.basePath + "GetNextSalesInvoiceENo");
            };

            this.AddSalesInvoiceE = function (data) {
                return $http.post(config.basePath + "AddSalesInvoiceE", data);
            };

            this.getSalesInvoiceEbyId = function (id) {
                return $http.get(config.basePath + "getSalesInvoiceEbyId/" + id);
            };
            this.SalesInvoiceEInView = function (data) {
                return $http.post(config.basePath + "SalesInvoiceEInView", data);
            };

            this.SalesInvoiceEInReport = function (data) {
                return $http.post(config.basePath + "SalesInvoiceEInReport", data);
            };

            this.DeleteSalesInvoiceE = function (id) {
                return $http.get(config.basePath + "DeleteSalesInvoiceE/" + id);
            };
            this.getOldSalesByCustomerProductA = function (id, cusId) {
                return $http.get(config.basePath + "getOldSalesByCustomerProductA/" + id + "/" + cusId);
            };




            //////////////////.Building..//////////////////

            this.BuildingsInView = function (data) {
                return $http.post(config.basePath + "BuildingsInView", data);
            };
            this.AddBuilding = function (data) {
                return $http.post(config.basePath + "AddBuilding", data);
            };
            this.EmployeesInDropdown = function () {
                return $http.get(config.basePath + "EmployeesInDropdown");
            };
            this.BuildingInDropdown = function () {
                return $http.get(config.basePath + "BuildingInDropdown");
            };
            this.BuildingsInSummary = function (data) {
                return $http.post(config.basePath + "BuildingsInSummary", data);
            };
            this.DeleteBuilding = function (id) {
                return $http.get(config.basePath + "DeleteBuilding/" + id);
            };
            this.BuildingById = function (id) {
                return $http.get(config.basePath + "BuildingById/" + id);
            };

            //////////////////.Flat..//////////////////

            this.FlatInView = function (data) {
                return $http.post(config.basePath + "FlatInView", data);
            };


            this.AddFlat = function (data) {
                return $http.post(config.basePath + "AddFlat", data);
            };

            this.DeleteFlat = function (id) {
                return $http.get(config.basePath + "DeleteFlat/" + id);
            };

            this.FlatById = function (id) {
                return $http.get(config.basePath + "FlatById/" + id);
            };

            this.FlatsByBuildingId = function (id) {
                return $http.get(config.basePath + "FlatsByBuildingId/" + id);
            };

            this.FlatInDropdown = function () {
                return $http.get(config.basePath + "FlatInDropdown");
            };

            this.VacantFlatsInHome = function () {
                return $http.get(config.basePath + "VacantFlatsInHome");
            };

            this.VacantFlatsByBuildingId = function (id) {
                return $http.get(config.basePath + "VacantFlatsByBuildingId/" + id);
            };

            this.FlatsInReport = function (data) {
                return $http.post(config.basePath + "FlatsInReport", data);
            };


            this.PrintFlats = function () {
                return $http.get(config.basePath + "PrintFlats");
            };



            //////////////////.Contract..//////////////////


            this.GetNextContractNo = function () {
                return $http.get(config.basePath + "GetNextContractNo");
            };

            this.ContractsInView = function (data) {
                return $http.post(config.basePath + "ContractsInView", data);
            };

            this.ContractsInReport = function (data) {
                return $http.post(config.basePath + "ContractsInReport", data);
            };

            this.AddContract = function (data) {
                return $http.post(config.basePath + "AddContract", data);
            };

            this.contractInAutoComplete = function (data) {
                return $http.post(config.basePath + "contractInAutoComplete", data);
            };
            this.PrintContractReport = function (data) {
                return $http.post(config.basePath + "PrintContractReport", data);
            };
            this.PrintFlatReport = function (data) {
                return $http.post(config.basePath + "PrintFlatReport", data);
            };

            this.BuildingInDropdown = function () {
                return $http.get(config.basePath + "BuildingInDropdown");
            };

            this.EndingContracts = function () {
                return $http.get(config.basePath + "EndingContracts");
            };

            this.NewContracts = function () {
                return $http.get(config.basePath + "NewContracts");
            };

            this.DeleteContract = function (id) {
                return $http.get(config.basePath + "DeleteContract/" + id);
            };

            this.CloseContract = function (id) {
                return $http.get(config.basePath + "CloseContract/" + id);
            };

            this.ContractById = function (id) {
                return $http.get(config.basePath + "ContractById/" + id);
            };

            this.PrintContract = function (id) {
                return $http.get(config.basePath + "PrintContract/" + id);
            };

            //////////////////.Contract Invoice //////////////////


            this.GetNextContractInvoiceNo = function () {
                return $http.get(config.basePath + "GetNextContractInvoiceNo");
            };

            this.AddContractInvoice = function (data) {
                return $http.post(config.basePath + "AddContractInvoice", data);
            };

            this.getContractInvoicebyId = function (id) {
                return $http.get(config.basePath + "getContractInvoicebyId/" + id);
            };

            this.DeleteContractInvoice = function (id) {
                return $http.get(config.basePath + "DeleteContractInvoice/" + id);
            };

            this.ContractInvoiceInView = function (data) {
                return $http.post(config.basePath + "ContractInvoiceInView", data);
            };


            //////////////////.Vehicle Category //////////////////

            this.SaveVehicleCategory = function (data) {
                return $http.post(config.basePath + "SaveVehicleCategory", data);
            };

            this.VehicleCategoriesInDropdown = function () {
                return $http.get(config.basePath + "VehicleCategoriesInDropdown");
            };

            this.DeleteVehicleCategory = function (id) {
                return $http.get(config.basePath + "DeleteVehicleCategory/" + id);
            };


            this.VehicleCategoryInView = function (data) {
                return $http.post(config.basePath + "VehicleCategoryInView", data);
            };

            //////////////////.Vehicle //////////////////

            this.AddVehicle = function (data) {
                return $http.post(config.basePath + "AddVehicle", data);
            };

            this.VehiclesInDropdown = function () {
                return $http.get(config.basePath + "VehiclesInDropdown");
            };

            this.DeletVehicle = function (id) {
                return $http.get(config.basePath + "DeletVehicle/" + id);
            };

            this.VehiclesInView = function (data) {
                return $http.post(config.basePath + "VehiclesInView", data);
            };

            this.VehiclesByCategoryId = function (id) {
                return $http.get(config.basePath + "VehiclesByCategoryId/" + id);
            };
            this.VehiclesByCategoryIdInContract = function (id) {
                return $http.get(config.basePath + "VehiclesByCategoryIdInContract/" + id);
            };


            ///////////////////////////////////////////reject///////////////////////////


            this.RejectSalesReturn = function (data) {
                return $http.post(config.basePath + "RejectSalesReturn", data);
            };

            this.RejectSalesQuotation = function (data) {
                return $http.post(config.basePath + "RejectSalesQuotation", data);
            };
            this.RejectSalesQuotation4 = function (data) {
                return $http.post(config.basePath + "RejectSalesQuotation4", data);
            };

            this.RejectSalesQuotation3 = function (data) {
                return $http.post(config.basePath + "RejectSalesQuotation3", data);
            };

            this.RejectSalesQuotation2 = function (data) {
                return $http.post(config.basePath + "RejectSalesQuotation2", data);
            };
            this.RejectSalesOrder = function (data) {
                return $http.post(config.basePath + "RejectSalesOrder", data);
            };
            this.RejectSalesOrder4 = function (data) {
                return $http.post(config.basePath + "RejectSalesOrder4", data);
            };
            this.RejectSalesOrder3 = function (data) {
                return $http.post(config.basePath + "RejectSalesOrder3", data);
            };
            this.RejectSalesOrder2 = function (data) {
                return $http.post(config.basePath + "RejectSalesOrder2", data);
            };
            this.RejectSalesInvoice = function (data) {
                return $http.post(config.basePath + "RejectSalesInvoice", data);
            };
            this.RejectSalesInvoice4 = function (data) {
                return $http.post(config.basePath + "RejectSalesInvoice4", data);
            };
            this.RejectSalesInvoice3 = function (data) {
                return $http.post(config.basePath + "RejectSalesInvoice3", data);
            };
            this.RejectSalesInvoice2 = function (data) {
                return $http.post(config.basePath + "RejectSalesInvoice2", data);
            };
            this.RejectSalesEnquiry = function (data) {
                return $http.post(config.basePath + "RejectSalesEnquiry", data);
            };
            this.RejectSalesEnquiry4 = function (data) {
                return $http.post(config.basePath + "RejectSalesEnquiry4", data);
            };
            this.RejectSalesEnquiry3 = function (data) {
                return $http.post(config.basePath + "RejectSalesEnquiry3", data);
            };
            this.RejectSalesEnquiry2 = function (data) {
                return $http.post(config.basePath + "RejectSalesEnquiry2", data);
            };
            this.RejectProSalesInvoice = function (data) {
                return $http.post(config.basePath + "RejectProSalesInvoice", data);
            };
            this.RejectPackingList = function (data) {
                return $http.post(config.basePath + "RejectPackingList", data);
            };
            this.RejectIndSalesInvoice = function (data) {
                return $http.post(config.basePath + "RejectIndSalesInvoice", data);
            };
            this.RejectExpSalesInvoice = function (data) {
                return $http.post(config.basePath + "RejectExpSalesInvoice", data);
            };
            this.RejectDirSalesInvoice = function (data) {
                return $http.post(config.basePath + "RejectDirSalesInvoice", data);
            };
            this.RejectDeliveryNote = function (data) {
                return $http.post(config.basePath + "RejectDeliveryNote", data);
            };
            this.RejectDeliveryNote4 = function (data) {
                return $http.post(config.basePath + "RejectDeliveryNote4", data);
            };
            this.RejectDeliveryNote3 = function (data) {
                return $http.post(config.basePath + "RejectDeliveryNote3", data);
            };
            this.RejectDeliveryNote2 = function (data) {
                return $http.post(config.basePath + "RejectDeliveryNote2", data);
            };
            this.RejectDirPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "RejectDirPurchaseInvoice", data);
            };
            this.RejectExpPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "RejectExpPurchaseInvoice", data);
            };
            this.RejectGoodsReceived = function (data) {
                return $http.post(config.basePath + "RejectGoodsReceived", data);
            };
            this.RejectImpPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "RejectImpPurchaseInvoice", data);
            };
            this.RejectIndPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "RejectIndPurchaseInvoice", data);
            };
            this.RejectMaterialRequest = function (data) {
                return $http.post(config.basePath + "RejectMaterialRequest", data);
            };
            this.RejectPurchaseEnquiry = function (data) {
                return $http.post(config.basePath + "RejectPurchaseEnquiry", data);
            };
            this.RejectPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "RejectPurchaseInvoice", data);
            };
            this.RejectPurchaseOrder = function (data) {
                return $http.post(config.basePath + "RejectPurchaseOrder", data);
            };
            this.RejectPurchaseQuotation = function (data) {
                return $http.post(config.basePath + "RejectPurchaseQuotation", data);
            };
            this.RejectPurchaseRequest = function (data) {
                return $http.post(config.basePath + "RejectPurchaseRequest", data);
            };
            this.RejectPurchaseReturn = function (data) {
                return $http.post(config.basePath + "RejectPurchaseReturn", data);
            };
            //            this.Reject = function (data) {
            //                return $http.post(config.basePath + "Reject", data);
            //            };


            ////////////////// Car Contract //////////////////

            this.AddCarContract = function (data) {
                return $http.post(config.basePath + "AddCarContract", data);
            };
            this.CarContractsInView = function (data) {
                return $http.post(config.basePath + "CarContractsInView", data);
            };
            this.OpenCarContractsInView = function (data) {
                return $http.post(config.basePath + "OpenCarContractsInView", data);
            };
            this.CloseCarContract = function (data) {
                return $http.post(config.basePath + "CloseCarContract", data);
            };
            this.CarContractsById = function (id) {
                return $http.get(config.basePath + "CarContractsById/" + id);
            };
            this.DeleteCarContract = function (id) {
                return $http.get(config.basePath + "DeleteCarContract/" + id);
            };
            this.GetNextCarContractNo = function () {
                return $http.get(config.basePath + "GetNextCarContractNo");
            };

            this.CPVDetailsByCustomerId = function (id) {
                return $http.post(config.basePath + "CPVDetailsByCustomerId/" + id);
            };
            this.CRVDetailsByCustomerId = function (id) {
                return $http.post(config.basePath + "CRVDetailsByCustomerId/" + id);
            };
            this.ChequePVDetailsByCustomerId = function (id) {
                return $http.post(config.basePath + "ChequePVDetailsByCustomerId/" + id);
            };
            this.ChequeRVDetailsByCustomerId = function (id) {
                return $http.post(config.basePath + "ChequeRVDetailsByCustomerId/" + id);
            };
            this.FPVDetailsByCustomerId = function (id) {
                return $http.post(config.basePath + "FPVDetailsByCustomerId/" + id);
            };
            this.FRVDetailsByCustomerId = function (id) {
                return $http.post(config.basePath + "FRVDetailsByCustomerId/" + id);
            };
            this.JVDetailsByCustomerId = function (id) {
                return $http.post(config.basePath + "JVDetailsByCustomerId/" + id);
            };
            this.PrintSalesInvoiceCarContrct = function (id) {
                return $http.post(config.basePath + "PrintSalesInvoiceCarContrct/" + id);
            };
            this.RecalculateAccountById = function (id) {
                return $http.get(config.basePath + "RecalculateAccountById/" + id);
            };
            this.GetAccountContactList = function (id) {
                return $http.get(config.basePath + "GetAccountContactList/" + id);
            };
            this.GetAccountAddressList = function (id) {
                return $http.get(config.basePath + "GetAccountAddressList/" + id);
            };
            this.RecalculateAllAccounts = function () {
                return $http.get(config.basePath + "RecalculateAllAccounts");
            };


            //////////////////.Import Purchase Invoice //////////////////

            this.AddImpPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "AddImpPurchaseInvoice", data);
            };
            this.ImpPurchaseInvoiceInView = function (data) {
                return $http.post(config.basePath + "ImpPurchaseInvoiceInView", data);
            };


            this.getImpPurchaseInvoicebyId = function (id) {
                return $http.get(config.basePath + "getImpPurchaseInvoicebyId/" + id);
            };

            this.DeleteImpPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "DeleteImpPurchaseInvoice/" + id);
            };
            this.GetBackImpPurchaseInvoice = function (id, type) {
                return $http.get(config.basePath + "GetBackImpPurchaseInvoice/" + id + "/" + type);
            };
            this.GetNextImpPurchaseInvoiceNo = function () {
                return $http.get(config.basePath + "GetNextImpPurchaseInvoiceNo");
            };

            //////////////////.Export Purchase Invoice //////////////////

            this.AddExpPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "AddExpPurchaseInvoice", data);
            };
            this.ExpPurchaseInvoiceInView = function (data) {
                return $http.post(config.basePath + "ExpPurchaseInvoiceInView", data);
            };

            this.getExpPurchaseInvoicebyId = function (id) {
                return $http.get(config.basePath + "getExpPurchaseInvoicebyId/" + id);
            };

            this.DeleteExpPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "DeleteExpPurchaseInvoice/" + id);
            };
            this.GetBackExpPurchaseInvoice = function (id, type) {
                return $http.get(config.basePath + "GetBackExpPurchaseInvoice/" + id + "/" + type);
            };
            this.GetNextExpPurchaseInvoiceNo = function () {
                return $http.get(config.basePath + "GetNextExpPurchaseInvoiceNo");
            };

            //////////////////.Direct Purchase Invoice //////////////////

            this.AddDirPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "AddDirPurchaseInvoice", data);
            };
            this.DirPurchaseInvoiceInView = function (data) {
                return $http.post(config.basePath + "DirPurchaseInvoiceInView", data);
            };

            this.getDirPurchaseInvoicebyId = function (id) {
                return $http.get(config.basePath + "getDirPurchaseInvoicebyId/" + id);
            };

            this.DeleteDirPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "DeleteDirPurchaseInvoice/" + id);
            };
            this.GetBackDirPurchaseInvoice = function (id, type) {
                return $http.get(config.basePath + "GetBackDirPurchaseInvoice/" + id + "/" + type);
            };
            this.GetNextDirPurchaseInvoiceNo = function () {
                return $http.get(config.basePath + "GetNextDirPurchaseInvoiceNo");
            };

            //////////////////.Direct Sales Invoice //////////////////

            this.AddDirSalesInvoice = function (data) {
                return $http.post(config.basePath + "AddDirSalesInvoice", data);
            };
            this.DirSalesInvoiceInView = function (data) {
                return $http.post(config.basePath + "DirSalesInvoiceInView", data);
            };


            this.getDirSalesInvoicebyId = function (id) {
                return $http.get(config.basePath + "getDirSalesInvoicebyId/" + id);
            };

            this.DeleteDirSalesInvoice = function (id) {
                return $http.get(config.basePath + "DeleteDirSalesInvoice/" + id);
            };
            this.GetBackDirSalesInvoice = function (id, type) {
                return $http.get(config.basePath + "GetBackDirSalesInvoice/" + id + "/" + type);
            };
            this.GetNextDirSalesInvoiceNo = function () {
                return $http.get(config.basePath + "GetNextDirSalesInvoiceNo");
            };

            //////////////////.Porfoma Sales Invoice //////////////////

            this.AddPorSalesInvoice = function (data) {
                return $http.post(config.basePath + "AddPorSalesInvoice", data);
            };
            this.PorSalesInvoiceInView = function (data) {
                return $http.post(config.basePath + "PorSalesInvoiceInView", data);
            };

            this.getPorSalesInvoicebyId = function (id) {
                return $http.get(config.basePath + "getPorSalesInvoicebyId/" + id);
            };

            this.DeletePorSalesInvoice = function (id) {
                return $http.get(config.basePath + "DeletePorSalesInvoice/" + id);
            };
            this.GetBackPorSalesInvoice = function (id, type) {
                return $http.get(config.basePath + "GetBackPorSalesInvoice/" + id + "/" + type);
            };
            this.GetNextPorSalesInvoiceNo = function () {
                return $http.get(config.basePath + "GetNextPorSalesInvoiceNo");
            };


            //////////////////.Direct Sales Invoice //////////////////

            this.AddExpSalesInvoice = function (data) {
                return $http.post(config.basePath + "AddExpSalesInvoice", data);
            };
            this.ExpSalesInvoiceInView = function (data) {
                return $http.post(config.basePath + "ExpSalesInvoiceInView", data);
            };


            this.getExpSalesInvoicebyId = function (id) {
                return $http.get(config.basePath + "getExpSalesInvoicebyId/" + id);
            };

            this.DeleteExpSalesInvoice = function (id) {
                return $http.get(config.basePath + "DeleteExpSalesInvoice/" + id);
            };
            this.GetBackExpSalesInvoice = function (id, type) {
                return $http.get(config.basePath + "GetBackExpSalesInvoice/" + id + "/" + type);
            };
            this.GetNextExpSalesInvoiceNo = function () {
                return $http.get(config.basePath + "GetNextExpSalesInvoiceNo");
            };

            this.ManufStockAutoComplete = function (data) {
                return $http.post(config.basePath + "ManufStockAutoComplete", data);
            };

            //////////////////.Cost Center Settings //////////////////

            this.AddCostCenterSettings = function (data) {
                return $http.post(config.basePath + "AddCostCenterSettings", data);
            };

            this.CostCenterSettingsbyType = function (id) {
                return $http.get(config.basePath + "CostCenterSettingsbyType/" + id);
            };
            this.CostCentersInVoucher = function (id) {
                return $http.get(config.basePath + "CostCentersInVoucher/" + id);
            };
            this.CostCentersInReortVoucher = function (id) {
                return $http.get(config.basePath + "CostCentersInReortVoucher/" + id);
            };
            this.GetJobCostCenters = function () {
                return $http.get(config.basePath + "GetJobCostCenters");
            };
            this.GetStateCostCenters = function () {
                return $http.get(config.basePath + "GetStateCostCenters");
            };
            this.GetVatReport = function (data) {
                return $http.post(config.basePath + "GetVatReport", data);
            };
            //////////////////.Voucher Links //////////////////


            this.AddVoucherLinks = function (data) {
                return $http.post(config.basePath + "AddVoucherLinks", data);
            };

            this.VoucherLinksbyType = function (id) {
                return $http.get(config.basePath + "VoucherLinksbyType/" + id);
            };
            this.VoucherLinksInVoucher = function (id) {
                return $http.get(config.basePath + "VoucherLinksInVoucher/" + id);
            };

            this.DeleteVocherLinking = function (id) {
                return $http.get(config.basePath + "DeleteVocherLinking/" + id);
            };

            //////////////////.Linking //////////////////

            this.getSalesEnquirybyLinkingId = function (id) {
                return $http.get(config.basePath + "getSalesEnquirybyLinkingId/" + id);
            };
            this.getSalesQuotationbyLinkingId = function (id) {
                return $http.get(config.basePath + "getSalesQuotationbyLinkingId/" + id);
            };
            this.getSalesOrderbyLinkingId = function (id) {
                return $http.get(config.basePath + "getSalesOrderbyLinkingId/" + id);
            };
            this.getPackingListbyLinkingId = function (id) {
                return $http.get(config.basePath + "getSalesOrderbyLinkingId/" + id);
            };
            this.getDeliveryNotebyLinkingId = function (id) {
                return $http.get(config.basePath + "getDeliveryNotebyLinkingId/" + id);
            };
            this.getSalesInvoicebyLinkingId = function (id) {
                return $http.get(config.basePath + "getSalesInvoicebyLinkingId/" + id);
            };
            this.getDirSalesInvoicebyLinkingId = function (id) {
                return $http.get(config.basePath + "getDirSalesInvoicebyLinkingId/" + id);
            };
            this.getExpSalesInvoicebyLinkingId = function (id) {
                return $http.get(config.basePath + "getExpSalesInvoicebyLinkingId/" + id);
            };
            this.getPorSalesInvoicebyLinkingId = function (id) {
                return $http.get(config.basePath + "getPorSalesInvoicebyLinkingId/" + id);
            };
            this.getSalesReturnbyLinkingId = function (id) {
                return $http.get(config.basePath + "getSalesReturnbyLinkingId/" + id);
            };
            this.getMaterialRequestbyLinkingId = function (id) {
                return $http.get(config.basePath + "getMaterialRequestbyLinkingId/" + id);
            };
            this.getPurchaseRequestbyLinkingId = function (id) {
                return $http.get(config.basePath + "getPurchaseRequestbyLinkingId/" + id);
            };
            this.getPurchaseEnquirybyLinkingId = function (id) {
                return $http.get(config.basePath + "getPurchaseEnquirybyLinkingId/" + id);
            };
            this.getPurcahseQuotationbyLinkingId = function (id) {
                return $http.get(config.basePath + "getPurcahseQuotationbyLinkingId/" + id);
            };
            this.getPurchaseOrderbyLinkingId = function (id) {
                return $http.get(config.basePath + "getPurchaseOrderbyLinkingId/" + id);
            };
            this.getGoodsReceivedbyLinkingId = function (id) {
                return $http.get(config.basePath + "getGoodsReceivedbyLinkingId/" + id);
            };
            this.getPurchaseInvoicebyLinkingId = function (id) {
                return $http.get(config.basePath + "getPurchaseInvoicebyLinkingId/" + id);
            };
            this.getDirPurchaseInvoicebyLinkingId = function (id) {
                return $http.get(config.basePath + "getDirPurchaseInvoicebyLinkingId/" + id);
            };
            this.getImpPurchaseInvoicebyLinkingId = function (id) {
                return $http.get(config.basePath + "getImpPurchaseInvoicebyLinkingId/" + id);
            };
            this.getExpPurchaseInvoicebyLinkingId = function (id) {
                return $http.get(config.basePath + "getExpPurchaseInvoicebyLinkingId/" + id);
            };
            this.getPurchaseReturnbyLinkingId = function (id) {
                return $http.get(config.basePath + "getPurchaseReturnbyLinkingId/" + id);
            };
            this.getCommonVocherLinkingId = function (id, type, voucher) {
                return $http.get(config.basePath + "getCommonVocherLinkingId/" + id + "/" + type + "/" + voucher);
            };
            this.GetAllPendingVoucherDetailsForLinking = function (id, type) {
                return $http.get(config.basePath + "GetAllPendingVoucherDetailsForLinking/" + id + "/" + type);
            };
            this.GetAllPendingVouchersForLinking = function (id, type) {
                return $http.get(config.basePath + "GetAllPendingVouchersForLinking/" + id + "/" + type);
            };
            this.GetAllPendingVouchersForLinkingCost = function (id, type) {
                return $http.get(config.basePath + "GetAllPendingVouchersForLinkingCost/" + id + "/" + type);
            };
            this.getCommonVocherLinkingDetails = function (data) {
                return $http.post(config.basePath + "getCommonVocherLinkingDetails", data);
            };
            this.getCommonVocherHeadLinkingDetails = function (data) {
                return $http.post(config.basePath + "getCommonVocherHeadLinkingDetails", data);
            };

            //////////////////.Bill Wise //////////////////

            this.GetPendingBillAnalysis = function (id, type) {
                return $http.get(config.basePath + "GetPendingBillAnalysis/" + id + "/" + type);
            };
            this.GetUnassignedBills = function (id) {
                return $http.get(config.basePath + "GetUnassignedBills/" + id);
            };
            this.DeleteBillWise = function (id) {
                return $http.get(config.basePath + "DeleteBillWise/" + id);
            };
            this.GetPendingBillAnalysisOld = function (id, did) {
                return $http.get(config.basePath + "GetPendingBillAnalysisOld/" + id + "/" + did);
            };
            this.GetVoucherBillDetails = function (id, type) {
                return $http.get(config.basePath + "GetVoucherBillDetails/" + id + "/" + type);
            };
            this.BillWiseAnalysisReport = function (data) {
                return $http.post(config.basePath + "BillWiseAnalysisReport", data);
            };
            this.BillWiseAnalysisInEdit = function (data) {
                return $http.post(config.basePath + "BillWiseAnalysisInEdit", data);
            };
            this.BillWiseDetailsReport = function (data) {
                return $http.post(config.basePath + "BillWiseDetailsReport", data);
            };
            this.BillWiseOutStandingReport = function (data) {
                return $http.post(config.basePath + "BillWiseOutStandingReport", data);
            };
            this.BillWiseOutStandingCreditReport = function (data) {
                return $http.post(config.basePath + "BillWiseOutStandingCreditReport", data);
            };
            this.BillWiseOutStandingDebitReport = function (data) {
                return $http.post(config.basePath + "BillWiseOutStandingDebitReport", data);
            };
            this.BillWiseAnalysisAgingReport = function (data) {
                return $http.post(config.basePath + "BillWiseAnalysisAgingReport", data);
            };
            this.AgingAnalysisReport = function (data) {
                return $http.post(config.basePath + "AgingAnalysisReport", data);
            };
            this.AgingAnalysisCreditorsReport = function (data) {
                return $http.post(config.basePath + "AgingAnalysisCreditorsReport", data);
            };
            this.AgingAnalysisDebtorsReport = function (data) {
                return $http.post(config.basePath + "AgingAnalysisDebtorsReport", data);
            };

            //////////////////. voucher accounts //////////////////

            this.AddVoucherAccounts = function (data) {
                return $http.post(config.basePath + "AddVoucherAccounts", data);
            };
            this.VoucherAccountsInVoucher = function (id) {
                return $http.get(config.basePath + "VoucherAccountsInVoucher/" + id);
            };
            this.VoucherAccountsbyType = function (id) {
                return $http.get(config.basePath + "VoucherAccountsbyType/" + id);
            };

            this.DeleteVoucherCostCenter = function (id) {
                return $http.get(config.basePath + "DeleteVoucherCostCenter/" + id);
            };


            //////////////////. Lead Type .//////////////////

            this.AddLeadType = function (data) {
                return $http.post(config.basePath + "AddLeadType", data);
            };

            this.LeadTypeInView = function (data) {
                return $http.post(config.basePath + "LeadTypeInView", data);
            };

            this.DeleteLeadType = function (id) {
                return $http.get(config.basePath + "DeleteLeadType/" + id);
            };


            //////////////////. lead Source .//////////////////

            this.AddLeadSource = function (data) {
                return $http.post(config.basePath + "AddLeadSource", data);
            };

            this.LeadSourcesInView = function (data) {
                return $http.post(config.basePath + "LeadSourcesInView", data);
            };

            this.DeleteLeadSource = function (id) {
                return $http.get(config.basePath + "DeleteLeadSource/" + id);
            };


            //////////////////. Lead.//////////////////

            this.AddLead = function (data) {
                return $http.post(config.basePath + "AddLead", data);
            };

            this.LeadsInView = function (data) {
                return $http.post(config.basePath + "LeadsInView", data);
            };

            this.DeleteLead = function (id) {
                return $http.get(config.basePath + "DeleteLead/" + id);
            };
            this.GetNextLeadNo = function () {
                return $http.get(config.basePath + "GetNextLeadNo");
            };

            this.UpdateLeadStatus = function (data) {
                return $http.post(config.basePath + "UpdateLeadStatus", data);
            };

            this.ConvertLead = function (id) {
                return $http.get(config.basePath + "ConvertLead/" + id);
            };

            this.LeadTypeInDropdown = function () {
                return $http.get(config.basePath + "LeadTypeInDropdown");
            };

            this.LeadSourcesInDropdown = function () {
                return $http.get(config.basePath + "LeadSourcesInDropdown");
            };

            this.getLeadbyId = function (id) {
                return $http.get(config.basePath + "getLeadbyId/" + id);
            };

            //////////////////. Voucher Design .//////////////////

            this.AddVoucherDesign = function (data) {
                return $http.post(config.basePath + "AddVoucherDesign", data);
            };

            this.AddCustomDesign = function (data) {
                return $http.post(config.basePath + "AddCustomDesign", data);
            };

            this.VoucherDesignsbyType = function (id) {
                return $http.get(config.basePath + "VoucherDesignsbyType/" + id);
            };

            this.CustomDesignsbyType = function (id) {
                return $http.get(config.basePath + "CustomDesignsbyType/" + id);
            };

            this.VoucherDesignsByUserId = function (id, type) {
                return $http.get(config.basePath + "VoucherDesignsByUserId/" + id + "/" + type);
            };
            this.VoucherDesignsByRoleId = function (id, type) {
                return $http.get(config.basePath + "VoucherDesignsByRoleId/" + id + "/" + type);
            };

            this.UpdateEmployeeToAccount = function (id, type) {
                return $http.get(config.basePath + "UpdateEmployeeToAccount/" + id + "/" + type);
            };

            this.AddTabDesign = function (data) {
                return $http.post(config.basePath + "AddTabDesign", data);
            };

            this.TabDesignsbyType = function (id) {
                return $http.get(config.basePath + "TabDesignsbyType/" + id);
            };

            this.AddProductDesign = function (data) {
                return $http.post(config.basePath + "AddProductDesign", data);
            };
            this.AddProductConfiguration = function (data) {
                return $http.post(config.basePath + "AddProductConfiguration", data);
            };

            this.GetProductDesign = function () {
                return $http.get(config.basePath + "GetProductDesign");
            };

            this.AddCostCenterDesign = function (data) {
                return $http.post(config.basePath + "AddCostCenterDesign", data);
            };

            this.CostcenterFieldAutoComplete = function (data) {
                return $http.post(config.basePath + "CostcenterFieldAutoComplete", data);
            };

            this.FieldAutoCompleteDetail = function (data) {
                return $http.post(config.basePath + "FieldAutoCompleteDetail", data);
            };

            this.GetCostCenterDesign = function (id) {
                return $http.get(config.basePath + "GetCostCenterDesign/" + id);
            };

            //////////////////. Status .//////////////////

            this.AddStatus = function (data) {
                return $http.post(config.basePath + "AddStatus", data);
            };

            this.StatussInView = function (data) {
                return $http.post(config.basePath + "StatussInView", data);
            };

            this.DeleteStatus = function (id) {
                return $http.get(config.basePath + "DeleteStatus/" + id);
            };

            this.StatusInDropdown = function () {
                return $http.get(config.basePath + "StatusInDropdown");
            };

            this.getStatusbyType = function (type) {
                return $http.get(config.basePath + "getStatusbyType/" + type);
            };

            //////////////////. Warehouse .//////////////////

            this.AddWarehouse = function (data) {
                return $http.post(config.basePath + "AddWarehouse", data);
            };

            this.WarehouseInView = function (data) {
                return $http.post(config.basePath + "WarehouseInView", data);
            };

            this.DeleteWarehouse = function (id) {
                return $http.get(config.basePath + "DeleteWarehouse/" + id);
            };

            this.WarehousesInDropdown = function () {
                return $http.get(config.basePath + "WarehousesInDropdown");
            };


            //////////////////. Brand .//////////////////

            this.AddBrand = function (data) {
                return $http.post(config.basePath + "AddBrand", data);
            };

            this.BrandsInView = function (data) {
                return $http.post(config.basePath + "BrandsInView", data);
            };

            this.DeleteBrand = function (id) {
                return $http.get(config.basePath + "DeleteBrand/" + id);
            };

            this.BrandsInDropdown = function () {
                return $http.get(config.basePath + "BrandsInDropdown");
            };

            //////////////////. User Role .//////////////////

            this.AddUserRole = function (data) {
                return $http.post(config.basePath + "AddUserRole", data);
            };

            this.UserRolesInView = function (data) {
                return $http.post(config.basePath + "UserRolesInView", data);
            };

            this.DeleteUserRole = function (id) {
                return $http.get(config.basePath + "DeleteUserRole/" + id);
            };

            this.UserRolesInDropdown = function () {
                return $http.get(config.basePath + "UserRolesInDropdown");
            };

            //////////////////. Favourite .//////////////////

            this.AddFavourite = function (data) {
                return $http.post(config.basePath + "AddFavourite", data);
            };

            this.FavouritesInView = function (data) {
                return $http.post(config.basePath + "FavouritesInView", data);
            };

            this.DeleteFavourite = function (id) {
                return $http.get(config.basePath + "DeleteFavourite/" + id);
            };

            this.FavouritesByUser = function () {
                return $http.post(config.basePath + "FavouritesByUser");
            };


            //////////////////. Favourite Category .//////////////////

            this.AddFavouriteCategory = function (data) {
                return $http.post(config.basePath + "AddFavouriteCategory", data);
            };

            this.FavouriteCategoryInView = function (data) {
                return $http.post(config.basePath + "FavouriteCategoryInView", data);
            };

            this.DeleteFavouriteCategory = function (id) {
                return $http.get(config.basePath + "DeleteFavouriteCategory/" + id);
            };

            this.FavouriteCategoryInDropdown = function () {
                return $http.get(config.basePath + "FavouriteCategoryInDropdown");
            };

            //////////////////. Building Type .//////////////////

            this.AddBuildingType = function (data) {
                return $http.post(config.basePath + "AddBuildingType", data);
            };

            this.BuildingTypesInView = function (data) {
                return $http.post(config.basePath + "BuildingTypesInView", data);
            };

            this.DeleteBuildingType = function (id) {
                return $http.get(config.basePath + "DeleteBuildingType/" + id);
            };

            this.BuildingTypesInDropdown = function () {
                return $http.get(config.basePath + "BuildingTypesInDropdown");
            };



            //////////////////. Flat Type .//////////////////

            this.AddFlatType = function (data) {
                return $http.post(config.basePath + "AddFlatType", data);
            };

            this.FlatTypesInView = function (data) {
                return $http.post(config.basePath + "FlatTypesInView", data);
            };

            this.DeleteFlatType = function (id) {
                return $http.get(config.basePath + "DeleteFlatType/" + id);
            };

            this.FlatTypesInDropdown = function () {
                return $http.get(config.basePath + "FlatTypesInDropdown");
            };


            //////////////////. Reminders .//////////////////

            this.AddReminder = function (data) {
                return $http.post(config.basePath + "AddReminder", data);
            };
            this.RemindersInView = function (data) {
                return $http.post(config.basePath + "RemindersInView", data);
            };
            this.DeleteReminder = function (id) {
                return $http.get(config.basePath + "DeleteReminder/" + id);
            };
            this.RemindersInHome = function (id) {
                return $http.get(config.basePath + "RemindersInHome/" + id);
            };
            this.GetUserNotifications = function (id) {
                return $http.get(config.basePath + "GetUserNotifications/" + id);
            };
            this.DocsInHome = function () {
                return $http.get(config.basePath + "DocsInHome");
            };


            //////////////////. Bulk Vochers .//////////////////

            this.AddPurchaseEnquiryBulk = function (data) {
                return $http.post(config.basePath + "AddPurchaseEnquiryBulk", data);
            };
            this.UploadChequePVMaster = function (data) {
                return $http.post(config.basePath + "UploadChequePVMaster", data);
            };
            this.UploadChequeRVMaster = function (data) {
                return $http.post(config.basePath + "UploadChequeRVMaster", data);
            };


            //////////////////.TenancyContract..//////////////////

            this.TenancyContractsInView = function (data) {
                return $http.post(config.basePath + "TenancyContractsInView", data);
            };
            this.AddTenancyContract = function (data) {
                return $http.post(config.basePath + "AddTenancyContract", data);
            };
            this.GetNextTenancyContractNo = function () {
                return $http.get(config.basePath + "GetNextTenancyContractNo");
            };
            this.BanksInDropdown = function () {
                return $http.get(config.basePath + "BanksInDropdown");
            };
            this.LessorsInDropdown = function () {
                return $http.get(config.basePath + "LessorsInDropdown");
            };

            this.DeleteTenancyContract = function (id) {
                return $http.get(config.basePath + "DeleteTenancyContract/" + id);
            };
            this.TenancyContractById = function (id) {
                return $http.get(config.basePath + "TenancyContractById/" + id);
            };

            this.GoBackTenancyContract = function (id) {
                return $http.get(config.basePath + "GoBackTenancyContract/" + id);
            };

            this.GoNextTenancyContract = function (id) {
                return $http.get(config.basePath + "GoNextTenancyContract/" + id);
            };

            this.UNApproveRental = function (id) {
                return $http.get(config.basePath + "UNApproveRental/" + id);
            };
            this.RentalInPages = function (data) {
                return $http.post(config.basePath + "RentalInPages", data);
            };
            //////////////////.TenancyContract..//////////////////

            //////////////////. PU TenancyContract..//////////////////

            this.PUTenancyContractsInView = function (data) {
                return $http.post(config.basePath + "PUTenancyContractsInView", data);
            };
            this.AddPUTenancyContract = function (data) {
                return $http.post(config.basePath + "AddPUTenancyContract", data);
            };
            this.GetNextPUTenancyContractNo = function () {
                return $http.get(config.basePath + "GetNextPUTenancyContractNo");
            };
            
            this.DeletePUTenancyContract = function (id) {
                return $http.get(config.basePath + "DeletePUTenancyContract/" + id);
            };
            this.PUTenancyContractById = function (id) {
                return $http.get(config.basePath + "PUTenancyContractById/" + id);
            };

            this.GoBackPUTenancyContract = function (id) {
                return $http.get(config.basePath + "GoBackTPUenancyContract/" + id);
            };

            this.GoNextPUTenancyContract = function (id) {
                return $http.get(config.basePath + "GoNextPUTenancyContract/" + id);
            };

            this.UNApproveRental = function (id) {
                return $http.get(config.basePath + "UNApproveRental/" + id);
            };
            this.RentalInPages = function (data) {
                return $http.post(config.basePath + "RentalInPages", data);
            };
            //////////////////.TenancyContract..//////////////////

            //////////////////.Particulars..//////////////////

            this.AddParticulars = function (data) {
                return $http.post(config.basePath + "AddParticulars", data);
            };
            this.ParticularsInView = function (data) {
                return $http.post(config.basePath + "ParticularsInView", data);
            };
            this.DeleteParticulars = function (id) {
                return $http.get(config.basePath + "DeleteParticulars/" + id);
            };
            this.ParticularsInDropdown = function () {
                return $http.get(config.basePath + "ParticularsInDropdown");
            };
            this.GetNextBuildingNo = function () {
                return $http.get(config.basePath + "GetNextBuildingNo");
            };

            //////////////////.Time Sheet..//////////////////

            this.GetNextTimeSheetNo = function () {
                return $http.get(config.basePath + "GetNextTimeSheetNo");
            };
            this.AddTimeSheet = function (data) {
                return $http.post(config.basePath + "AddTimeSheet", data);
            };
            this.TimeSheetInView = function (data) {
                return $http.post(config.basePath + "TimeSheetInView", data);
            };
            this.GetTimeSheet = function (id) {
                return $http.get(config.basePath + "GetTimeSheet/" + id);
            };
            this.DeleteTimeSheet = function (id) {
                return $http.get(config.basePath + "DeleteTimeSheet/" + id);
            };

            //////////////////.Holiday..//////////////////

            this.AddHoliday = function (data) {
                return $http.post(config.basePath + "AddHoliday", data);
            };
            this.CheckDateHoliday = function (data) {
                return $http.post(config.basePath + "CheckDateHoliday", data);
            };
            this.HolidaysInView = function (data) {
                return $http.post(config.basePath + "HolidaysInView", data);
            };
            this.DeletHoliday = function (id) {
                return $http.get(config.basePath + "DeletHoliday/" + id);
            };
            this.HolidaysInDropdown = function () {
                return $http.get(config.basePath + "HolidaysInDropdown");
            };


            //////////////////.Extra Masters..//////////////////

            this.AddMaster1 = function (data) {
                return $http.post(config.basePath + "AddMaster1", data);
            };
            this.Master1sInView = function (data) {
                return $http.post(config.basePath + "Master1sInView", data);
            };
            this.DeleteMaster1 = function (id) {
                return $http.get(config.basePath + "DeleteMaster1/" + id);
            };
            this.Master1sInDropdown = function () {
                return $http.get(config.basePath + "Master1sInDropdown");
            };

            this.AddMaster2 = function (data) {
                return $http.post(config.basePath + "AddMaster2", data);
            };
            this.Master2sInView = function (data) {
                return $http.post(config.basePath + "Master2sInView", data);
            };
            this.DeleteMaster2 = function (id) {
                return $http.get(config.basePath + "DeleteMaster2/" + id);
            };
            this.Master2sInDropdown = function () {
                return $http.get(config.basePath + "Master2sInDropdown");
            };

            this.AddMaster3 = function (data) {
                return $http.post(config.basePath + "AddMaster3", data);
            };
            this.Master3sInView = function (data) {
                return $http.post(config.basePath + "Master3sInView", data);
            };
            this.DeleteMaster3 = function (id) {
                return $http.get(config.basePath + "DeleteMaster3/" + id);
            };
            this.Master3sInDropdown = function () {
                return $http.get(config.basePath + "Master3sInDropdown");
            };

            this.AddMaster4 = function (data) {
                return $http.post(config.basePath + "AddMaster4", data);
            };
            this.Master4sInView = function (data) {
                return $http.post(config.basePath + "Master4sInView", data);
            };
            this.DeleteMaster4 = function (id) {
                return $http.get(config.basePath + "DeleteMaster4/" + id);
            };
            this.Master4sInDropdown = function () {
                return $http.get(config.basePath + "Master4sInDropdown");
            };

            this.AddMaster5 = function (data) {
                return $http.post(config.basePath + "AddMaster5", data);
            };
            this.Master5sInView = function (data) {
                return $http.post(config.basePath + "Master5sInView", data);
            };
            this.DeleteMaster5 = function (id) {
                return $http.get(config.basePath + "DeleteMaster5/" + id);
            };
            this.Master5sInDropdown = function () {
                return $http.get(config.basePath + "Master5sInDropdown");
            };

            this.AddMaster6 = function (data) {
                return $http.post(config.basePath + "AddMaster6", data);
            };
            this.Master6sInView = function (data) {
                return $http.post(config.basePath + "Master6sInView", data);
            };
            this.DeleteMaster6 = function (id) {
                return $http.get(config.basePath + "DeleteMaster6/" + id);
            };
            this.Master6sInDropdown = function () {
                return $http.get(config.basePath + "Master6sInDropdown");
            };

            this.AddMaster7 = function (data) {
                return $http.post(config.basePath + "AddMaster7", data);
            };
            this.Master7sInView = function (data) {
                return $http.post(config.basePath + "Master7sInView", data);
            };
            this.DeleteMaster7 = function (id) {
                return $http.get(config.basePath + "DeleteMaster7/" + id);
            };
            this.Master7sInDropdown = function () {
                return $http.get(config.basePath + "Master7sInDropdown");
            };

            this.AddMaster8 = function (data) {
                return $http.post(config.basePath + "AddMaster8", data);
            };
            this.Master8sInView = function (data) {
                return $http.post(config.basePath + "Master8sInView", data);
            };
            this.DeleteMaster8 = function (id) {
                return $http.get(config.basePath + "DeleteMaster8/" + id);
            };
            this.Master8sInDropdown = function () {
                return $http.get(config.basePath + "Master8sInDropdown");
            };

            this.AddAccountLoading = function (data) {
                return $http.post(config.basePath + "AddAccountLoading", data);
            };
            this.AccountLoadingbyType = function (id) {
                return $http.get(config.basePath + "AccountLoadingbyType/" + id);
            };
            this.DeleteAccountLoading = function (id) {
                return $http.get(config.basePath + "DeleteAccountLoading/" + id);
            };



            //////////////////.Building Particulars..//////////////////

            this.AddBuildingParticulars = function (data) {
                return $http.post(config.basePath + "AddBuildingParticulars", data);
            };
            this.DeleteBuildingParticulars = function (id) {
                return $http.get(config.basePath + "DeleteBuildingParticulars/" + id);
            };
            this.GetAllBuildingParticulars = function (id) {
                return $http.get(config.basePath + "GetAllBuildingParticulars/" + id);
            };

            //////////////////.flat Particulars..//////////////////

            this.AddFlatParticulars = function (data) {
                return $http.post(config.basePath + "AddFlatParticulars", data);
            };
            this.DeleteFlatParticulars = function (id) {
                return $http.get(config.basePath + "DeleteFlatParticulars/" + id);
            };
            this.GetAllFlatParticulars = function (id) {
                return $http.get(config.basePath + "GetAllFlatParticulars/" + id);
            };
            this.GetAllFlatParticularsInContract = function (id) {
                return $http.get(config.basePath + "GetAllFlatParticularsInContract/" + id);
            };

            //////////////////.Parking Zone..//////////////////

            this.AddParkingZone = function (data) {
                return $http.post(config.basePath + "AddParkingZone", data);
            };
            this.ParkingZonesInView = function (data) {
                return $http.post(config.basePath + "ParkingZonesInView", data);
            };
            this.DeleteParkingZone = function (id) {
                return $http.get(config.basePath + "DeleteParkingZone/" + id);
            };
            this.ParkingZonesInDropdown = function () {
                return $http.get(config.basePath + "ParkingZonesInDropdown");
            };
            this.ParkingZonesByBuildingId = function (id) {
                return $http.get(config.basePath + "ParkingZonesByBuildingId/" + id);
            };

            //////////////////.TableDesign..//////////////////

            this.AddTableDesign = function (data) {
                return $http.post(config.basePath + "AddTableDesign", data);
            };
            this.TableDesignsbyVoucher = function (data) {
                return $http.get(config.basePath + "TableDesignsbyVoucher/" + data);
            };

            //////////////////.Resave Vouchers..//////////////////

            this.ResaveAllMaterialRequest = function () {
                return $http.get(config.basePath + "ResaveAllMaterialRequest");
            };


            this.ResaveAllPurchaseRequest = function () {
                return $http.get(config.basePath + "ResaveAllPurchaseRequest");
            };

            this.ResaveAllPurchaseEnquiry = function () {
                return $http.get(config.basePath + "ResaveAllPurchaseEnquiry");
            };

            this.ResaveAllPurchaseQuotation = function () {
                return $http.get(config.basePath + "ResaveAllPurchaseQuotation");
            };

            this.ResaveAllPurchaseOrder = function () {
                return $http.get(config.basePath + "ResaveAllPurchaseOrder");
            };

            this.ResaveAllGoodsReceived = function () {
                return $http.get(config.basePath + "ResaveAllGoodsReceived");
            };

            this.ResaveAllPurchaseInvoice = function () {
                return $http.get(config.basePath + "ResaveAllPurchaseInvoice");
            };

            this.ResaveAllDirectPurchaseInvoice = function () {
                return $http.get(config.basePath + "ResaveAllDirectPurchaseInvoice");
            };

            this.ResaveAllIndividualPurchaseInvoice = function () {
                return $http.get(config.basePath + "ResaveAllIndividualPurchaseInvoice");
            };

            this.ResaveAllImportPurchaseInvoice = function () {
                return $http.get(config.basePath + "ResaveAllImportPurchaseInvoice");
            };

            this.ResaveAllExportPurchaseInvoice = function () {
                return $http.get(config.basePath + "ResaveAllExportPurchaseInvoice");
            };

            this.ResaveAllPurchaseReturn = function () {
                return $http.get(config.basePath + "ResaveAllPurchaseReturn");
            };

            this.ResaveAllSalesEnquiry = function () {
                return $http.get(config.basePath + "ResaveAllSalesEnquiry");
            };

            this.ResaveAllSalesQuotation = function () {
                return $http.get(config.basePath + "ResaveAllSalesQuotation");
            };

            this.ResaveAllPackingList = function () {
                return $http.get(config.basePath + "ResaveAllPackingList");
            };
            this.ResaveAllSalesOrder = function () {
                return $http.get(config.basePath + "ResaveAllSalesOrder");
            };
            this.ResaveAllDeliveryNote = function () {
                return $http.get(config.basePath + "ResaveAllDeliveryNote");
            };
            this.ResaveAllSalesInvoice = function () {
                return $http.get(config.basePath + "ResaveAllSalesInvoice");
            };
            this.ResaveAllDirectSalesInvoice = function () {
                return $http.get(config.basePath + "ResaveAllDirectSalesInvoice");
            };
            this.ResaveAllIndividualSalesInvoice = function () {
                return $http.get(config.basePath + "ResaveAllIndividualSalesInvoice");
            };
            this.ResaveAllExportSalesInvoice = function () {
                return $http.get(config.basePath + "ResaveAllExportSalesInvoice");
            };
            this.ResaveAllPorfomaInvoice = function () {
                return $http.get(config.basePath + "ResaveAllPorfomaInvoice");
            };
            this.ResaveAllSalesReturn = function () {
                return $http.get(config.basePath + "ResaveAllSalesReturn");
            };
            this.ResaveAllCompanyExpense = function () {
                return $http.get(config.basePath + "ResaveAllCompanyExpense");
            };
            this.ResaveAllJournalVoucher = function () {
                return $http.get(config.basePath + "ResaveAllJournalVoucher");
            };
            this.ResaveAllOpeningBalance = function () {
                return $http.get(config.basePath + "ResaveAllOpeningBalance");
            };
            this.ResaveAllCreditNote = function () {
                return $http.get(config.basePath + "ResaveAllCreditNote");
            };
            this.ResaveAllDebitNote = function () {
                return $http.get(config.basePath + "ResaveAllDebitNote");
            };
            this.ResaveAllCashPayment = function () {
                return $http.get(config.basePath + "ResaveAllCashPayment");
            };
            this.ResaveAllCashReceipt = function () {
                return $http.get(config.basePath + "ResaveAllCashReceipt");
            };
            this.ResaveAllFundPayment = function () {
                return $http.get(config.basePath + "ResaveAllFundPayment");
            };
            this.ResaveAllFundReceipt = function () {
                return $http.get(config.basePath + "ResaveAllFundReceipt");
            };
            this.ResaveAllChequePayment = function () {
                return $http.get(config.basePath + "ResaveAllChequePayment");
            };
            this.ResaveAllChequeReceipt = function () {
                return $http.get(config.basePath + "ResaveAllChequeReceipt");
            };
            this.ResaveAllOpeningStock = function () {
                return $http.get(config.basePath + "ResaveAllOpeningStock");
            };
            this.ResaveAllStockReceive = function () {
                return $http.get(config.basePath + "ResaveAllStockReceive");
            };

            this.ResaveAllStockIssue = function () {
                return $http.get(config.basePath + "ResaveAllStockIssue");
            };
            this.ResaveAllStockFOC = function () {
                return $http.get(config.basePath + "ResaveAllStockFOC");
            };
            this.ResaveAllStockJV = function () {
                return $http.get(config.basePath + "ResaveAllStockJV");
            };


            //////////////////.Price Chart..//////////////////

            this.LoadPriceFromChart = function (data) {
                return $http.post(config.basePath + "LoadPriceFromChart", data);
            };
            this.AddPriceChart = function (data) {
                return $http.post(config.basePath + "AddPriceChart", data);
            };
            this.PriceChartInView = function (data) {
                return $http.post(config.basePath + "PriceChartInView", data);
            };
            this.PriceChartById = function (id) {
                return $http.get(config.basePath + "PriceChartById/" + id);
            };
            this.DeletePriceChart = function (id) {
                return $http.get(config.basePath + "DeletePriceChart/" + id);
            };

            //////////////////.parking slot..//////////////////

            this.AddParkingSlot = function (data) {
                return $http.post(config.basePath + "AddParkingSlot", data);
            };
            this.ParkingSlotsInView = function (data) {
                return $http.post(config.basePath + "ParkingSlotsInView", data);
            };
            this.DeleteParkingSlot = function (id) {
                return $http.get(config.basePath + "DeleteParkingSlot/" + id);
            };
            this.ParkingSlotsInDropdown = function () {
                return $http.get(config.basePath + "ParkingSlotsInDropdown");
            };
            this.ParkingSlotsByBuildingId = function (id) {
                return $http.get(config.basePath + "ParkingSlotsByBuildingId/" + id);
            };
            this.ParkingSlotsByZoneId = function (id) {
                return $http.get(config.basePath + "ParkingSlotsByZoneId/" + id);
            };

            //////////////////.Task Type..//////////////////

            this.AddTaskType = function (data) {
                return $http.post(config.basePath + "AddTaskType", data);
            };
            this.TaskTypesInView = function (data) {
                return $http.post(config.basePath + "TaskTypesInView", data);
            };
            this.DeleteTaskType = function (id) {
                return $http.get(config.basePath + "DeleteTaskType/" + id);
            };
            this.TaskTypesInDropdown = function () {
                return $http.get(config.basePath + "TaskTypesInDropdown");
            };
            //////////////////.Project..//////////////////

            this.AddProject = function (data) {
                return $http.post(config.basePath + "AddProject", data);
            };
            this.ProjectsInView = function (data) {
                return $http.post(config.basePath + "ProjectsInView", data);
            };
            this.DeleteProject = function (id) {
                return $http.get(config.basePath + "DeleteProject/" + id);
            };
            this.ProjectsInDropdown = function () {
                return $http.get(config.basePath + "ProjectsInDropdown");
            };

            //////////////////.Task..//////////////////

            this.AddTask = function (data) {
                return $http.post(config.basePath + "AddTask", data);
            };
            this.TasksInView = function (data) {
                return $http.post(config.basePath + "TasksInView", data);
            };
            this.DeleteTask = function (id) {
                return $http.get(config.basePath + "DeleteTask/" + id);
            };
            this.TasksInDropdown = function () {
                return $http.get(config.basePath + "TasksInDropdown");
            };

            //////////////////.Credit Note SR..//////////////////

            this.GetNextCreditNoteSRNo = function () {
                return $http.get(config.basePath + "GetNextCreditNoteSRNo");
            };

            this.AddCreditNoteSR = function (data) {
                return $http.post(config.basePath + "AddCreditNoteSR", data);
            };
            this.CreditNoteSRInView = function (data) {
                return $http.post(config.basePath + "CreditNoteSRInView", data);
            };
            this.RejectCreditNoteSR = function (data) {
                return $http.post(config.basePath + "RejectCreditNoteSR", data);
            };

            this.getCreditNoteSRbyId = function (id) {
                return $http.get(config.basePath + "getCreditNoteSRbyId/" + id);
            };
            this.getCreditNoteSRbyLinkingId = function (id) {
                return $http.get(config.basePath + "getCreditNoteSRbyLinkingId/" + id);
            };
            this.GetCreditNoteSRForLinking = function (id) {
                return $http.get(config.basePath + "GetCreditNoteSRForLinking/" + id);
            };
            this.GetCreditNoteSRForLinkingCost = function (id) {
                return $http.get(config.basePath + "GetCreditNoteSRForLinkingCost/" + id);
            };
            this.DeleteCreditNoteSR = function (id) {
                return $http.get(config.basePath + "DeleteCreditNoteSR/" + id);
            };
            this.ResaveAllCreditNoteSR = function () {
                return $http.get(config.basePath + "ResaveAllCreditNoteSR");
            };
            this.GetNextSalesVoucherNo = function () {
                return $http.get(config.basePath + "GetNextSalesVoucherNo");
            };
            this.GetNextPurchaseVoucherNo = function () {
                return $http.get(config.basePath + "GetNextPurchaseVoucherNo");
            };
            this.GetBackCreditNoteSR = function (id, type) {
                return $http.get(config.basePath + "GetBackCreditNoteSR/" + id + "/" + type);
            };


            //////////////////. Vacation request .//////////////////

            this.SaveVacationRequest = function (data) {
                return $http.post(config.basePath + "SaveVacationRequest", data);
            };
            this.GetNextVacationRequestNo = function () {
                return $http.get(config.basePath + "GetNextVacationRequestNo");
            };
            this.GetVacationRequest = function (id) {
                return $http.get(config.basePath + "GetVacationRequest/" + id);
            };
            this.GetBackVacationRequest = function (id, type) {
                return $http.get(config.basePath + "GetBackVacationRequest/" + id + "/" + type);
            };
            this.EmployeeVacationSettings = function (id, cid) {
                return $http.get(config.basePath + "EmployeeVacationSettings/" + id + "/" + cid);
            };
            this.DeleteVacationRequest = function (id) {
                return $http.get(config.basePath + "DeleteVacationRequest/" + id);
            };

            //////////////////. Vacation settings .//////////////////

            this.VacationSettingsByGradeId = function (id) {
                return $http.get(config.basePath + "VacationSettingsByGradeId/" + id);
            };
            this.VacationSettingsInVacationReq = function (id) {
                return $http.get(config.basePath + "VacationSettingsInVacationReq/" + id);
            };
            this.AddVacationSettings = function (data) {
                return $http.post(config.basePath + "AddVacationSettings", data);
            };

            //////////////////. Vacation join .//////////////////


            this.SaveVacationJoin = function (data) {
                return $http.post(config.basePath + "SaveVacationJoin", data);
            };
            this.VacationJoinsInView = function (data) {
                return $http.post(config.basePath + "VacationJoinsInView", data);
            };
            this.DeleteVacationJoin = function (id) {
                return $http.get(config.basePath + "DeleteVacationJoin/" + id);
            };
            this.GetNextVacationJoinNo = function () {
                return $http.get(config.basePath + "GetNextVacationJoinNo");
            };

            //////////////////. Employee Attendance .//////////////////

            this.AddEmployeeAttendance = function (data) {
                return $http.post(config.basePath + "AddEmployeeAttendance", data);
            };
            this.EmployeeAttendanceDetailReport = function (data) {
                return $http.post(config.basePath + "EmployeeAttendanceDetailReport", data);
            };
            this.EmployeeVacationLedgerInView = function (data) {
                return $http.post(config.basePath + "EmployeeVacationLedgerInView", data);
            };

            this.GetNextEmployeeAttendanceNo = function () {
                return $http.get(config.basePath + "GetNextEmployeeAttendanceNo");
            };
            this.GetEmployeeAttendance = function (id) {
                return $http.get(config.basePath + "GetEmployeeAttendance/" + id);
            };
            this.PayrollComponentsByType = function (id) {
                return $http.get(config.basePath + "PayrollComponentsByType/" + id);
            };
            this.DeleteEmployeeAttendance = function (id) {
                return $http.get(config.basePath + "DeleteEmployeeAttendance/" + id);
            };
            this.GetBackEmployeeAttendance = function (id, type, grade) {
                return $http.get(config.basePath + "GetBackEmployeeAttendance/" + id + "/" + type + "/" + grade);
            };
            this.CheckEmployeeAttendanceByDate = function (year, month, day, grade) {
                return $http.get(config.basePath + "CheckEmployeeAttendanceByDate/" + year + "/" + month + "/" + day + "/" + grade);
            };

            this.GetCurrentDayAttendance = function () {
                return $http.get(config.basePath + "GetCurrentDayAttendance");
            };
            this.EmployeeDocsInHome = function () {
                return $http.get(config.basePath + "EmployeeDocsInHome");
            };
            this.GetPayrollSettings = function () {
                return $http.get(config.basePath + "GetPayrollSettings");
            };
            this.AddPayrollSettings = function (data) {
                return $http.post(config.basePath + "AddPayrollSettings", data);
            };
            this.AddPayrollSettingsGrade = function (data) {
                return $http.post(config.basePath + "AddPayrollSettingsGrade", data);
            };
            this.GetPayrollSettingsGrade = function (id) {
                return $http.get(config.basePath + "GetPayrollSettingsGrade/" + id);
            };
            this.MostSellingItemsReport = function (data) {
                return $http.post(config.basePath + "MostSellingItemsReport", data);
            };

            this.EmployeeLeaveReport = function (data) {
                return $http.post(config.basePath + "EmployeeLeaveReport", data);
            };
            this.AddEmployeeSalary = function (data) {
                return $http.post(config.basePath + "AddEmployeeSalary", data);
            };
            this.EmployeeSalaryInView = function (data) {
                return $http.post(config.basePath + "EmployeeSalaryInView", data);
            };
            this.GetBalanceEmployees = function (data) {
                return $http.post(config.basePath + "GetBalanceEmployees", data);
            };
            this.GetBalanceEmployeesGrade = function (data) {
                return $http.post(config.basePath + "GetBalanceEmployeesGrade", data);
            };
            this.GetMonthlyAttLeaveSummary = function (data) {
                return $http.post(config.basePath + "GetMonthlyAttLeaveSummary", data);
            };
            this.GetNextEmployeeSalaryNo = function () {
                return $http.get(config.basePath + "GetNextEmployeeSalaryNo");
            };
            this.GetBackEmployeeSalary = function (id, type) {
                return $http.get(config.basePath + "GetBackEmployeeSalary/" + id + "/" + type);
            };
            this.CheckEmployeeSalaryByDate = function (year, month, empId) {
                return $http.get(config.basePath + "CheckEmployeeSalaryByDate/" + year + "/" + month + "/" + empId);
            };
            this.GetEmployeeSalary = function (id) {
                return $http.get(config.basePath + "GetEmployeeSalary/" + id);
            };
            this.DeleteEmployeeSalary = function (id) {
                return $http.get(config.basePath + "DeleteEmployeeSalary/" + id);
            };
            this.GeEmployeePayrollById = function (id) {
                return $http.get(config.basePath + "GeEmployeePayrollById/" + id);
            };
            this.DeleteLeaveAllocation = function (id) {
                return $http.get(config.basePath + "DeleteLeaveAllocation/" + id);
            };
            this.GetEmployeeMonthlyAttandanceSummary = function (empId, year, month) {
                return $http.get(config.basePath + "GetEmployeeMonthlyAttandanceSummary/" + empId + "/" + year + "/" + month);
            };

            this.AddTableReorder = function (data) {
                return $http.post(config.basePath + "AddTableReorder", data);
            };
            this.PrintTimeSheetReport = function (data) {
                return $http.post(config.basePath + "PrintTimeSheetReport", data);
            };
            this.ExpiredEmpDocsReport = function (data) {
                return $http.post(config.basePath + "ExpiredEmpDocsReport", data);
            };
            this.FavouritesByUserGroup = function () {
                return $http.post(config.basePath + "FavouritesByUserGroup");
            };
          
            this.GetProductCost = function (data) {
                return $http.post(config.basePath + "GetProductCost", data);
            };
            this.GetPurchaseFIFOCost = function (pdt) {
                return $http.post(config.basePath + "GetPurchaseFIFOCost", pdt);
            };
            this.TableReorderByType = function (id) {
                return $http.get(config.basePath + "TableReorderByType/" + id);
            };
            this.PrintProductLabel = function (id) {
                return $http.get(config.basePath + "PrintProductLabel/" + id);
            };
            this.GetProductUnitsInDropdown = function (id) {
                return $http.get(config.basePath + "GetProductUnitsInDropdown/" + id);
            };


            //////////////// voucher reports ///////////////////

            this.SalesInvoiceDetailedReport = function (data) {
                return $http.post(config.basePath + "SalesInvoiceDetailedReport", data);
            };
            this.SalesInvoice2DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesInvoice2DetailedReport", data);
            };
            this.SalesInvoice3DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesInvoice3DetailedReport", data);
            };
            this.SalesInvoice4DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesInvoice4DetailedReport", data);
            };
            this.SalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesInvoiceSummaryReport", data);
            };
            this.SalesReturnDetailedReport = function (data) {
                return $http.post(config.basePath + "SalesReturnDetailedReport", data);
            };
            this.SalesReturnSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesReturnSummaryReport", data);
            };
            this.SalesQuotationDetailedReport = function (data) {
                return $http.post(config.basePath + "SalesQuotationDetailedReport", data);
            };
            this.SalesQuotation2DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesQuotation2DetailedReport", data);
            };
            this.SalesQuotation3DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesQuotation3DetailedReport", data);
            };
            this.SalesQuotation4DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesQuotation4DetailedReport", data);
            };
            this.SalesQuotationSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesQuotationSummaryReport", data);
            };
            this.SalesOrderDetailedReport = function (data) {
                return $http.post(config.basePath + "SalesOrderDetailedReport", data);
            };
            this.SalesOrder2DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesOrder2DetailedReport", data);
            };
            this.SalesOrder3DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesOrder3DetailedReport", data);
            };
            this.SalesOrder4DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesOrder4DetailedReport", data);
            };

            this.SalesOrderSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesOrderSummaryReport", data);
            };
            this.SalesEnquiryDetailedReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiryDetailedReport", data);
            };
            this.SalesEnquiry3DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiry3DetailedReport", data);
            };
            this.SalesEnquiry4DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiry4DetailedReport", data);
            };
            this.SalesEnquiry2DetailedReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiry2DetailedReport", data);
            };
            this.SalesEnquirySummaryReport = function (data) {
                return $http.post(config.basePath + "SalesEnquirySummaryReport", data);
            };
            this.PorSalesInvoiceDetailedReport = function (data) {
                return $http.post(config.basePath + "PorSalesInvoiceDetailedReport", data);
            };
            this.PorSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PorSalesInvoiceSummaryReport", data);
            };
            this.PackingListDetailedReport = function (data) {
                return $http.post(config.basePath + "PackingListDetailedReport", data);
            };
            this.PackingListSummaryReport = function (data) {
                return $http.post(config.basePath + "PackingListSummaryReport", data);
            };
            this.IndSalesInvoiceDetailedReport = function (data) {
                return $http.post(config.basePath + "IndSalesInvoiceDetailedReport", data);
            };
            this.IndSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "IndSalesInvoiceSummaryReport", data);
            };
            this.ExpSalesInvoiceDetailedReport = function (data) {
                return $http.post(config.basePath + "ExpSalesInvoiceDetailedReport", data);
            };
            this.ExpSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "ExpSalesInvoiceSummaryReport", data);
            };
            this.DirSalesInvoiceDetailedReport = function (data) {
                return $http.post(config.basePath + "DirSalesInvoiceDetailedReport", data);
            };
            this.DirSalesInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "DirSalesInvoiceSummaryReport", data);
            };
            this.DeliveryNoteDetailedReport = function (data) {
                return $http.post(config.basePath + "DeliveryNoteDetailedReport", data);
            };
            this.DeliveryNote2DetailedReport = function (data) {
                return $http.post(config.basePath + "DeliveryNote2DetailedReport", data);
            };
            this.DeliveryNote3DetailedReport = function (data) {
                return $http.post(config.basePath + "DeliveryNote3DetailedReport", data);
            };
            this.DeliveryNote4DetailedReport = function (data) {
                return $http.post(config.basePath + "DeliveryNote4DetailedReport", data);
            };

            this.DeliveryNoteSummaryReport = function (data) {
                return $http.post(config.basePath + "DeliveryNoteSummaryReport", data);
            };
            this.CreditNoteSRDetailedReport = function (data) {
                return $http.post(config.basePath + "CreditNoteSRDetailedReport", data);
            };
            this.CreditNoteSRSummaryReport = function (data) {
                return $http.post(config.basePath + "CreditNoteSRSummaryReport", data);
            };
            this.DirPurchaseInvoiceDetailedReport = function (data) {
                return $http.post(config.basePath + "DirPurchaseInvoiceDetailedReport", data);
            };
            this.DirPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "DirPurchaseInvoiceSummaryReport", data);
            };
            this.ExpPurchaseInvoiceDetailedReport = function (data) {
                return $http.post(config.basePath + "ExpPurchaseInvoiceDetailedReport", data);
            };
            this.ExpPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "ExpPurchaseInvoiceSummaryReport", data);
            };
            this.GoodsReceivedDetailedReport = function (data) {
                return $http.post(config.basePath + "GoodsReceivedDetailedReport", data);
            };
            this.GoodsReceivedSummaryReport = function (data) {
                return $http.post(config.basePath + "GoodsReceivedSummaryReport", data);
            };
            this.ImpPurchaseInvoiceDetailedReport = function (data) {
                return $http.post(config.basePath + "ImpPurchaseInvoiceDetailedReport", data);
            };
            this.ImpPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "ImpPurchaseInvoiceSummaryReport", data);
            };
            this.IndPurchaseInvoiceDetailedReport = function (data) {
                return $http.post(config.basePath + "IndPurchaseInvoiceDetailedReport", data);
            };
            this.IndPurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "IndPurchaseInvoiceSummaryReport", data);
            };
            this.PurchaseEnquiryDetailedReport = function (data) {
                return $http.post(config.basePath + "PurchaseEnquiryDetailedReport", data);
            };
            this.PurchaseEnquirySummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseEnquirySummaryReport", data);
            };
            this.PurchaseInvoiceDetailedReport = function (data) {
                return $http.post(config.basePath + "PurchaseInvoiceDetailedReport", data);
            };
            this.PurchaseInvoiceSummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseInvoiceSummaryReport", data);
            };
            this.PurchaseOrderDetailedReport = function (data) {
                return $http.post(config.basePath + "PurchaseOrderDetailedReport", data);
            };
            this.PurchaseOrderSummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseOrderSummaryReport", data);
            };
            this.PurchaseQuotationDetailedReport = function (data) {
                return $http.post(config.basePath + "PurchaseQuotationDetailedReport", data);
            };
            this.PurchaseQuotationSummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseQuotationSummaryReport", data);
            };

            this.MaterialRequestDetailedReport = function (data) {
                return $http.post(config.basePath + "MaterialRequestDetailedReport", data);
            };
            this.MaterialRequestSummaryReport = function (data) {
                return $http.post(config.basePath + "MaterialRequestSummaryReport", data);
            };

            this.PurchaseRequestDetailedReport = function (data) {
                return $http.post(config.basePath + "PurchaseRequestDetailedReport", data);
            };
            this.PurchaseRequestSummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseRequestSummaryReport", data);
            };
            this.PurchaseReturnDetailedReport = function (data) {
                return $http.post(config.basePath + "PurchaseReturnDetailedReport", data);
            };
            this.PurchaseReturnSummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseReturnSummaryReport", data);
            };


            this.AddCustomerDriverPayConfig = function (data) {
                return $http.post(config.basePath + "AddCustomerDriverPayConfig", data);
            };
            this.CustomerDriverPayConfigInView = function (data) {
                return $http.post(config.basePath + "CustomerDriverPayConfigInView", data);
            };
            this.CheckCustomerDriverPayConfig = function (data) {
                return $http.post(config.basePath + "CheckCustomerDriverPayConfig", data);
            };
            this.GetCustomerDriverPayConfig = function (id) {
                return $http.get(config.basePath + "GetCustomerDriverPayConfig/" + id);
            };
            this.DeleteCustomerDriverPayConfig = function (id) {
                return $http.get(config.basePath + "DeleteCustomerDriverPayConfig/" + id);
            };


            this.AddDriverPaymentSheet = function (data) {
                return $http.post(config.basePath + "AddDriverPaymentSheet", data);
            };
            this.DriverPaymentSheetInView = function (data) {
                return $http.post(config.basePath + "DriverPaymentSheetInView", data);
            };
            this.GetNextDriverPaymentSheetNo = function () {
                return $http.get(config.basePath + "GetNextDriverPaymentSheetNo");
            };
            this.GetBackDriverPaymentSheet = function (id, type) {
                return $http.get(config.basePath + "GetBackDriverPaymentSheet/" + id + "/" + type);
            };

            this.GetDriverPaymentSheet = function (id) {
                return $http.get(config.basePath + "GetDriverPaymentSheet/" + id);
            };
            this.DeleteDriverPaymentSheet = function (id) {
                return $http.get(config.basePath + "DeleteDriverPaymentSheet/" + id);
            };

            this.AddVoucherApprovalConfig = function (data) {
                return $http.post(config.basePath + "AddVoucherApprovalConfig", data);
            };

            this.GetVoucherApprovalConfig = function (id) {
                return $http.get(config.basePath + "GetVoucherApprovalConfig/" + id);
            };
            this.DeleteVoucherApprovalConfig = function (id) {
                return $http.get(config.basePath + "DeleteVoucherApprovalConfig/" + id);
            };
            this.GetEmployeeUsers = function () {
                return $http.get(config.basePath + "GetEmployeeUsers");
            };

            this.AddReportConfig = function (data) {
                return $http.post(config.basePath + "AddReportConfig", data);
            };

            this.ReportConfigsbyType = function (name, type) {
                return $http.get(config.basePath + "ReportConfigsbyType/" + name + "/" + type);
            };

            //////////////////. History .//////////////////


            this.SalesInvoiceHistory = function (id) {
                return $http.get(config.basePath + "SalesInvoiceHistory/" + id);
            };
            this.DirPurchaseInvoiceHistory = function (id) {
                return $http.get(config.basePath + "DirPurchaseInvoiceHistory/" + id);
            };
            this.ExpPurchaseInvoiceHistory = function (id) {
                return $http.get(config.basePath + "ExpPurchaseInvoiceHistory/" + id);
            };
            this.GoodsReceivedHistory = function (id) {
                return $http.get(config.basePath + "GoodsReceivedHistory/" + id);
            };
            this.ImpPurchaseInvoiceHistory = function (id) {
                return $http.get(config.basePath + "ImpPurchaseInvoiceHistory/" + id);
            };
            this.IndPurchaseInvoiceHistory = function (id) {
                return $http.get(config.basePath + "IndPurchaseInvoiceHistory/" + id);
            };
            this.PurchaseEnquiryHistory = function (id) {
                return $http.get(config.basePath + "PurchaseEnquiryHistory/" + id);
            };
            this.PurchaseInvoiceHistory = function (id) {
                return $http.get(config.basePath + "PurchaseInvoiceHistory/" + id);
            };
            this.PurchaseOrderHistory = function (id) {
                return $http.get(config.basePath + "PurchaseOrderHistory/" + id);
            };
            this.PurchaseQuotationHistory = function (id) {
                return $http.get(config.basePath + "PurchaseQuotationHistory/" + id);
            };
            this.PurchaseRequestHistory = function (id) {
                return $http.get(config.basePath + "PurchaseRequestHistory/" + id);
            };
            this.MaterialRequestHistory = function (id) {
                return $http.get(config.basePath + "MaterialRequestHistory/" + id);
            };
            this.PurchaseReturnHistory = function (id) {
                return $http.get(config.basePath + "PurchaseReturnHistory/" + id);
            };
            this.CreditNoteSRHistory = function (id) {
                return $http.get(config.basePath + "CreditNoteSRHistory/" + id);
            };
            this.DeliveryNote2History = function (id) {
                return $http.get(config.basePath + "DeliveryNote2History/" + id);
            };
            this.DeliveryNote3History = function (id) {
                return $http.get(config.basePath + "DeliveryNote3History/" + id);
            };
            this.DeliveryNote4History = function (id) {
                return $http.get(config.basePath + "DeliveryNote4History/" + id);
            };
            this.DeliveryNoteHistory = function (id) {
                return $http.get(config.basePath + "DeliveryNoteHistory/" + id);
            };
            this.DirSalesInvoiceHistory = function (id) {
                return $http.get(config.basePath + "DirSalesInvoiceHistory/" + id);
            };
            this.ExpSalesInvoiceHistory = function (id) {
                return $http.get(config.basePath + "ExpSalesInvoiceHistory/" + id);
            };
            this.IndSalesInvoiceHistory = function (id) {
                return $http.get(config.basePath + "IndSalesInvoiceHistory/" + id);
            };
            this.PackingListHistory = function (id) {
                return $http.get(config.basePath + "PackingListHistory/" + id);
            };
            this.ProSalesInvoiceHistory = function (id) {
                return $http.get(config.basePath + "ProSalesInvoiceHistory/" + id);
            };
            this.SalesEnquiry2History = function (id) {
                return $http.get(config.basePath + "SalesEnquiry2History/" + id);
            };
            this.SalesEnquiry3History = function (id) {
                return $http.get(config.basePath + "SalesEnquiry3History/" + id);
            };
            this.SalesEnquiry4History = function (id) {
                return $http.get(config.basePath + "SalesEnquiry4History/" + id);
            };
            this.SalesEnquiryHistory = function (id) {
                return $http.get(config.basePath + "SalesEnquiryHistory/" + id);
            };
            this.SalesInvoice2History = function (id) {
                return $http.get(config.basePath + "SalesInvoice2History/" + id);
            };
            this.SalesInvoice3History = function (id) {
                return $http.get(config.basePath + "SalesInvoice3History/" + id);
            };
            this.SalesInvoice4History = function (id) {
                return $http.get(config.basePath + "SalesInvoice4History/" + id);
            };
            this.SalesInvoiceHistory = function (id) {
                return $http.get(config.basePath + "SalesInvoiceHistory/" + id);
            };
            this.SalesOrder2History = function (id) {
                return $http.get(config.basePath + "SalesOrder2History/" + id);
            };
            this.SalesOrder3History = function (id) {
                return $http.get(config.basePath + "SalesOrder3History/" + id);
            };
            this.SalesOrder4History = function (id) {
                return $http.get(config.basePath + "SalesOrder4History/" + id);
            };
            this.SalesOrderHistory = function (id) {
                return $http.get(config.basePath + "SalesOrderHistory/" + id);
            };
            this.SalesQuotation2History = function (id) {
                return $http.get(config.basePath + "SalesQuotation2History/" + id);
            };
            this.SalesQuotation3History = function (id) {
                return $http.get(config.basePath + "SalesQuotation3History/" + id);
            };
            this.SalesQuotation4History = function (id) {
                return $http.get(config.basePath + "SalesQuotation4History/" + id);
            };
            this.SalesQuotationHistory = function (id) {
                return $http.get(config.basePath + "SalesQuotationHistory/" + id);
            };
            this.SalesReturnHistory = function (id) {
                return $http.get(config.basePath + "SalesReturnHistory/" + id);
            };

            this.SalesQuotationRevisions = function (id) {
                return $http.get(config.basePath + "SalesQuotationRevisions/" + id);
            };
            this.CreditNoteSRRevisions = function (id) {
                return $http.get(config.basePath + "CreditNoteSRRevisions/" + id);
            };
            this.DeliveryNote2Revisions = function (id) {
                return $http.get(config.basePath + "DeliveryNote2Revisions/" + id);
            };
            this.DeliveryNote3Revisions = function (id) {
                return $http.get(config.basePath + "DeliveryNote3Revisions/" + id);
            };
            this.DeliveryNote4Revisions = function (id) {
                return $http.get(config.basePath + "DeliveryNote4Revisions/" + id);
            };
            this.DeliveryNoteRevisions = function (id) {
                return $http.get(config.basePath + "DeliveryNoteRevisions/" + id);
            };
            this.DirSalesInvoiceRevisions = function (id) {
                return $http.get(config.basePath + "DirSalesInvoiceRevisions/" + id);
            };
            this.ExpSalesInvoiceRevisions = function (id) {
                return $http.get(config.basePath + "ExpSalesInvoiceRevisions/" + id);
            };
            this.IndSalesInvoiceRevisions = function (id) {
                return $http.get(config.basePath + "IndSalesInvoiceRevisions/" + id);
            };
            this.PackingListRevisions = function (id) {
                return $http.get(config.basePath + "PackingListRevisions/" + id);
            };
            this.ProSalesInvoiceRevisions = function (id) {
                return $http.get(config.basePath + "ProSalesInvoiceRevisions/" + id);
            };
            this.SalesEnquiry2Revisions = function (id) {
                return $http.get(config.basePath + "SalesEnquiry2Revisions/" + id);
            };
            this.SalesEnquiry3Revisions = function (id) {
                return $http.get(config.basePath + "SalesEnquiry3Revisions/" + id);
            };
            this.SalesEnquiry4Revisions = function (id) {
                return $http.get(config.basePath + "SalesEnquiry4Revisions/" + id);
            };
            this.SalesEnquiryRevisions = function (id) {
                return $http.get(config.basePath + "SalesEnquiryRevisions/" + id);
            };
            this.SalesInvoice2Revisions = function (id) {
                return $http.get(config.basePath + "SalesInvoice2Revisions/" + id);
            };
            this.SalesInvoice3Revisions = function (id) {
                return $http.get(config.basePath + "SalesInvoice3Revisions/" + id);
            };
            this.SalesInvoice4Revisions = function (id) {
                return $http.get(config.basePath + "SalesInvoice4Revisions/" + id);
            };
            this.SalesInvoiceRevisions = function (id) {
                return $http.get(config.basePath + "SalesInvoiceRevisions/" + id);
            };
            this.SalesOrder2Revisions = function (id) {
                return $http.get(config.basePath + "SalesOrder2Revisions/" + id);
            };
            this.SalesOrder3Revisions = function (id) {
                return $http.get(config.basePath + "SalesOrder3Revisions/" + id);
            };
            this.SalesOrder4Revisions = function (id) {
                return $http.get(config.basePath + "SalesOrder4Revisions/" + id);
            };
            this.SalesOrderRevisions = function (id) {
                return $http.get(config.basePath + "SalesOrderRevisions/" + id);
            };
            this.SalesQuotation2Revisions = function (id) {
                return $http.get(config.basePath + "SalesQuotation2Revisions/" + id);
            };
            this.SalesQuotation3Revisions = function (id) {
                return $http.get(config.basePath + "SalesQuotation3Revisions/" + id);
            };
            this.SalesQuotation4Revisions = function (id) {
                return $http.get(config.basePath + "SalesQuotation4Revisions/" + id);
            };
            this.SalesReturnRevisions = function (id) {
                return $http.get(config.basePath + "SalesReturnRevisions/" + id);
            };
            this.DirPurchaseInvoiceRevisions = function (id) {
                return $http.get(config.basePath + "DirPurchaseInvoiceRevisions/" + id);
            };
            this.ExpPurchaseInvoiceRevisions = function (id) {
                return $http.get(config.basePath + "ExpPurchaseInvoiceRevisions/" + id);
            };
            this.GoodsReceivedRevisions = function (id) {
                return $http.get(config.basePath + "GoodsReceivedRevisions/" + id);
            };
            this.ImpPurchaseInvoiceRevisions = function (id) {
                return $http.get(config.basePath + "ImpPurchaseInvoiceRevisions/" + id);
            };
            this.IndPurchaseInvoiceRevisions = function (id) {
                return $http.get(config.basePath + "IndPurchaseInvoiceRevisions/" + id);
            };
            this.PurchaseEnquiryRevisions = function (id) {
                return $http.get(config.basePath + "PurchaseEnquiryRevisions/" + id);
            };
            this.PurchaseInvoiceRevisions = function (id) {
                return $http.get(config.basePath + "PurchaseInvoiceRevisions/" + id);
            };
            this.PurchaseOrderRevisions = function (id) {
                return $http.get(config.basePath + "PurchaseOrderRevisions/" + id);
            };
            this.PurchaseQuotationRevisions = function (id) {
                return $http.get(config.basePath + "PurchaseQuotationRevisions/" + id);
            };
            this.PurchaseRequestRevisions = function (id) {
                return $http.get(config.basePath + "PurchaseRequestRevisions/" + id);
            };
            this.MaterialRequestRevisions = function (id) {
                return $http.get(config.basePath + "MaterialRequestRevisions/" + id);
            };
            this.PurchaseReturnRevisions = function (id) {
                return $http.get(config.basePath + "PurchaseReturnRevisions/" + id);
            };


            //////////////////. Approvals .//////////////////

            this.GetVoucherApprovalHistory = function (id, vno, vname) {
                return $http.get(config.basePath + "GetVoucherApprovalHistory/" + id + "/" + vno + "/" + vname);
            };
            this.GetPendApprovalDocsCountPurchase = function () {
                return $http.get(config.basePath + "GetPendApprovalDocsCountPurchase");
            };
            this.GetPendApprovalDocsCountSales = function () {
                return $http.get(config.basePath + "GetPendApprovalDocsCountSales");
            };
            this.GetPendApprovalDocsCountPayments = function () {
                return $http.get(config.basePath + "GetPendApprovalDocsCountPayments");
            };
            this.GetPendApprovalDocsCountReceipts = function () {
                return $http.get(config.basePath + "GetPendApprovalDocsCountReceipts");
            };
            this.GetPendApprovalDocsCountBasics = function () {
                return $http.get(config.basePath + "GetPendApprovalDocsCountBasics");
            };
            this.GetPendApprovalDocsCountStock = function () {
                return $http.get(config.basePath + "GetPendApprovalDocsCountStock");
            };
            this.ApprovePurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ApprovePurchaseInvoice/" + id);
            };

            this.ApproveDirPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ApproveDirPurchaseInvoice/" + id);
            };

            this.ApproveDirPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ApproveDirPurchaseInvoice/" + id);
            };

            this.ApproveExpPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ApproveExpPurchaseInvoice/" + id);
            };
            this.ApproveGoodsReceived = function (id) {
                return $http.get(config.basePath + "ApproveGoodsReceived/" + id);
            };
            this.ApproveImpPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ApproveImpPurchaseInvoice/" + id);
            };
            this.ApproveIndPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ApproveIndPurchaseInvoice/" + id);
            };
            this.ApprovePurchaseEnquiry = function (id) {
                return $http.get(config.basePath + "ApprovePurchaseEnquiry/" + id);
            };
            this.ApprovePurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ApprovePurchaseInvoice/" + id);
            };
            this.ApprovePurchaseOrder = function (id) {
                return $http.get(config.basePath + "ApprovePurchaseOrder/" + id);
            };
            this.ApprovePurchaseQuotation = function (id) {
                return $http.get(config.basePath + "ApprovePurchaseQuotation/" + id);
            };
            this.ApprovePurchaseRequest = function (id) {
                return $http.get(config.basePath + "ApprovePurchaseRequest/" + id);
            };

            this.ApproveMaterialRequest = function (id) {
                return $http.get(config.basePath + "ApproveMaterialRequest/" + id);
            };
            this.ApproveDirPurchaseReturn = function (id) {
                return $http.get(config.basePath + "ApproveDirPurchaseReturn/" + id);
            };
            this.ApproveSalesReturn = function (id) {
                return $http.get(config.basePath + "ApproveSalesReturn/" + id);
            };
            this.ApproveSalesQuotation = function (id) {
                return $http.get(config.basePath + "ApproveSalesQuotation/" + id);
            };
            this.ApproveSalesQuotation4 = function (id) {
                return $http.get(config.basePath + "ApproveSalesQuotation4/" + id);
            };
            this.ApproveSalesQuotation3 = function (id) {
                return $http.get(config.basePath + "ApproveSalesQuotation3/" + id);
            };
            this.ApproveSalesQuotation2 = function (id) {
                return $http.get(config.basePath + "ApproveSalesQuotation2/" + id);
            };
            this.ApproveSalesOrder = function (id) {
                return $http.get(config.basePath + "ApproveSalesOrder/" + id);
            };

            this.ApproveSalesOrder4 = function (id) {
                return $http.get(config.basePath + "ApproveSalesOrder4/" + id);
            };
            this.ApproveSalesOrder3 = function (id) {
                return $http.get(config.basePath + "ApproveSalesOrder3/" + id);
            };
            this.ApproveSalesOrder2 = function (id) {
                return $http.get(config.basePath + "ApproveSalesOrder2/" + id);
            };
            this.ApproveSalesInvoice = function (id) {
                return $http.get(config.basePath + "ApproveSalesInvoice/" + id);
            };

            this.ApproveSalesInvoice4 = function (id) {
                return $http.get(config.basePath + "ApproveSalesInvoice4/" + id);
            };
            this.ApproveSalesInvoice3 = function (id) {
                return $http.get(config.basePath + "ApproveSalesInvoice3/" + id);
            };
            this.ApproveSalesInvoice2 = function (id) {
                return $http.get(config.basePath + "ApproveSalesInvoice2/" + id);
            };

            this.ApproveSalesEnquiry = function (id) {
                return $http.get(config.basePath + "ApproveSalesEnquiry/" + id);
            };
            this.ApproveSalesEnquiry4 = function (id) {
                return $http.get(config.basePath + "ApproveSalesEnquiry4/" + id);
            };
            this.ApproveSalesEnquiry3 = function (id) {
                return $http.get(config.basePath + "ApproveSalesEnquiry3/" + id);
            };
            this.ApproveSalesEnquiry2 = function (id) {
                return $http.get(config.basePath + "ApproveSalesEnquiry2/" + id);
            };
            this.ApproveProSalesInvoice = function (id) {
                return $http.get(config.basePath + "ApproveProSalesInvoice/" + id);
            };
            this.ApprovePackingList = function (id) {
                return $http.get(config.basePath + "ApprovePackingList/" + id);
            };
            this.ApproveIndSalesInvoice = function (id) {
                return $http.get(config.basePath + "ApproveIndSalesInvoice/" + id);
            };
            this.ApproveExpSalesInvoice = function (id) {
                return $http.get(config.basePath + "ApproveExpSalesInvoice/" + id);
            };
            this.ApproveDirSalesInvoice = function (id) {
                return $http.get(config.basePath + "ApproveDirSalesInvoice/" + id);
            };
            this.ApproveDeliveryNote = function (id) {
                return $http.get(config.basePath + "ApproveDeliveryNote/" + id);
            };
            this.ApproveDeliveryNote4 = function (id) {
                return $http.get(config.basePath + "ApproveDeliveryNote4/" + id);
            };
            this.ApproveDeliveryNote3 = function (id) {
                return $http.get(config.basePath + "ApproveDeliveryNote3/" + id);
            };
            this.ApproveDeliveryNote2 = function (id) {
                return $http.get(config.basePath + "ApproveDeliveryNote2/" + id);
            };
            this.ApproveCreditNoteSR = function (id) {
                return $http.get(config.basePath + "ApproveCreditNoteSR/" + id);
            };


            this.ResubmitCreditNoteSR = function (id) {
                return $http.get(config.basePath + "ResubmitCreditNoteSR/" + id);
            };
            this.ResubmitDeliveryNote2 = function (id) {
                return $http.get(config.basePath + "ResubmitDeliveryNote2/" + id);
            };
            this.ResubmitDeliveryNote3 = function (id) {
                return $http.get(config.basePath + "ResubmitDeliveryNote3/" + id);
            };
            this.ResubmitDeliveryNote4 = function (id) {
                return $http.get(config.basePath + "ResubmitDeliveryNote4/" + id);
            };
            this.ResubmitDeliveryNote = function (id) {
                return $http.get(config.basePath + "ResubmitDeliveryNote/" + id);
            };
            this.ResubmitDirSalesInvoice = function (id) {
                return $http.get(config.basePath + "ResubmitDirSalesInvoice/" + id);
            };
            this.ResubmitExpSalesInvoice = function (id) {
                return $http.get(config.basePath + "ResubmitExpSalesInvoice/" + id);
            };
            this.ResubmitIndSalesInvoice = function (id) {
                return $http.get(config.basePath + "ResubmitIndSalesInvoice/" + id);
            };
            this.ResubmitPackingList = function (id) {
                return $http.get(config.basePath + "ResubmitPackingList/" + id);
            };
            this.ResubmitProSalesInvoice = function (id) {
                return $http.get(config.basePath + "ResubmitProSalesInvoice/" + id);
            };
            this.ResubmitSalesEnquiry2 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesEnquiry2/" + id);
            };
            this.ResubmitSalesEnquiry3 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesEnquiry3/" + id);
            };
            this.ResubmitSalesEnquiry4 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesEnquiry4/" + id);
            };
            this.ResubmitSalesEnquiry = function (id) {
                return $http.get(config.basePath + "ResubmitSalesEnquiry/" + id);
            };
            this.ResubmitSalesInvoice2 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesInvoice2/" + id);
            };
            this.ResubmitSalesInvoice3 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesInvoice3/" + id);
            };
            this.ResubmitSalesInvoice4 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesInvoice4/" + id);
            };
            this.ResubmitSalesInvoice = function (id) {
                return $http.get(config.basePath + "ResubmitSalesInvoice/" + id);
            };
            this.ResubmitSalesOrder2 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesOrder2/" + id);
            };
            this.ResubmitSalesOrder3 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesOrder3/" + id);
            };
            this.ResubmitSalesOrder4 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesOrder4/" + id);
            };
            this.ResubmitSalesOrder = function (id) {
                return $http.get(config.basePath + "ResubmitSalesOrder/" + id);
            };
            this.ResubmitSalesQuotation2 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesQuotation2/" + id);
            };
            this.ResubmitSalesQuotation3 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesQuotation3/" + id);
            };
            this.ResubmitSalesQuotation4 = function (id) {
                return $http.get(config.basePath + "ResubmitSalesQuotation4/" + id);
            };
            this.ResubmitSalesQuotation = function (id) {
                return $http.get(config.basePath + "ResubmitSalesQuotation/" + id);
            };
            this.ResubmitSalesReturn = function (id) {
                return $http.get(config.basePath + "ResubmitSalesReturn/" + id);
            };
            this.ResubmitDirPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ResubmitDirPurchaseInvoice/" + id);
            };
            this.ResubmitExpPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ResubmitExpPurchaseInvoice/" + id);
            };
            this.ResubmitGoodsReceived = function (id) {
                return $http.get(config.basePath + "ResubmitGoodsReceived/" + id);
            };
            this.ResubmitImpPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ResubmitImpPurchaseInvoice/" + id);
            };
            this.ResubmitIndPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ResubmitIndPurchaseInvoice/" + id);
            };
            this.ResubmitMaterialRequest = function (id) {
                return $http.get(config.basePath + "ResubmitMaterialRequest/" + id);
            };
            this.ResubmitPurchaseEnquiry = function (id) {
                return $http.get(config.basePath + "ResubmitPurchaseEnquiry/" + id);
            };
            this.ResubmitPurchaseInvoice = function (id) {
                return $http.get(config.basePath + "ResubmitPurchaseInvoice/" + id);
            };
            this.ResubmitPurchaseOrder = function (id) {
                return $http.get(config.basePath + "ResubmitPurchaseOrder/" + id);
            };
            this.ResubmitPurchaseQuotation = function (id) {
                return $http.get(config.basePath + "ResubmitPurchaseQuotation/" + id);
            };
            this.ResubmitPurchaseRequest = function (id) {
                return $http.get(config.basePath + "ResubmitPurchaseRequest/" + id);
            };
            this.ResubmitPurchaseReturn = function (id) {
                return $http.get(config.basePath + "ResubmitPurchaseReturn/" + id);
            };

            this.ProductSummary = function (id) {
                return $http.get(config.basePath + "ProductSummary/" + id);
            };
            this.GetRecipeItems = function (id) {
                return $http.get(config.basePath + "GetRecipeItems/" + id);
            };



            //////////////////. Approvals .//////////////////

            this.PostingTemplatesInDropdown = function () {
                return $http.get(config.basePath + "PostingTemplatesInDropdown");
            };
            this.DeletePostingTemplate = function (id) {
                return $http.get(config.basePath + "DeletePostingTemplate/" + id);
            };
            this.PostingTemplatesById = function (id) {
                return $http.get(config.basePath + "PostingTemplatesById/" + id);
            };

            this.PostingTemplatesInView = function (data) {
                return $http.post(config.basePath + "PostingTemplatesInView", data);
            };
            this.AddPostingTemplate = function (data) {
                return $http.post(config.basePath + "AddPostingTemplate", data);
            };

            this.GetAvailableSuppliersForProducts = function () {
                return $http.get(config.basePath + "GetAvailableSuppliersForProducts");
            };

            //////////////////. Dynamic Reports .//////////////////

            this.DirPurchaseInvoiceDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "DirPurchaseInvoiceDynamicSummaryReport", data);
            };
            this.ExpPurchaseInvoiceDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "ExpPurchaseInvoiceDynamicSummaryReport", data);
            };
            this.GoodsReceivedDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "GoodsReceivedDynamicSummaryReport", data);
            };
            this.ImpPurchaseInvoiceDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "ImpPurchaseInvoiceDynamicSummaryReport", data);
            };
            this.IndPurchaseInvoiceDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "IndPurchaseInvoiceDynamicSummaryReport", data);
            };
            this.MaterialRequestDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "MaterialRequestDynamicSummaryReport", data);
            };
            this.PurchaseEnquiryDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseEnquiryDynamicSummaryReport", data);
            };
            this.PurchaseInvoiceDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseInvoiceDynamicSummaryReport", data);
            };
            this.PurchaseOrderDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseOrderDynamicSummaryReport", data);
            };
            this.PurchaseQuotationDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseQuotationDynamicSummaryReport", data);
            };
            this.PurchaseRequestDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseRequestDynamicSummaryReport", data);
            };
            this.PurchaseReturnDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "PurchaseReturnDynamicSummaryReport", data);
            };
            this.CreditNoteSRDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "CreditNoteSRDynamicSummaryReport", data);
            };
            this.DeliveryNoteDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "DeliveryNoteDynamicSummaryReport", data);
            };
            this.DeliveryNote2DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "DeliveryNote2DynamicSummaryReport", data);
            };
            this.DeliveryNote3DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "DeliveryNote3DynamicSummaryReport", data);
            };
            this.DeliveryNote4DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "DeliveryNote4DynamicSummaryReport", data);
            };

            this.DirSalesInvoiceDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "DirSalesInvoiceDynamicSummaryReport", data);
            };
            this.ExpSalesInvoiceDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "ExpSalesInvoiceDynamicSummaryReport", data);
            };
            this.IndSalesInvoiceDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "IndSalesInvoiceDynamicSummaryReport", data);
            };
            this.PackingListDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "PackingListDynamicSummaryReport", data);
            };
            this.ProSalesInvoiceDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "ProSalesInvoiceDynamicSummaryReport", data);
            };
            this.SalesEnquiryDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiryDynamicSummaryReport", data);
            };

            this.SalesEnquiry3DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiry3DynamicSummaryReport", data);
            };
            this.SalesEnquiry4DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiry4DynamicSummaryReport", data);
            };
            this.SalesEnquiry2DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiry2DynamicSummaryReport", data);
            };
            this.SalesInvoiceDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesInvoiceDynamicSummaryReport", data);
            };
            this.SalesInvoice2DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesInvoice2DynamicSummaryReport", data);
            };
            this.SalesInvoice3DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesInvoice3DynamicSummaryReport", data);
            };
            this.SalesInvoice4DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesInvoice4DynamicSummaryReport", data);
            };

            this.SalesOrderDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesOrderDynamicSummaryReport", data);
            };
            this.SalesOrder2DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesOrder2DynamicSummaryReport", data);
            };
            this.SalesOrder3DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesOrder3DynamicSummaryReport", data);
            };
            this.SalesOrder4DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesOrder4DynamicSummaryReport", data);
            };

            this.SalesQuotationDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesQuotationDynamicSummaryReport", data);
            };
            this.SalesQuotation2DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesQuotation2DynamicSummaryReport", data);
            };
            this.SalesQuotation3DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesQuotation3DynamicSummaryReport", data);
            };
            this.SalesQuotation4DynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesQuotation4DynamicSummaryReport", data);
            };
            this.SalesReturnDynamicSummaryReport = function (data) {
                return $http.post(config.basePath + "SalesReturnDynamicSummaryReport", data);
            };

            this.GetCustomerParentList = function () {
                return $http.get(config.basePath + "GetCustomerParentList");
            };
            this.GetVendorParentList = function () {
                return $http.get(config.basePath + "GetVendorParentList");
            };
            this.GetEmployeeParentList = function () {
                return $http.get(config.basePath + "GetEmployeeParentList");
            };

            this.RecipesInView = function (data) {
                return $http.post(config.basePath + "RecipesInView", data);
            };

            this.GetVoucherLinkHistory = function (id) {
                return $http.get(config.basePath + "GetVoucherLinkHistory/" + id);
            };

            //////////////////// print payment and receipts

            this.PrintOpeningBalanceSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintOpeningBalanceSummaryReport", data);
            };
            this.PrintOpeningBalanceDetailReport = function (data) {
                return $http.post(config.basePath + "PrintOpeningBalanceDetailReport", data);
            };
            this.PrintJournalVoucherSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintJournalVoucherSummaryReport", data);
            };
            this.PrintJournalVoucherDetailReport = function (data) {
                return $http.post(config.basePath + "PrintJournalVoucherDetailReport", data);
            };
            this.PrintFRVMasterSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintFRVMasterSummaryReport", data);
            };
            this.PrintFRVMasterDetailReport = function (data) {
                return $http.post(config.basePath + "PrintFRVMasterDetailReport", data);
            };
            this.PrintFPVMasterSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintFPVMasterSummaryReport", data);
            };
            this.PrintFPVMasterDetailReport = function (data) {
                return $http.post(config.basePath + "PrintFPVMasterDetailReport", data);
            };
            this.PrintDebitNoteSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintDebitNoteSummaryReport", data);
            };
            this.PrintDebitNoteDetailReport = function (data) {
                return $http.post(config.basePath + "PrintDebitNoteDetailReport", data);
            };
            this.PrintCRVMasterSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintCRVMasterSummaryReport", data);
            };
            this.PrintCRVMasterDetailReport = function (data) {
                return $http.post(config.basePath + "PrintCRVMasterDetailReport", data);
            };
            this.PrintCreditNoteSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintCreditNoteSummaryReport", data);
            };
            this.PrintCreditNoteDetailReport = function (data) {
                return $http.post(config.basePath + "PrintCreditNoteDetailReport", data);
            };
            this.PrintCPVMasterSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintCPVMasterSummaryReport", data);
            };
            this.PrintCPVMasterDetailReport = function (data) {
                return $http.post(config.basePath + "PrintCPVMasterDetailReport", data);
            };
            this.PrintCompanyExpenseSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintCompanyExpenseSummaryReport", data);
            };
            this.PrintCompanyExpenseDetailReport = function (data) {
                return $http.post(config.basePath + "PrintCompanyExpenseDetailReport", data);
            };
            this.PrintChequeRVMasterSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintChequeRVMasterSummaryReport", data);
            };
            this.PrintChequeRVMasterDetailReport = function (data) {
                return $http.post(config.basePath + "PrintChequeRVMasterDetailReport", data);
            };
            this.PrintChequePVMasterSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintChequePVMasterSummaryReport", data);
            };
            this.PrintChequePVMasterDetailReport = function (data) {
                return $http.post(config.basePath + "PrintChequePVMasterDetailReport", data);
            };

            this.ChequePVSummaryReport = function (data) {
                return $http.post(config.basePath + "ChequePVSummaryReport", data);
            };
            this.ChequePVDetailReport = function (data) {
                return $http.post(config.basePath + "ChequePVDetailReport", data);
            };
            this.ChequeRVSummaryReport = function (data) {
                return $http.post(config.basePath + "ChequeRVSummaryReport", data);
            };
            this.ChequeRVDetailReport = function (data) {
                return $http.post(config.basePath + "ChequeRVDetailReport", data);
            };
            this.CompanyExpenseSummaryReport = function (data) {
                return $http.post(config.basePath + "CompanyExpenseSummaryReport", data);
            };
            this.CompanyExpenseDetailReport = function (data) {
                return $http.post(config.basePath + "CompanyExpenseDetailReport", data);
            };
            this.CPVMasterSummaryReport = function (data) {
                return $http.post(config.basePath + "CPVMasterSummaryReport", data);
            };
            this.CPVMasterDetailReport = function (data) {
                return $http.post(config.basePath + "CPVMasterDetailReport", data);
            };
            this.CreditNoteSummaryReport = function (data) {
                return $http.post(config.basePath + "CreditNoteSummaryReport", data);
            };
            this.CreditNoteDetailReport = function (data) {
                return $http.post(config.basePath + "CreditNoteDetailReport", data);
            };
            this.CRVMasterSummaryReport = function (data) {
                return $http.post(config.basePath + "CRVMasterSummaryReport", data);
            };
            this.CRVMasterDetailReport = function (data) {
                return $http.post(config.basePath + "CRVMasterDetailReport", data);
            };
            this.DebitNoteSummaryReport = function (data) {
                return $http.post(config.basePath + "DebitNoteSummaryReport", data);
            };
            this.DebitNoteDetailReport = function (data) {
                return $http.post(config.basePath + "DebitNoteDetailReport", data);
            };
            this.FPVMasterSummaryReport = function (data) {
                return $http.post(config.basePath + "FPVMasterSummaryReport", data);
            };
            this.FPVMasterDetailReport = function (data) {
                return $http.post(config.basePath + "FPVMasterDetailReport", data);
            };
            this.FRVMasterSummaryReport = function (data) {
                return $http.post(config.basePath + "FRVMasterSummaryReport", data);
            };
            this.FRVMasterDetailReport = function (data) {
                return $http.post(config.basePath + "FRVMasterDetailReport", data);
            };
            this.JournalVoucherSummaryReport = function (data) {
                return $http.post(config.basePath + "JournalVoucherSummaryReport", data);
            };
            this.JournalVoucherDetailReport = function (data) {
                return $http.post(config.basePath + "JournalVoucherDetailReport", data);
            };
            this.OpeningBalanceSummaryReport = function (data) {
                return $http.post(config.basePath + "OpeningBalanceSummaryReport", data);
            };
            this.OpeningBalanceDetailReport = function (data) {
                return $http.post(config.basePath + "OpeningBalanceDetailReport", data);
            };




            this.DirPurchaseInvoiceInVoucherAuto = function (data) {
                return $http.post(config.basePath + "DirPurchaseInvoiceInVoucherAuto", data);
            };
            this.ExpPurchaseInvoiceInVoucherAuto = function (data) {
                return $http.post(config.basePath + "ExpPurchaseInvoiceInVoucherAuto", data);
            };
            this.GoodsReceivedInVoucherAuto = function (data) {
                return $http.post(config.basePath + "GoodsReceivedInVoucherAuto", data);
            };
            this.ImpPurchaseInvoiceInVoucherAuto = function (data) {
                return $http.post(config.basePath + "ImpPurchaseInvoiceInVoucherAuto", data);
            };
            this.IndPurchaseInvoiceInVoucherAuto = function (data) {
                return $http.post(config.basePath + "IndPurchaseInvoiceInVoucherAuto", data);
            };
            this.MaterialRequestInVoucherAuto = function (data) {
                return $http.post(config.basePath + "MaterialRequestInVoucherAuto", data);
            };
            this.PurchaseEnquiryInVoucherAuto = function (data) {
                return $http.post(config.basePath + "PurchaseEnquiryInVoucherAuto", data);
            };
            this.PurchaseInvoiceInVoucherAuto = function (data) {
                return $http.post(config.basePath + "PurchaseInvoiceInVoucherAuto", data);
            };
            this.PurchaseOrderInVoucherAuto = function (data) {
                return $http.post(config.basePath + "PurchaseOrderInVoucherAuto", data);
            };
            this.PurchaseQuotationInVoucherAuto = function (data) {
                return $http.post(config.basePath + "PurchaseQuotationInVoucherAuto", data);
            };
            this.PurchaseRequestInVoucherAuto = function (data) {
                return $http.post(config.basePath + "PurchaseRequestInVoucherAuto", data);
            };
            this.PurchaseReturnInVoucherAuto = function (data) {
                return $http.post(config.basePath + "PurchaseReturnInVoucherAuto", data);
            };

            this.CreditNoteSRInVoucherAuto = function (data) {
                return $http.post(config.basePath + "CreditNoteSRInVoucherAuto", data);
            };
            this.DeliveryNote2InVoucherAuto = function (data) {
                return $http.post(config.basePath + "DeliveryNote2InVoucherAuto", data);
            };
            this.DeliveryNote3InVoucherAuto = function (data) {
                return $http.post(config.basePath + "DeliveryNote3InVoucherAuto", data);
            };
            this.DeliveryNote4InVoucherAuto = function (data) {
                return $http.post(config.basePath + "DeliveryNote4InVoucherAuto", data);
            };
            this.DeliveryNoteInVoucherAuto = function (data) {
                return $http.post(config.basePath + "DeliveryNoteInVoucherAuto", data);
            };
            this.DirSalesInvoiceInVoucherAuto = function (data) {
                return $http.post(config.basePath + "DirSalesInvoiceInVoucherAuto", data);
            };
            this.ExpSalesInvoiceInVoucherAuto = function (data) {
                return $http.post(config.basePath + "ExpSalesInvoiceInVoucherAuto", data);
            };
            this.IndSalesInvoiceInVoucherAuto = function (data) {
                return $http.post(config.basePath + "IndSalesInvoiceInVoucherAuto", data);
            };
            this.PackingListInVoucherAuto = function (data) {
                return $http.post(config.basePath + "PackingListInVoucherAuto", data);
            };
            this.ProSalesInvoiceInVoucherAuto = function (data) {
                return $http.post(config.basePath + "ProSalesInvoiceInVoucherAuto", data);
            };
            this.SalesEnquiry2InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesEnquiry2InVoucherAuto", data);
            };
            this.SalesEnquiry3InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesEnquiry3InVoucherAuto", data);
            };
            this.SalesEnquiry4InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesEnquiry4InVoucherAuto", data);
            };
            this.SalesEnquiryInVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesEnquiryInVoucherAuto", data);
            };
            this.SalesInvoice2InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesInvoice2InVoucherAuto", data);
            };
            this.SalesInvoice3InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesInvoice3InVoucherAuto", data);
            };
            this.SalesInvoice4InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesInvoice4InVoucherAuto", data);
            };
            this.SalesInvoiceInVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesInvoiceInVoucherAuto", data);
            };
            this.SalesOrder2InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesOrder2InVoucherAuto", data);
            };
            this.SalesOrder3InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesOrder3InVoucherAuto", data);
            };
            this.SalesOrder4InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesOrder4InVoucherAuto", data);
            };
            this.SalesOrderInVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesOrderInVoucherAuto", data);
            };
            this.SalesQuotation2InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesQuotation2InVoucherAuto", data);
            };
            this.SalesQuotation3InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesQuotation3InVoucherAuto", data);
            };
            this.SalesQuotation4InVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesQuotation4InVoucherAuto", data);
            };
            this.SalesQuotationInVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesQuotationInVoucherAuto", data);
            };
            this.SalesReturnInVoucherAuto = function (data) {
                return $http.post(config.basePath + "SalesReturnInVoucherAuto", data);
            };

            this.AddVehicleAllocation = function (data) {
                return $http.post(config.basePath + "AddVehicleAllocation", data);
            };
            this.VehicleAllocationInView = function (data) {
                return $http.post(config.basePath + "VehicleAllocationInView", data);
            };
            this.DeletVehicleAllocation = function (id) {
                return $http.get(config.basePath + "DeletVehicleAllocation/" + id);
            };
            this.GetVehicleCostCenters = function () {
                return $http.get(config.basePath + "GetVehicleCostCenters");
            };
            this.UpdateEmployeeStatus = function (id, sid) {
                return $http.get(config.basePath + "UpdateEmployeeStatus/" + id + "/" + sid);
            };
            this.EmployeeAppraisalsById = function (id) {
                return $http.get(config.basePath + "EmployeeAppraisalsById/" + id);
            };

            this.addEmployeeOpeningLoan = function (data) {
                return $http.post(config.basePath + "addEmployeeOpeningLoan", data);
            };
            this.EmployeeOpeningLoansInView = function (data) {
                return $http.post(config.basePath + "EmployeeOpeningLoansInView", data);
            };
            this.GetEmployeeOpeningLoan = function (id) {
                return $http.get(config.basePath + "GetEmployeeOpeningLoan/" + id);
            };
            this.DeleteEmployeeOpeningLoan = function (id) {
                return $http.get(config.basePath + "DeleteEmployeeOpeningLoan/" + id);
            };

            this.addEmployeeLoan = function (data) {
                return $http.post(config.basePath + "addEmployeeLoan", data);
            };

            this.EmployeeLoansInView = function (data) {
                return $http.post(config.basePath + "EmployeeLoansInView", data);
            };
            this.GetEmployeeLoan = function (id) {
                return $http.get(config.basePath + "GetEmployeeLoan/" + id);
            };
            this.DeleteEmployeeLoan = function (id) {
                return $http.get(config.basePath + "DeleteEmployeeLoan/" + id);
            };

            this.AddLoanType = function (data) {
                return $http.post(config.basePath + "AddLoanType", data);
            };
            this.LoanTypeInView = function (data) {
                return $http.post(config.basePath + "LoanTypeInView", data);
            };
            this.DeleteLoanType = function (id) {
                return $http.get(config.basePath + "DeleteLoanType/" + id);
            };
            this.LoanTypesInDropdown = function () {
                return $http.get(config.basePath + "LoanTypesInDropdown");
            };

            this.GetNextEmployeeOpeningLoanNo = function () {
                return $http.get(config.basePath + "GetNextEmployeeOpeningLoanNo");
            };
            this.GetNextEmployeeLoanNo = function () {
                return $http.get(config.basePath + "GetNextEmployeeLoanNo");
            };


            this.UploadFPVMaster = function (data) {
                return $http.post(config.basePath + "UploadFPVMaster", data);
            };
            this.UploadFRVMaster = function (data) {
                return $http.post(config.basePath + "UploadFRVMaster", data);
            };


            this.OpeningStockSummaryReport = function (data) {
                return $http.post(config.basePath + "OpeningStockSummaryReport", data);
            };
            this.OpeningStockDetailedReport = function (data) {
                return $http.post(config.basePath + "OpeningStockDetailedReport", data);
            };
            this.StockFOCSummaryReport = function (data) {
                return $http.post(config.basePath + "StockFOCSummaryReport", data);
            };
            this.StockFOCDetailedReport = function (data) {
                return $http.post(config.basePath + "StockFOCDetailedReport", data);
            };
            this.StockIssueSummaryReport = function (data) {
                return $http.post(config.basePath + "StockIssueSummaryReport", data);
            };
            this.StockIssueDetailedReport = function (data) {
                return $http.post(config.basePath + "StockIssueDetailedReport", data);
            };
            this.StockJVSummaryReport = function (data) {
                return $http.post(config.basePath + "StockJVSummaryReport", data);
            };
            this.StockJVDetailedReport = function (data) {
                return $http.post(config.basePath + "StockJVDetailedReport", data);
            };
            this.StockReciveSummaryReport = function (data) {
                return $http.post(config.basePath + "StockReciveSummaryReport", data);
            };
            this.StockReciveDetailedReport = function (data) {
                return $http.post(config.basePath + "StockReciveDetailedReport", data);
            };
            this.ReorderReport = function (data) {
                return $http.post(config.basePath + "ReorderReport", data);
            };


            this.DeletedCreditNoteSRs = function (data) {
                return $http.post(config.basePath + "DeletedCreditNoteSRs", data);
            };
            this.DeletedDeliveryNotes = function (data) {
                return $http.post(config.basePath + "DeletedDeliveryNotes", data);
            };
            this.DeletedDirSalesInvoices = function (data) {
                return $http.post(config.basePath + "DeletedDirSalesInvoices", data);
            };
            this.DeletedExpSalesInvoices = function (data) {
                return $http.post(config.basePath + "DeletedExpSalesInvoices", data);
            };
            this.DeletedIndSalesInvoices = function (data) {
                return $http.post(config.basePath + "DeletedIndSalesInvoices", data);
            };
            this.DeletedPackingLists = function (data) {
                return $http.post(config.basePath + "DeletedPackingLists", data);
            };
            this.DeletedProSalesInvoices = function (data) {
                return $http.post(config.basePath + "DeletedProSalesInvoices", data);
            };
            this.DeletedSalesEnquiries = function (data) {
                return $http.post(config.basePath + "DeletedSalesEnquiries", data);
            };
            this.DeletedSalesInvoices = function (data) {
                return $http.post(config.basePath + "DeletedSalesInvoices", data);
            };
            this.DeletedSalesOrders = function (data) {
                return $http.post(config.basePath + "DeletedSalesOrders", data);
            };
            this.DeletedSalesQuotations = function (data) {
                return $http.post(config.basePath + "DeletedSalesQuotations", data);
            };
            this.DeletedSalesReturns = function (data) {
                return $http.post(config.basePath + "DeletedSalesReturns", data);
            };

            this.DeletedDeliveryNote2s = function (data) {
                return $http.post(config.basePath + "DeletedDeliveryNote2s", data);
            };
            this.DeletedDeliveryNote3s = function (data) {
                return $http.post(config.basePath + "DeletedDeliveryNote3s", data);
            };
            this.DeletedDeliveryNote4s = function (data) {
                return $http.post(config.basePath + "DeletedDeliveryNote4s", data);
            };
            this.DeletedSalesEnquiry2s = function (data) {
                return $http.post(config.basePath + "DeletedSalesEnquiry2s", data);
            };
            this.DeletedSalesEnquiry3s = function (data) {
                return $http.post(config.basePath + "DeletedSalesEnquiry3s", data);
            };
            this.DeletedSalesEnquiry4s = function (data) {
                return $http.post(config.basePath + "DeletedSalesEnquiry4s", data);
            };
            this.DeletedSalesInvoice2s = function (data) {
                return $http.post(config.basePath + "DeletedSalesInvoice2s", data);
            };
            this.DeletedSalesInvoice3s = function (data) {
                return $http.post(config.basePath + "DeletedSalesInvoice3s", data);
            };
            this.DeletedSalesInvoice4s = function (data) {
                return $http.post(config.basePath + "DeletedSalesInvoice4s", data);
            };
            this.DeletedSalesOrder2s = function (data) {
                return $http.post(config.basePath + "DeletedSalesOrder2s", data);
            };
            this.DeletedSalesOrder3s = function (data) {
                return $http.post(config.basePath + "DeletedSalesOrder3s", data);
            };
            this.DeletedSalesOrder4s = function (data) {
                return $http.post(config.basePath + "DeletedSalesOrder4s", data);
            };
            this.DeletedSalesQuotation2s = function (data) {
                return $http.post(config.basePath + "DeletedSalesQuotation2s", data);
            };
            this.DeletedSalesQuotation3s = function (data) {
                return $http.post(config.basePath + "DeletedSalesQuotation3s", data);
            };
            this.DeletedSalesQuotation4s = function (data) {
                return $http.post(config.basePath + "DeletedSalesQuotation4s", data);
            };
            this.DeletedSalesQuotations = function (data) {
                return $http.post(config.basePath + "DeletedSalesQuotations", data);
            };
            this.DeletedSalesReturns = function (data) {
                return $http.post(config.basePath + "DeletedSalesReturns", data);
            };

            this.DeletedPurchaseReturns = function (data) {
                return $http.post(config.basePath + "DeletedPurchaseReturns", data);
            };
            this.DeletedPurchaseRequests = function (data) {
                return $http.post(config.basePath + "DeletedPurchaseRequests", data);
            };
            this.DeletedPurchaseQuotations = function (data) {
                return $http.post(config.basePath + "DeletedPurchaseQuotations", data);
            };
            this.DeletedPurchaseOrders = function (data) {
                return $http.post(config.basePath + "DeletedPurchaseOrders", data);
            };
            this.DeletedPurchaseInvoices = function (data) {
                return $http.post(config.basePath + "DeletedPurchaseInvoices", data);
            };
            this.DeletedPurchaseEnquiries = function (data) {
                return $http.post(config.basePath + "DeletedPurchaseEnquiries", data);
            };
            this.DeletedMaterialRequests = function (data) {
                return $http.post(config.basePath + "DeletedMaterialRequests", data);
            };
            this.DeletedIndPurchaseInvoices = function (data) {
                return $http.post(config.basePath + "DeletedIndPurchaseInvoices", data);
            };
            this.DeletedImpPurchaseInvoices = function (data) {
                return $http.post(config.basePath + "DeletedImpPurchaseInvoices", data);
            };
            this.DeletedGoodsReceiveds = function (data) {
                return $http.post(config.basePath + "DeletedGoodsReceiveds", data);
            };
            this.DeletedExpPurchaseInvoices = function (data) {
                return $http.post(config.basePath + "DeletedExpPurchaseInvoices", data);
            };
            this.DeletedDirPurchaseInvoices = function (data) {
                return $http.post(config.basePath + "DeletedDirPurchaseInvoices", data);
            };

            this.DeletedOpeningStocks = function (data) {
                return $http.post(config.basePath + "DeletedOpeningStocks", data);
            };
            this.DeletedStockFCOs = function (data) {
                return $http.post(config.basePath + "DeletedStockFCOs", data);
            };
            this.DeletedStockIssues = function (data) {
                return $http.post(config.basePath + "DeletedStockIssues", data);
            };
            this.DeletedStockJVs = function (data) {
                return $http.post(config.basePath + "DeletedStockJVs", data);
            };
            this.DeletedStockReceives = function (data) {
                return $http.post(config.basePath + "DeletedStockReceives", data);
            };

            this.DeletedChequePVs = function (data) {
                return $http.post(config.basePath + "DeletedChequePVs", data);
            };
            this.DeletedChequeRvs = function (data) {
                return $http.post(config.basePath + "DeletedChequeRvs", data);
            };
            this.DeletedCompanyExpenses = function (data) {
                return $http.post(config.basePath + "DeletedCompanyExpenses", data);
            };
            this.DeletedCpvs = function (data) {
                return $http.post(config.basePath + "DeletedCpvs", data);
            };
            this.DeletedCreditNotes = function (data) {
                return $http.post(config.basePath + "DeletedCreditNotes", data);
            };
            this.DeletedCrvs = function (data) {
                return $http.post(config.basePath + "DeletedCrvs", data);
            };
            this.DeletedDebitNotes = function (data) {
                return $http.post(config.basePath + "DeletedDebitNotes", data);
            };
            this.DeletedFpvs = function (data) {
                return $http.post(config.basePath + "DeletedFpvs", data);
            };
            this.DeletedFrvs = function (data) {
                return $http.post(config.basePath + "DeletedFrvs", data);
            };
            this.DeletedJournalVouchers = function (data) {
                return $http.post(config.basePath + "DeletedJournalVouchers", data);
            };
            this.DeletedOpeningBalances = function (data) {
                return $http.post(config.basePath + "DeletedOpeningBalances", data);
            };


            this.CreditNoteSRInPendingDash = function () {
                return $http.get(config.basePath + "CreditNoteSRInPendingDash");
            };
            this.DeliveryNote2InPendingDash = function () {
                return $http.get(config.basePath + "DeliveryNote2InPendingDash");
            };
            this.DeliveryNote3InPendingDash = function () {
                return $http.get(config.basePath + "DeliveryNote3InPendingDash");
            };
            this.DeliveryNote4InPendingDash = function () {
                return $http.get(config.basePath + "DeliveryNote4InPendingDash");
            };
            this.DeliveryNoteInPendingDash = function () {
                return $http.get(config.basePath + "DeliveryNoteInPendingDash");
            };
            this.DirSalesInvoiceInPendingDash = function () {
                return $http.get(config.basePath + "DirSalesInvoiceInPendingDash");
            };
            this.ExpSalesInvoiceInPendingDash = function () {
                return $http.get(config.basePath + "ExpSalesInvoiceInPendingDash");
            };
            this.IndSalesInvoiceInPendingDash = function () {
                return $http.get(config.basePath + "IndSalesInvoiceInPendingDash");
            };
            this.PackingListInPendingDash = function () {
                return $http.get(config.basePath + "PackingListInPendingDash");
            };
            this.ProSalesInvoiceInPendingDash = function () {
                return $http.get(config.basePath + "ProSalesInvoiceInPendingDash");
            };
            this.SalesEnquiry2InPendingDash = function () {
                return $http.get(config.basePath + "SalesEnquiry2InPendingDash");
            };
            this.SalesEnquiry3InPendingDash = function () {
                return $http.get(config.basePath + "SalesEnquiry3InPendingDash");
            };
            this.SalesEnquiry4InPendingDash = function () {
                return $http.get(config.basePath + "SalesEnquiry4InPendingDash");
            };
            this.SalesEnquiryInPendingDash = function () {
                return $http.get(config.basePath + "SalesEnquiryInPendingDash");
            };
            this.SalesInvoice2InPendingDash = function () {
                return $http.get(config.basePath + "SalesInvoice2InPendingDash");
            };
            this.SalesInvoice3InPendingDash = function () {
                return $http.get(config.basePath + "SalesInvoice3InPendingDash");
            };
            this.SalesInvoice4InPendingDash = function () {
                return $http.get(config.basePath + "SalesInvoice4InPendingDash");
            };
            this.SalesInvoiceInPendingDash = function () {
                return $http.get(config.basePath + "SalesInvoiceInPendingDash");
            };
            this.SalesOrder2InPendingDash = function () {
                return $http.get(config.basePath + "SalesOrder2InPendingDash");
            };
            this.SalesOrder3InPendingDash = function () {
                return $http.get(config.basePath + "SalesOrder3InPendingDash");
            };
            this.SalesOrder4InPendingDash = function () {
                return $http.get(config.basePath + "SalesOrder4InPendingDash");
            };
            this.SalesOrderInPendingDash = function () {
                return $http.get(config.basePath + "SalesOrderInPendingDash");
            };
            this.SalesQuotation2InPendingDash = function () {
                return $http.get(config.basePath + "SalesQuotation2InPendingDash");
            };
            this.SalesQuotation3InPendingDash = function () {
                return $http.get(config.basePath + "SalesQuotation3InPendingDash");
            };
            this.SalesQuotation4InPendingDash = function () {
                return $http.get(config.basePath + "SalesQuotation4InPendingDash");
            };
            this.SalesQuotationInPendingDash = function () {
                return $http.get(config.basePath + "SalesQuotationInPendingDash");
            };
            this.SalesReturnInPendingDash = function () {
                return $http.get(config.basePath + "SalesReturnInPendingDash");
            };

            this.DirPurchaseInvoiceInPendingDash = function () {
                return $http.get(config.basePath + "DirPurchaseInvoiceInPendingDash");
            };
            this.ExpPurchaseInvoiceInPendingDash = function () {
                return $http.get(config.basePath + "ExpPurchaseInvoiceInPendingDash");
            };
            this.GoodsReceivedInPendingDash = function () {
                return $http.get(config.basePath + "GoodsReceivedInPendingDash");
            };
            this.ImpPurchaseInvoiceInPendingDash = function () {
                return $http.get(config.basePath + "ImpPurchaseInvoiceInPendingDash");
            };
            this.IndPurchaseInvoiceInPendingDash = function () {
                return $http.get(config.basePath + "IndPurchaseInvoiceInPendingDash");
            };
            this.MaterialRequestInPendingDash = function () {
                return $http.get(config.basePath + "MaterialRequestInPendingDash");
            };
            this.PurchaseEnquiryInPendingDash = function () {
                return $http.get(config.basePath + "PurchaseEnquiryInPendingDash");
            };
            this.PurchaseInvoiceInPendingDash = function () {
                return $http.get(config.basePath + "PurchaseInvoiceInPendingDash");
            };
            this.PurchaseOrderInPendingDash = function () {
                return $http.get(config.basePath + "PurchaseOrderInPendingDash");
            };
            this.PurchaseQuotationInPendingDash = function () {
                return $http.get(config.basePath + "PurchaseQuotationInPendingDash");
            };
            this.PurchaseRequestInPendingDash = function () {
                return $http.get(config.basePath + "PurchaseRequestInPendingDash");
            };
            this.PurchaseReturnInPendingDash = function () {
                return $http.get(config.basePath + "PurchaseReturnInPendingDash");
            };

            this.GetCashBalanceDashboard = function () {
                return $http.get(config.basePath + "GetCashBalanceDashboard");
            };
            this.GetBankBalanceDashboard = function () {
                return $http.get(config.basePath + "GetBankBalanceDashboard");
            };
            this.GetTotalReceivableDashboard = function () {
                return $http.get(config.basePath + "GetTotalReceivableDashboard");
            };
            this.GetTotalPayableDashboard = function () {
                return $http.get(config.basePath + "GetTotalPayableDashboard");
            };
            this.GetTotalInventoryDashboard = function () {
                return $http.get(config.basePath + "GetTotalInventoryDashboard");
            };
            this.GetTotalInventoryDashboardMainGroup = function () {
                return $http.get(config.basePath + "GetTotalInventoryDashboardMainGroup");
            };
            this.GetDailySalesTableDashboard = function () {
                return $http.get(config.basePath + "GetDailySalesTableDashboard");
            };
            this.GetDailySalesTableDashboard2 = function () {
                return $http.get(config.basePath + "GetDailySalesTableDashboard2");
            };
            this.GetMonthlySalesTableDashboard = function () {
                return $http.get(config.basePath + "GetMonthlySalesTableDashboard");
            };
            this.GetMonthlySalesTableDashboard2 = function () {
                return $http.get(config.basePath + "GetMonthlySalesTableDashboard2");
            };
            this.TopMonthlyCustomers = function () {
                return $http.get(config.basePath + "TopMonthlyCustomers");
            };
            this.TopYearlyCustomers = function () {
                return $http.get(config.basePath + "TopYearlyCustomers");
            };
            this.TopProductTableQuarterDashboard = function () {
                return $http.get(config.basePath + "TopProductTableQuarterDashboard");
            };
            this.TopProductTableMonthlyDashboard = function () {
                return $http.get(config.basePath + "TopProductTableMonthlyDashboard");
            };

            this.GetDailyPurchaseTableDashboard = function () {
                return $http.get(config.basePath + "GetDailyPurchaseTableDashboard");
            };
            this.GetDailyPurchaseTableDashboard2 = function () {
                return $http.get(config.basePath + "GetDailyPurchaseTableDashboard2");
            };
            this.GetMonthlyPurchaseTableDashboard = function () {
                return $http.get(config.basePath + "GetMonthlyPurchaseTableDashboard");
            };
            this.GetMonthlyPurchaseTableDashboard2 = function () {
                return $http.get(config.basePath + "GetMonthlyPurchaseTableDashboard2");
            };
            this.TopMonthlySuppliers = function () {
                return $http.get(config.basePath + "TopMonthlySuppliers");
            };
            this.TopYearlySuppliers = function () {
                return $http.get(config.basePath + "TopYearlySuppliers");
            };
            this.TopProductTablePurchaseQuarterDashboard = function () {
                return $http.get(config.basePath + "TopProductTablePurchaseQuarterDashboard");
            };
            this.TopProductTablePurchaseMonthlyDashboard = function () {
                return $http.get(config.basePath + "TopProductTablePurchaseMonthlyDashboard");
            };


            this.ProductSerialNoView = function (data) {
                return $http.post(config.basePath + "ProductSerialNoView", data);
            };
            this.PurchaseQueueInView = function (data) {
                return $http.post(config.basePath + "PurchaseQueueInView", data);
            };
            this.GetPurchaseQueueDetails = function (id) {
                return $http.get(config.basePath + "GetPurchaseQueueDetails/" + id);
            };


            this.SaveProductAlternatives = function (data) {
                return $http.post(config.basePath + "SaveProductAlternatives", data);
            };
            this.ProductAlternativesInView = function (data) {
                return $http.post(config.basePath + "ProductAlternativesInView", data);
            };
            this.DeleteAlternativesById = function (id) {
                return $http.get(config.basePath + "DeleteAlternativesById/" + id);
            };
            this.ProductAlternativesById = function (id) {
                return $http.get(config.basePath + "ProductAlternativesById/" + id);
            };

            this.ResaveSalesInvoiceGL = function (id) {
                return $http.get(config.basePath + "ResaveSalesInvoiceGL/" + id);
            };
            this.ResaveSalesInvoiceSL = function (id) {
                return $http.get(config.basePath + "ResaveSalesInvoiceSL/" + id);
            };
            this.ResaveSalesInvoiceTCOST = function (id) {
                return $http.get(config.basePath + "ResaveSalesInvoiceTCOST/" + id);
            };

            this.ResaveAllProductSalesInvoiceGLFIFO = function (data) {
                return $http.post(config.basePath + "ResaveAllProductSalesInvoiceGLFIFO", data);
            };
            this.AddUserMenu = function (data) {
                return $http.post(config.basePath + "AddUserMenu", data);
            };
            this.UserMenusInKendoTree = function (id) {
                return $http.get(config.basePath + "UserMenusInKendoTree/" + id);
            };
            this.DeleteUserMenu = function (id) {
                return $http.get(config.basePath + "DeleteUserMenu/" + id);
            };
            this.GetUserSideMenu = function (id) {
                return $http.get(config.basePath + "GetUserSideMenu/" + id);
            };
            this.GetUserTopMenu = function (id) {
                return $http.get(config.basePath + "GetUserTopMenu/" + id);
            };
            this.GetUserMenuInSearch = function (id) {
                return $http.get(config.basePath + "GetUserMenuInSearch/" + id);
            };
            this.GetProductMultiPrice = function (id) {
                return $http.get(config.basePath + "GetProductMultiPrice/" + id);
            };
            this.ResetSalesInvoiceFIFOCost = function (id) {
                return $http.get(config.basePath + "ResetSalesInvoiceFIFOCost/" + id);
            };
            this.RestoreBillWiseSI = function (id) {
                return $http.get(config.basePath + "RestoreBillWiseSI/" + id);
            };
            this.ReconcileAllZeroCostFIFOSI = function () {
                return $http.get(config.basePath + "ReconcileAllZeroCostFIFOSI");
            };

            this.GetDailySalesTableDashboardByDate = function (data) {
                return $http.post(config.basePath + "GetDailySalesTableDashboardByDate", data);
            };

            this.GetDailySalesTableDashboard2ByDate = function (data) {
                return $http.post(config.basePath + "GetDailySalesTableDashboard2ByDate", data);
            };

            this.GetDailyPurchaseTableDashboardByDate = function (data) {
                return $http.post(config.basePath + "GetDailyPurchaseTableDashboardByDate", data);
            };

            this.GetDailyPurchaseTableDashboard2ByDate = function (data) {
                return $http.post(config.basePath + "GetDailyPurchaseTableDashboard2ByDate", data);
            };

            this.PrintTempGeneralLedger = function (data) {
                return $http.post(config.basePath + "PrintTempGeneralLedger", data);
            };
            this.PrintTempBillWiseOutstanding = function (data) {
                return $http.post(config.basePath + "PrintTempBillWiseOutstanding", data);
            };

            this.UploadSalesReturn = function (data) {
                return $http.post(config.basePath + "UploadSalesReturn", data);
            };
            this.UploadCashPayment = function (data) {
                return $http.post(config.basePath + "UploadCashPayment", data);
            };
            this.UploadCashReceipt = function (data) {
                return $http.post(config.basePath + "UploadCashReceipt", data);
            };
            this.ZeroCostSalesInvoices = function (data) {
                return $http.post(config.basePath + "ZeroCostSalesInvoices", data);
            };
            this.WarehouseStockValuation = function (data) {
                return $http.post(config.basePath + "WarehouseStockValuation", data);
            };


            this.PrintOpeningStockSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintOpeningStockSummaryReport", data);
            };
            this.PrintOpeningStockDetailedReport = function (data) {
                return $http.post(config.basePath + "PrintOpeningStockDetailedReport", data);
            };
            this.PrintStockFOCSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintStockFOCSummaryReport", data);
            };
            this.PrintStockFOCDetailedReport = function (data) {
                return $http.post(config.basePath + "PrintStockFOCDetailedReport", data);
            };
            this.PrintStockIssueSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintStockIssueSummaryReport", data);
            };
            this.PrintStockIssueDetailedReport = function (data) {
                return $http.post(config.basePath + "PrintStockIssueDetailedReport", data);
            };
            this.PrintStockJVSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintStockJVSummaryReport", data);
            };
            this.PrintStockJVDetailedReport = function (data) {
                return $http.post(config.basePath + "PrintStockJVDetailedReport", data);
            };
            this.PrintStockReciveSummaryReport = function (data) {
                return $http.post(config.basePath + "PrintStockReciveSummaryReport", data);
            };
            this.PrintStockReciveDetailedReport = function (data) {
                return $http.post(config.basePath + "PrintStockReciveDetailedReport", data);
            };

            this.AgingAnalysisSummaryReport = function (data) {
                return $http.post(config.basePath + "AgingAnalysisSummaryReport", data);
            };
            this.LinkReport = function (data) {
                return $http.post(config.basePath + "LinkReport", data);
            };
            this.ProductForecastingReport = function (data) {
                return $http.post(config.basePath + "ProductForecastingReport", data);
            };
            this.ProductQueryReport = function (data) {
                return $http.post(config.basePath + "ProductQueryReport", data);
            };
            this.GerWrongLedgerRecords = function () {
                return $http.get(config.basePath + "GerWrongLedgerRecords");
            };
            this.LedgerAccountBalances = function () {
                return $http.get(config.basePath + "LedgerAccountBalances");
            };
            this.PaysheetSummaryReport = function (data) {
                return $http.post(config.basePath + "PaysheetSummaryReport", data);
            };
            this.EmployeesInBulkPayroll = function (data) {
                return $http.post(config.basePath + "EmployeesInBulkPayroll", data);
            };
            this.AddBulkEmployeeSalary = function (data) {
                return $http.post(config.basePath + "AddBulkEmployeeSalary", data);
            };
            this.saveLinkedVouchersToSIBackend = function (data) {
                return $http.post(config.basePath + "saveLinkedVouchersToSIBackend", data);
            };


            this.ApproveOpeningStock = function (id) {
                return $http.get(config.basePath + "ApproveOpeningStock/" + id);
            };
            this.RejectOpeningStock = function (data) {
                return $http.post(config.basePath + "RejectOpeningStock", data);
            };
            this.ResubmitOpeningStock = function (id) {
                return $http.get(config.basePath + "ResubmitOpeningStock/" + id);
            };
            this.OpeningStockForApprovals = function (data) {
                return $http.post(config.basePath + "OpeningStockForApprovals", data);
            };

            this.ApproveStockFOC = function (id) {
                return $http.get(config.basePath + "ApproveStockFOC/" + id);
            };
            this.RejectStockFoc = function (data) {
                return $http.post(config.basePath + "RejectStockFoc", data);
            };
            this.ResubmitStockFOC = function (id) {
                return $http.get(config.basePath + "ResubmitStockFOC/" + id);
            };
            this.StockFOCForApprovals = function (data) {
                return $http.post(config.basePath + "StockFOCForApprovals", data);
            };

            this.ApproveStockIssue = function (id) {
                return $http.get(config.basePath + "ApproveStockIssue/" + id);
            };
            this.RejectStockIssue = function (data) {
                return $http.post(config.basePath + "RejectStockIssue", data);
            };
            this.ResubmitStockIssue = function (id) {
                return $http.get(config.basePath + "ResubmitStockIssue/" + id);
            };
            this.StockIssueForApprovals = function (data) {
                return $http.post(config.basePath + "StockIssueForApprovals", data);
            };

            this.ApproveStockJV = function (id) {
                return $http.get(config.basePath + "ApproveStockJV/" + id);
            };
            this.RejectStockJV = function (data) {
                return $http.post(config.basePath + "RejectStockJV", data);
            };
            this.ResubmitStockJV = function (id) {
                return $http.get(config.basePath + "ResubmitStockJV/" + id);
            };
            this.StockJVForApprovals = function (data) {
                return $http.post(config.basePath + "StockJVForApprovals", data);
            };

            this.ApproveStockRecive = function (id) {
                return $http.get(config.basePath + "ApproveStockRecive/" + id);
            };
            this.RejectStockRecive = function (data) {
                return $http.post(config.basePath + "RejectStockRecive", data);
            };
            this.ResubmitStockRecive = function (id) {
                return $http.get(config.basePath + "ResubmitStockRecive/" + id);
            };
            this.StockReceiveForApprovals = function (data) {
                return $http.post(config.basePath + "StockReceiveForApprovals", data);
            };

            this.ApproveChequePV = function (id) {
                return $http.get(config.basePath + "ApproveChequePV/" + id);
            };
            this.RejectChequePV = function (data) {
                return $http.post(config.basePath + "RejectChequePV", data);
            };
            this.ResubmitChequePV = function (id) {
                return $http.get(config.basePath + "ResubmitChequePV/" + id);
            };
            this.ChequePVForApprovals = function (data) {
                return $http.post(config.basePath + "ChequePVForApprovals", data);
            };

            this.ApproveChequeRV = function (id) {
                return $http.get(config.basePath + "ApproveChequeRV/" + id);
            };
            this.RejectChequeRV = function (data) {
                return $http.post(config.basePath + "RejectChequeRV", data);
            };
            this.ResubmitChequeRV = function (id) {
                return $http.get(config.basePath + "ResubmitChequeRV/" + id);
            };
            this.ChequeRVForApprovals = function (data) {
                return $http.post(config.basePath + "ChequeRVForApprovals", data);
            };

            this.ApproveCompanyExpense = function (id) {
                return $http.get(config.basePath + "ApproveCompanyExpense/" + id);
            };
            this.RejectCompanyExpense = function (data) {
                return $http.post(config.basePath + "RejectCompanyExpense", data);
            };
            this.ResubmitCompanyExpense = function (id) {
                return $http.get(config.basePath + "ResubmitCompanyExpense/" + id);
            };
            this.CompanyExpenseForApprovals = function (data) {
                return $http.post(config.basePath + "CompanyExpenseForApprovals", data);
            };

            this.ApproveCPV = function (id) {
                return $http.get(config.basePath + "ApproveCPV/" + id);
            };
            this.RejectCPV = function (data) {
                return $http.post(config.basePath + "RejectCPV", data);
            };
            this.ResubmitCPV = function (id) {
                return $http.get(config.basePath + "ResubmitCPV/" + id);
            };
            this.CPVForApprovals = function (data) {
                return $http.post(config.basePath + "CPVForApprovals", data);
            };

            this.ApproveCRV = function (id) {
                return $http.get(config.basePath + "ApproveCRV/" + id);
            };
            this.RejectCRV = function (data) {
                return $http.post(config.basePath + "RejectCRV", data);
            };
            this.ResubmitCRV = function (id) {
                return $http.get(config.basePath + "ResubmitCRV/" + id);
            };
            this.CRVForApprovals = function (data) {
                return $http.post(config.basePath + "CRVForApprovals", data);
            };

            this.ApproveFRV = function (id) {
                return $http.get(config.basePath + "ApproveFRV/" + id);
            };
            this.RejectFRV = function (data) {
                return $http.post(config.basePath + "RejectFRV", data);
            };
            this.ResubmitFRV = function (id) {
                return $http.get(config.basePath + "ResubmitFRV/" + id);
            };
            this.FRVForApprovals = function (data) {
                return $http.post(config.basePath + "FRVForApprovals", data);
            };

            this.ApproveFPV = function (id) {
                return $http.get(config.basePath + "ApproveFPV/" + id);
            };
            this.RejectFPV = function (data) {
                return $http.post(config.basePath + "RejectFPV", data);
            };
            this.ResubmitFPV = function (id) {
                return $http.get(config.basePath + "ResubmitFPV/" + id);
            };
            this.FPVForApprovals = function (data) {
                return $http.post(config.basePath + "FPVForApprovals", data);
            };

            this.ApproveCreditNote = function (id) {
                return $http.get(config.basePath + "ApproveCreditNote/" + id);
            };
            this.RejectCreditNote = function (data) {
                return $http.post(config.basePath + "RejectCreditNote", data);
            };
            this.ResubmitCreditNote = function (id) {
                return $http.get(config.basePath + "ResubmitCreditNote/" + id);
            };
            this.CreditNoteForApprovals = function (data) {
                return $http.post(config.basePath + "CreditNoteForApprovals", data);
            };

            this.ApproveDebitNote = function (id) {
                return $http.get(config.basePath + "ApproveDebitNote/" + id);
            };
            this.RejectDebitNote = function (data) {
                return $http.post(config.basePath + "RejectDebitNote", data);
            };
            this.ResubmitDebitNote = function (id) {
                return $http.get(config.basePath + "ResubmitDebitNote/" + id);
            };
            this.DebitNoteForApprovals = function (data) {
                return $http.post(config.basePath + "DebitNoteForApprovals", data);
            };

            this.ApproveJV = function (id) {
                return $http.get(config.basePath + "ApproveJV/" + id);
            };
            this.RejectJV = function (data) {
                return $http.post(config.basePath + "RejectJV", data);
            };
            this.ResubmitJV = function (id) {
                return $http.get(config.basePath + "ResubmitJV/" + id);
            };
            this.JVMasterForApprovals = function (data) {
                return $http.post(config.basePath + "JVMasterForApprovals", data);
            };

            this.ApproveOpeningBalance = function (id) {
                return $http.get(config.basePath + "ApproveOpeningBalance/" + id);
            };
            this.RejectOpeningBalance = function (data) {
                return $http.post(config.basePath + "RejectOpeningBalance", data);
            };
            this.ResubmitOpeningBalance = function (id) {
                return $http.get(config.basePath + "ResubmitOpeningBalance/" + id);
            };
            this.MakeAccountActive = function (id) {
                return $http.get(config.basePath + "MakeAccountActive/" + id);
            };
            this.ChangeAccountParent = function (id, pid) {
                return $http.get(config.basePath + "ChangeAccountParent/" + id + "/" + pid);
            };
            this.OpeningBalanceForApprovals = function (data) {
                return $http.post(config.basePath + "OpeningBalanceForApprovals", data);
            };


            this.GetDeletedAccounts = function () {
                return $http.get(config.basePath + "GetDeletedAccounts");
            };

            this.GetSameParentAccounts = function () {
                return $http.get(config.basePath + "GetSameParentAccounts");
            };


            this.GetBankAccountList = function () {
                return $http.get(config.basePath + "GetBankAccountList");
            };



            // Purchase Invoices
            this.DirPurchaseInvoiceDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "DirPurchaseInvoiceDynamicDetailReport", data);
            };
            this.ExpPurchaseInvoiceRequestDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "ExpPurchaseInvoiceRequestDynamicDetailReport", data);
            };
            this.ImpPurchaseInvoiceDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "ImpPurchaseInvoiceDynamicDetailReport", data);
            };
            this.IndPurchaseInvoiceDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "IndPurchaseInvoiceDynamicDetailReport", data);
            };
            this.PurchaseInvoiceDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "PurchaseInvoiceDynamicDetailReport", data);
            };

            // Goods Received
            this.GoodsReceivedDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "GoodsReceivedDynamicDetailReport", data);
            };

            // materil request
            this.MaterialRequestDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "MaterialRequestDynamicDetailReport", data);
            };

            // Purchase Enquiry
            this.PurchaseEnquiryDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "PurchaseEnquiryDynamicDetailReport", data);
            };

            // Purchase Order
            this.PurchaseOrderDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "PurchaseOrderDynamicDetailReport", data);
            };

            // Purchase Quotation
            this.PurchaseQuotationDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "PurchaseQuotationDynamicDetailReport", data);
            };

            // Purchase Request
            this.PurchaseRequestDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "PurchaseRequestDynamicDetailReport", data);
            };

            // Purchase Return
            this.PurchaseReturnDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "PurchaseReturnDynamicDetailReport", data);
            };


            // Credit notes

            this.CreditNoteSRDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "CreditNoteSRDynamicDetailReport", data);
            };


            // Delivery Notes
            this.DeliveryNote3DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "DeliveryNote3DynamicDetailReport", data);
            };
            this.DeliveryNote4DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "DeliveryNote4DynamicDetailReport", data);
            };
            this.DeliveryNoteDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "DeliveryNoteDynamicDetailReport", data);
            };

            this.DeliveryNote2DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "DeliveryNote2DynamicDetailReport", data);
            };


            // Sales Invoices
            this.DirSalesInvoiceDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "DirSalesInvoiceDynamicDetailReport", data);
            };
            this.ExpSalesInvoiceDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "ExpSalesInvoiceDynamicDetailReport", data);
            };
            this.IndSalesInvoiceDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "IndSalesInvoiceDynamicDetailReport", data);
            };
            this.ProSalesInvoiceDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "ProSalesInvoiceDynamicDetailReport", data);
            };
            this.SalesInvoice2DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesInvoice2DynamicDetailReport", data);
            };
            this.SalesInvoice3DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesInvoice3DynamicDetailReport", data);
            };
            this.SalesInvoice4DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesInvoice4DynamicDetailReport", data);
            };
            this.SalesInvoiceDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesInvoiceDynamicDetailReport", data);
            };

            // Packing List
            this.PackingListDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "PackingListDynamicDetailReport", data);
            };

            // Sales Enquiry
            this.SalesEnquiry2DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiry2DynamicDetailReport", data);
            };
            this.SalesEnquiry3DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiry3DynamicDetailReport", data);
            };
            this.SalesEnquiry4DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiry4DynamicDetailReport", data);
            };
            this.SalesEnquiryDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesEnquiryDynamicDetailReport", data);
            };

            // Sales Orders
            this.SalesOrder2DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesOrder2DynamicDetailReport", data);
            };
            this.SalesOrder3DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesOrder3DynamicDetailReport", data);
            };
            this.SalesOrder4DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesOrder4DynamicDetailReport", data);
            };
            this.SalesOrderDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesOrderDynamicDetailReport", data);
            };

            // Sales Quotations
            this.SalesQuotation2DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesQuotation2DynamicDetailReport", data);
            };
            this.SalesQuotation3DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesQuotation3DynamicDetailReport", data);
            };
            this.SalesQuotation4DynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesQuotation4DynamicDetailReport", data);
            };
            this.SalesQuotationDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesQuotationDynamicDetailReport", data);
            };

            // Sales Return
            this.SalesReturnDynamicDetailReport = function (data) {
                return $http.post(config.basePath + "SalesReturnDynamicDetailReport", data);
            };


            // bulk print

            this.PrintBulkSalesInvoice = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesInvoice", data);
            };

            this.PrintBulkCreditNoteSR = function (data) {
                return $http.post(config.basePath + "PrintBulkCreditNoteSR", data);
            };

            this.PrintBulkDeliveryNote2 = function (data) {
                return $http.post(config.basePath + "PrintBulkDeliveryNote2", data);
            };

            this.PrintBulkDeliveryNote3 = function (data) {
                return $http.post(config.basePath + "PrintBulkDeliveryNote3", data);
            };

            this.PrintBulkDeliveryNote4 = function (data) {
                return $http.post(config.basePath + "PrintBulkDeliveryNote4", data);
            };

            this.PrintBulkDeliveryNote = function (data) {
                return $http.post(config.basePath + "PrintBulkDeliveryNote", data);
            };

            this.PrintBulkDirSalesInvoice = function (data) {
                return $http.post(config.basePath + "PrintBulkDirSalesInvoice", data);
            };

            this.PrintBulkExpSalesInvoice = function (data) {
                return $http.post(config.basePath + "PrintBulkExpSalesInvoice", data);
            };

            this.PrintBulkIndSalesInvoice = function (data) {
                return $http.post(config.basePath + "PrintBulkIndSalesInvoice", data);
            };

            this.PrintBulkPackingList = function (data) {
                return $http.post(config.basePath + "PrintBulkPackingList", data);
            };

            this.PrintBulkProSalesInvoice = function (data) {
                return $http.post(config.basePath + "PrintBulkProSalesInvoice", data);
            };

            this.PrintBulkSalesEnquiry2 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesEnquiry2", data);
            };

            this.PrintBulkSalesEnquiry3 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesEnquiry3", data);
            };

            this.PrintBulkSalesEnquiry4 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesEnquiry4", data);
            };

            this.PrintBulkSalesEnquiry = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesEnquiry", data);
            };

            this.PrintBulkSalesInvoice2 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesInvoice2", data);
            };

            this.PrintBulkSalesInvoice3 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesInvoice3", data);
            };

            this.PrintBulkSalesInvoice4 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesInvoice4", data);
            };

            this.PrintBulkSalesOrder2 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesOrder2", data);
            };

            this.PrintBulkSalesOrder3 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesOrder3", data);
            };

            this.PrintBulkSalesOrder4 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesOrder4", data);
            };

            this.PrintBulkSalesOrder = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesOrder", data);
            };

            this.PrintBulkSalesQuotation2 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesQuotation2", data);
            };

            this.PrintBulkSalesQuotation3 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesQuotation3", data);
            };

            this.PrintBulkSalesQuotation4 = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesQuotation4", data);
            };

            this.PrintBulkSalesQuotation = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesQuotation", data);
            };

            this.PrintBulkSalesReturn = function (data) {
                return $http.post(config.basePath + "PrintBulkSalesReturn", data);
            };

            // --- Purchase side ---
            this.PrintBulkDirPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "PrintBulkDirPurchaseInvoice", data);
            };

            this.PrintBulkExpPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "PrintBulkExpPurchaseInvoice", data);
            };

            this.PrintBulkGoodsReceived = function (data) {
                return $http.post(config.basePath + "PrintBulkGoodsReceived", data);
            };

            this.PrintBulkImpPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "PrintBulkImpPurchaseInvoice", data);
            };

            this.PrintBulkIndPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "PrintBulkIndPurchaseInvoice", data);
            };

            this.PrintBulkMaterialRequest = function (data) {
                return $http.post(config.basePath + "PrintBulkMaterialRequest", data);
            };

            this.PrintBulkPurchaseEnquiry = function (data) {
                return $http.post(config.basePath + "PrintBulkPurchaseEnquiry", data);
            };

            this.PrintBulkPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "PrintBulkPurchaseInvoice", data);
            };

            this.PrintBulkPurchaseOrder = function (data) {
                return $http.post(config.basePath + "PrintBulkPurchaseOrder", data);
            };

            this.PrintBulkPurchaseQuotation = function (data) {
                return $http.post(config.basePath + "PrintBulkPurchaseQuotation", data);
            };

            this.PrintBulkPurchaseRequest = function (data) {
                return $http.post(config.basePath + "PrintBulkPurchaseRequest", data);
            };

            this.PrintBulkPurchaseReturn = function (data) {
                return $http.post(config.basePath + "PrintBulkPurchaseReturn", data);
            };

            this.UploadDirSalesInvoice = function (data) {
                return $http.post(config.basePath + "UploadDirSalesInvoice", data);
            };

            this.UploadDirPurchaseInvoice = function (data) {
                return $http.post(config.basePath + "UploadDirPurchaseInvoice", data);
            };

            this.WarehousesInDropdownByLevel = function (id) {
                return $http.get(config.basePath + "WarehousesInDropdownByLevel/" + id);
            };

            this.WarehousesInDropdownByParent = function (id) {
                return $http.get(config.basePath + "WarehousesInDropdownByParent/" + id);
            };

            this.WarehousesInDropdownByWId = function (id) {
                return $http.get(config.basePath + "WarehousesInDropdownByWId/" + id);
            };

            this.WarehousesInKendoTree = function () {
                return $http.get(config.basePath + "WarehousesInKendoTree");
            };
            this.GetProductWiseAging = function (data) {
                return $http.post(config.basePath + "GetProductWiseAging", data);
            };


        }]);
